import { useLicense } from '../../hooks/useLicense';
import { LicenseGatedButton } from '../../components/LicenseBlock';
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  ArrowLeft, Target, Clock, AlertTriangle, Server, Shield, Activity, Trash2,
  ThumbsUp, ThumbsDown, MessageSquare, Image, ZoomIn, ZoomOut, X, Download,
  RefreshCcw, Eye, EyeOff, ChevronDown, ChevronUp, Play, Pause, CheckCircle, XCircle,
  TrendingUp, TrendingDown, Minus, Info, ExternalLink, Copy, Bug, Lock,
  Wifi, Database, Terminal, FileText, BarChart3, PieChart, Brain, Sparkles,
  FileCheck, Send, BookOpen, Camera, Calendar, CalendarOff, Repeat, Save, MapPin,
  ArrowUpDown, List, ListFilter, Monitor, Smartphone, Router, HardDrive, Settings,
  Globe, ArrowUp, ArrowDown, ArrowRight, Cloud
} from 'lucide-react';
import { scans as scansApi } from '../../api/client';
import ScanTimeline from '../../components/ScanTimeline';
import AttackTimeline from '../../components/AttackTimeline';
import VulnerabilitySlider from '../../components/VulnerabilitySlider';
import AIStorytellingWindow from '../../components/AIStorytellingWindow';
import RadarScanner from '../../components/RadarScanner';
import AssetCartography from '../../components/AssetCartography';
import DomainCartography from '../../components/DomainCartography';
import CyberScorePanel from '../../components/CyberScorePanel';
import ToolOutputsPanel from '../../components/ToolOutputsPanel';
import SwaggerSpyResults from '../../components/SwaggerSpyResults';
import { useI18n } from '../../i18n';
import MarkdownRenderer from '../../components/common/MarkdownRenderer';
import AICommandGenerator from '../../components/AICommandGenerator';
import OSINTIntelPanel from '../../components/OSINTIntelPanel';

// OS Icon Components
const WindowsIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M0 3.449L9.75 2.1v9.451H0m10.949-9.602L24 0v11.4H10.949M0 12.6h9.75v9.451L0 20.699M10.949 12.6H24V24l-12.9-1.801"/>
  </svg>
);

const LinuxIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.504 0c-.155 0-.315.008-.48.021-4.226.333-3.105 4.807-3.17 6.298-.076 1.092-.3 1.953-1.05 3.02-.885 1.051-2.127 2.75-2.716 4.521-.278.832-.41 1.684-.287 2.489a.424.424 0 00-.11.135c-.26.268-.45.6-.663.839-.199.199-.485.267-.797.4-.313.136-.658.269-.864.68-.09.189-.136.394-.132.602 0 .199.027.4.055.536.058.399.116.728.04.97-.249.68-.28 1.145-.106 1.484.174.334.535.47.94.601.81.2 1.91.135 2.774.6.926.466 1.866.67 2.616.47.526-.116.97-.464 1.208-.946.587-.003 1.23-.269 2.26-.334.699-.058 1.574.267 2.577.2.025.134.063.198.114.333l.003.003c.391.778 1.113 1.132 1.884 1.071.771-.06 1.592-.536 2.257-1.306.631-.765 1.683-1.084 2.378-1.503.348-.199.629-.469.649-.853.023-.4-.2-.811-.714-1.376v-.097l-.003-.003c-.17-.2-.25-.535-.338-.926-.085-.401-.182-.786-.492-1.046h-.003c-.059-.054-.123-.067-.188-.135a.357.357 0 00-.19-.064c.431-1.278.264-2.55-.173-3.694-.533-1.41-1.465-2.638-2.175-3.483-.796-1.005-1.576-1.957-1.56-3.368.026-2.152.236-6.133-3.544-6.139zm.529 3.405h.013c.213 0 .396.062.584.198.19.135.33.332.438.533.105.259.158.459.166.724 0-.02.006-.04.006-.06v.105a.086.086 0 01-.004-.021l-.004-.024a1.807 1.807 0 01-.15.706.953.953 0 01-.213.335.71.71 0 00-.088-.042c-.104-.045-.198-.064-.284-.133a1.312 1.312 0 00-.22-.066c.05-.06.146-.133.183-.198.053-.128.082-.264.088-.402v-.02a1.21 1.21 0 00-.061-.4c-.045-.134-.101-.2-.183-.333-.084-.066-.167-.132-.267-.132h-.016c-.093 0-.176.03-.262.132a.8.8 0 00-.205.334 1.18 1.18 0 00-.09.4v.019c.002.089.008.179.02.267-.193-.067-.438-.135-.607-.202a1.635 1.635 0 01-.018-.2v-.02a1.772 1.772 0 01.15-.768c.082-.22.232-.406.43-.533a.985.985 0 01.594-.2zm-2.962.059h.036c.142 0 .27.048.399.135.146.129.264.288.344.465.09.199.14.4.153.667v.004c.007.134.006.2-.002.266v.08c-.03.007-.056.018-.083.024-.152.055-.274.135-.393.2.012-.09.013-.18.003-.267v-.015c-.012-.133-.04-.2-.082-.333a.613.613 0 00-.166-.267.248.248 0 00-.183-.064h-.021c-.071.006-.13.04-.186.132a.552.552 0 00-.12.27.944.944 0 00-.023.33v.015c.012.135.037.2.08.334.046.134.098.2.166.268.01.009.02.018.034.024-.07.057-.117.07-.176.136a.304.304 0 01-.131.068 2.62 2.62 0 01-.275-.402 1.772 1.772 0 01-.155-.667 1.759 1.759 0 01.08-.668 1.43 1.43 0 01.283-.535c.128-.133.26-.2.418-.2zm1.37 1.706c.332 0 .733.065 1.216.399.293.2.523.269 1.052.468h.003c.255.136.405.266.478.399v-.131a.571.571 0 01.016.47c-.123.31-.516.643-1.063.842v.002c-.268.135-.501.333-.775.465-.276.135-.588.292-1.012.267a1.139 1.139 0 01-.448-.067 3.566 3.566 0 01-.322-.198c-.195-.135-.363-.332-.612-.465v-.005h-.005c-.4-.246-.616-.512-.686-.71-.07-.268-.005-.47.193-.6.224-.135.38-.271.483-.336.104-.074.143-.102.176-.131h.002v-.003c.169-.202.436-.47.839-.601.139-.036.294-.065.466-.065zm2.8 2.142c.358 1.417 1.196 3.475 1.735 4.473.286.534.855 1.659 1.102 3.024.156-.005.33.018.513.064.646-1.671-.546-3.467-1.089-3.966-.22-.2-.232-.335-.123-.335.59.534 1.365 1.572 1.646 2.757.13.535.16 1.104.021 1.67.067.028.135.06.205.067 1.032.534 1.413.938 1.23 1.537v-.002c-.06-.135-.12-.2-.184-.268h-.004c-.048-.07-.105-.134-.2-.202.205.532.227 1.066.133 1.533-.15.832-.582 1.472-1.006 1.875-.238.27-.4.465-.676.602-.28.135-.598.2-1.016.068-.328-.101-.623-.299-.85-.532-.257-.268-.378-.6-.505-.932-.063-.171-.098-.268-.078-.399.12-.135.267-.132.377-.132.075 0 .137.004.185.01.043-.066.08-.132.126-.2a.555.555 0 00.095-.2c-.06-.028-.133-.064-.195-.132a.557.557 0 01-.143-.267c-.064-.268-.07-.6.083-.867.07-.135.132-.201.225-.266.094-.066.197-.135.33-.2a1.327 1.327 0 00-.3-.082c-.163-.028-.323-.05-.48-.128l-.001-.002a.846.846 0 01-.167-.1.621.621 0 01-.265-.398c-.027-.165-.018-.268.008-.4.096-.406.296-.744.546-.99.17-.165.354-.267.538-.333v-.013c-.017-.151-.053-.266-.12-.4a1.35 1.35 0 00-.258-.367c-.263-.332-.573-.601-.745-.8a.566.566 0 01-.115-.2c-.022-.067-.032-.132-.03-.133-.003.003-.009.136-.009.2 0 .065.003.132.009.2a.759.759 0 00.1.334c-.057.028-.117.064-.167.133a.816.816 0 00-.1.2.721.721 0 00-.05.267c0 .067.01.132.027.2.03.132.066.2.105.267a.893.893 0 00.12.183c-.053.028-.098.064-.14.1-.057.057-.107.1-.147.153a.77.77 0 00-.093.2c-.037.133-.037.267 0 .4.036.134.096.2.157.268.061.066.13.133.21.2a.96.96 0 00.268.132c-.17.066-.333.133-.495.266-.197.165-.33.4-.406.667-.07.268-.07.535-.036.797l.005.027c-.095.066-.155.133-.203.199a.685.685 0 00-.101.266.767.767 0 00-.01.267c.009.066.025.132.046.2h-.001c-.028 0-.06.005-.091.006h-.022a.665.665 0 01-.333-.066 1.12 1.12 0 01-.267-.2 3.632 3.632 0 01-.533-.598c-.265-.4-.47-.867-.536-1.4a3.553 3.553 0 01.134-1.334c.136-.466.376-.862.672-1.199.143-.17.303-.315.48-.44.144-.1.3-.187.464-.258-.3-.9-.436-1.867-.436-2.799 0-1.066.201-2.066.568-2.932-.174-.066-.32-.132-.467-.199-.19-.068-.396-.135-.596-.2l-.005.002h.002z"/>
  </svg>
);

const AppleIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/>
  </svg>
);

const AndroidIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.523 15.34a.558.558 0 00-.554.56v4.1a.558.558 0 001.112 0v-4.1a.558.558 0 00-.558-.56zm-11.046 0a.558.558 0 00-.554.56v4.1a.558.558 0 001.112 0v-4.1a.558.558 0 00-.558-.56zm8.626-10.24l.941-1.653a.187.187 0 00-.074-.25.188.188 0 00-.253.07l-.955 1.677c-.753-.338-1.597-.53-2.491-.53-.894 0-1.738.192-2.491.53L8.826 3.267a.188.188 0 00-.327.18l.941 1.653c-1.694.907-2.84 2.548-2.84 4.413h10.8c0-1.865-1.146-3.506-2.84-4.413zm-4.87 2.393a.558.558 0 110-1.116.558.558 0 010 1.116zm4.334 0a.558.558 0 110-1.116.558.558 0 010 1.116zM5.6 10.58h12.8v8.8c0 .75-.61 1.36-1.36 1.36h-.8v2.46c0 .43-.35.8-.8.8s-.8-.37-.8-.8v-2.46H9.36v2.46c0 .43-.35.8-.8.8s-.8-.37-.8-.8v-2.46h-.8c-.75 0-1.36-.61-1.36-1.36v-8.8z"/>
  </svg>
);

const FreeBSDIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M22.088 4.424c-.262-1.315-1.107-2.156-2.42-2.418C18.127 1.697 16.307 1.5 12 1.5S5.873 1.697 4.332 2.006c-1.313.262-2.158 1.103-2.42 2.418C1.603 5.965 1.406 7.785 1.406 12.09s.197 6.127.506 7.668c.262 1.315 1.107 2.156 2.42 2.418 1.541.309 3.361.506 7.668.506s6.127-.197 7.668-.506c1.313-.262 2.158-1.103 2.42-2.418.309-1.541.506-3.361.506-7.668s-.197-6.125-.506-7.666zM12 19.5c-4.142 0-7.5-3.358-7.5-7.5S7.858 4.5 12 4.5s7.5 3.358 7.5 7.5-3.358 7.5-7.5 7.5z"/>
  </svg>
);

const NetworkIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="16" y="16" width="6" height="6" rx="1"/>
    <rect x="2" y="16" width="6" height="6" rx="1"/>
    <rect x="9" y="2" width="6" height="6" rx="1"/>
    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"/>
    <path d="M12 12V8"/>
  </svg>
);

const ProxmoxIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
  </svg>
);

const SwitchIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="6" width="20" height="12" rx="2"/>
    <circle cx="6" cy="12" r="1.5" fill="currentColor"/>
    <circle cx="10" cy="12" r="1.5" fill="currentColor"/>
    <circle cx="14" cy="12" r="1.5" fill="currentColor"/>
    <circle cx="18" cy="12" r="1.5" fill="currentColor"/>
  </svg>
);

const FirewallIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2s8 4 8 10v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-5C4 6 12 2 12 2z"/>
    <path d="M8 12h8M8 16h8"/>
  </svg>
);

const AccessPointIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12.55a11 11 0 0 1 14.08 0"/>
    <path d="M1.42 9a16 16 0 0 1 21.16 0"/>
    <path d="M8.53 16.11a6 6 0 0 1 6.95 0"/>
    <circle cx="12" cy="20" r="1" fill="currentColor"/>
  </svg>
);

// Helper function to get OS icon based on os_name
const getOSIcon = (osName) => {
  if (!osName) return { icon: Terminal, color: 'text-gray-400', name: 'Unknown' };

  const osLower = osName.toLowerCase();

  // Windows detection
  if (osLower.includes('windows') || osLower.includes('win32') || osLower.includes('win64') || osLower.includes('microsoft')) {
    return { icon: WindowsIcon, color: 'text-blue-400', name: 'Windows' };
  }

  // macOS / Apple detection
  if (osLower.includes('mac') || osLower.includes('darwin') || osLower.includes('apple') || osLower.includes('ios') || osLower.includes('osx')) {
    return { icon: AppleIcon, color: 'text-gray-300', name: 'macOS' };
  }

  // Android detection
  if (osLower.includes('android')) {
    return { icon: AndroidIcon, color: 'text-green-400', name: 'Android' };
  }

  // Linux distributions
  if (osLower.includes('linux') || osLower.includes('ubuntu') || osLower.includes('debian') ||
      osLower.includes('centos') || osLower.includes('redhat') || osLower.includes('fedora') ||
      osLower.includes('kali') || osLower.includes('arch') || osLower.includes('mint') ||
      osLower.includes('suse') || osLower.includes('gentoo') || osLower.includes('manjaro')) {
    return { icon: LinuxIcon, color: 'text-yellow-400', name: 'Linux' };
  }

  // BSD variants
  if (osLower.includes('freebsd') || osLower.includes('openbsd') || osLower.includes('netbsd') || osLower.includes('bsd')) {
    return { icon: FreeBSDIcon, color: 'text-red-400', name: 'BSD' };
  }

  // Unix
  if (osLower.includes('unix') || osLower.includes('solaris') || osLower.includes('aix') || osLower.includes('hp-ux')) {
    return { icon: Terminal, color: 'text-purple-400', name: 'Unix' };
  }

  // Proxmox - specific detection before general hypervisor
  if (osLower.includes('proxmox') || osLower.includes('pve')) {
    return { icon: ProxmoxIcon, color: 'text-orange-500', name: 'Proxmox' };
  }

  // VMware / Hypervisor
  if (osLower.includes('vmware') || osLower.includes('esxi') || osLower.includes('hypervisor') ||
      osLower.includes('hyper-v') || osLower.includes('xen') || osLower.includes('kvm')) {
    return { icon: Server, color: 'text-teal-400', name: 'Hypervisor' };
  }

  // Firewalls
  if (osLower.includes('fortinet') || osLower.includes('fortigate') || osLower.includes('palo alto') ||
      osLower.includes('pfsense') || osLower.includes('opnsense') || osLower.includes('sophos') ||
      osLower.includes('watchguard') || osLower.includes('checkpoint') || osLower.includes('firewall')) {
    return { icon: FirewallIcon, color: 'text-red-500', name: 'Firewall' };
  }

  // Routers
  if (osLower.includes('cisco') || osLower.includes('juniper') || osLower.includes('mikrotik') ||
      osLower.includes('router') || osLower.includes('vyos') || osLower.includes('openwrt') ||
      osLower.includes('routeros')) {
    return { icon: Router, color: 'text-cyan-400', name: 'Router' };
  }

  // Switches
  if (osLower.includes('switch') || osLower.includes('aruba') || osLower.includes('procurve') ||
      osLower.includes('catalyst') || osLower.includes('nexus')) {
    return { icon: SwitchIcon, color: 'text-blue-500', name: 'Switch' };
  }

  // Network equipment brands (HP, Netgear, Ubiquiti, etc.)
  if (osLower.includes('hp ') || osLower.includes('hewlett') || osLower.includes('hpe ') ||
      osLower.includes('netgear') || osLower.includes('tp-link') || osLower.includes('tplink') ||
      osLower.includes('d-link') || osLower.includes('dlink') || osLower.includes('linksys') ||
      osLower.includes('asus') || osLower.includes('zyxel')) {
    return { icon: NetworkIcon, color: 'text-cyan-400', name: 'Network Device' };
  }

  // Ubiquiti / UniFi
  if (osLower.includes('ubiquiti') || osLower.includes('unifi') || osLower.includes('edgerouter') ||
      osLower.includes('edgeswitch') || osLower.includes('ubnt')) {
    return { icon: AccessPointIcon, color: 'text-blue-400', name: 'Ubiquiti' };
  }

  // Access Points / WiFi
  if (osLower.includes('access point') || osLower.includes('ap ') || osLower.includes('wifi') ||
      osLower.includes('wireless') || osLower.includes('ruckus') || osLower.includes('meraki')) {
    return { icon: AccessPointIcon, color: 'text-green-400', name: 'Access Point' };
  }

  // IoT / Embedded
  if (osLower.includes('embedded') || osLower.includes('rtos') || osLower.includes('firmware') ||
      osLower.includes('iot') || osLower.includes('raspberry') || osLower.includes('arduino') ||
      osLower.includes('esp32') || osLower.includes('esp8266')) {
    return { icon: HardDrive, color: 'text-orange-400', name: 'Embedded' };
  }

  // Printer
  if (osLower.includes('printer') || osLower.includes('hp laserjet') || osLower.includes('canon') || osLower.includes('xerox')) {
    return { icon: Monitor, color: 'text-pink-400', name: 'Printer' };
  }

  // Phone
  if (osLower.includes('phone') || osLower.includes('mobile')) {
    return { icon: Smartphone, color: 'text-indigo-400', name: 'Mobile' };
  }

  // Default
  return { icon: Terminal, color: 'text-gray-400', name: 'Unknown' };
};

// Helper function to detect if target is an IP address
const isIPAddress = (target) => {
  if (!target) return false;
  const ipPattern = /^(\d{1,3}\.){3}\d{1,3}$/;
  return ipPattern.test(target);
};

// Helper function to safely render any value (fixes React error #130 when objects are passed)
// CRITICAL: This function MUST always return a primitive string, never an object.
const safeRenderValue = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (Array.isArray(value)) {
    // Array: join string elements, stringify objects
    return value.map(v => typeof v === 'string' ? v : typeof v === 'object' ? JSON.stringify(v) : String(v)).join(', ');
  }
  if (typeof value === 'object') {
    // Extract the most relevant string field, with recursive safety
    const candidates = ['title', 'description', 'name', 'action', 'text', 'message', 'value', 'label'];
    for (const field of candidates) {
      if (value[field] !== undefined && value[field] !== null) {
        const extracted = value[field];
        // Recursively ensure the extracted value is a string
        if (typeof extracted === 'string') return extracted;
        if (typeof extracted === 'number' || typeof extracted === 'boolean') return String(extracted);
        // If extracted is also an object, fall through to JSON.stringify
      }
    }
    // Fallback to JSON string
    try {
      return JSON.stringify(value);
    } catch {
      return '[Object]';
    }
  }
  return String(value);
};

// Ensures any value is safe to render as a React child (string coercion)
const toSafeString = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (typeof value === 'object') {
    try { return JSON.stringify(value); } catch { return '[Object]'; }
  }
  return String(value);
};

const ScanDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useI18n();

  // Helper to translate scan type values
  const translateScanType = (scanType) => {
    if (!scanType) return '-';
    const key = `scans.types.${scanType}`;
    const translated = t(key);
    if (translated && translated !== key) return translated;
    const osintKey = `osint.scanTypes.${scanType}`;
    const osintTranslated = t(osintKey);
    if (osintTranslated && osintTranslated !== osintKey) return osintTranslated;
    return scanType.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  };
  const [scan, setScan] = useState(null);
  const [hosts, setHosts] = useState([]);
  const [vulnerabilities, setVulnerabilities] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  // CyberScore states
  const [cyberScore, setCyberScore] = useState(null);
  const [hackProbability, setHackProbability] = useState(null);

  // Screenshots/Captures states
  const [screenshots, setScreenshots] = useState([]);
  const [selectedScreenshot, setSelectedScreenshot] = useState(null);
  const [screenshotZoom, setScreenshotZoom] = useState(1);

  // AI Feedback states
  const [aiFeedbacks, setAiFeedbacks] = useState({});
  const [feedbackComment, setFeedbackComment] = useState('');
  const [showFeedbackModal, setShowFeedbackModal] = useState(null);
  const [expandedSections, setExpandedSections] = useState({
    info: true,
    cyberscore: true,
    screenshots: true,
    hosts: true,
    vulnerabilities: true,
    toolOutputs: false,
    advancedScore: false,
    aiTools: false
  });

  // Advanced CyberScore from API
  const [advancedCyberScore, setAdvancedCyberScore] = useState(null);

  // Vulnerability slider state
  const [selectedVulnerability, setSelectedVulnerability] = useState(null);

  // Excluded vulnerabilities (false positives)
  const [excludedVulns, setExcludedVulns] = useState({});

  // Vulnerability view controls (like Timeline)
  const [vulnViewMode, setVulnViewMode] = useState('top5'); // 'top5', 'all'
  const [vulnSortOrder, setVulnSortOrder] = useState('desc'); // 'asc', 'desc'
  const [vulnSortBy, setVulnSortBy] = useState('severity'); // 'severity', 'date'

  // Show all hosts toggle
  const [showAllHosts, setShowAllHosts] = useState(false);

  // Hosts sorting state
  const [hostsSortBy, setHostsSortBy] = useState('severity'); // 'severity', 'ip', 'ports', 'vulns'
  const [hostsSortOrder, setHostsSortOrder] = useState('desc'); // 'asc', 'desc'

  // GreyNoise botnet check state
  const [greynoiseResults, setGreynoiseResults] = useState({}); // ip -> greynoise data
  const [checkingGreynoise, setCheckingGreynoise] = useState(false);
  const [greynoiseSummary, setGreynoiseSummary] = useState(null); // { checked, botnet_count, botnet_ips }

  // AI Executive Summary state
  const [executiveSummary, setExecutiveSummary] = useState(null);
  const [loadingExecutiveSummary, setLoadingExecutiveSummary] = useState(false);
  const [isValidating, setIsValidating] = useState(false);

  // AI Storytelling Window state
  const [showStorytellingWindow, setShowStorytellingWindow] = useState(false);

  // Host Detail Modal state
  const [selectedHost, setSelectedHost] = useState(null);
  const [hostAnalysis, setHostAnalysis] = useState(null);
  const [loadingHostAnalysis, setLoadingHostAnalysis] = useState(false);
  const [hostAccordion, setHostAccordion] = useState({
    aiAnalysis: true,
    attackPath: false,
    priorityActions: false,
    vulnerabilities: false,
    recommendations: false
  });

  // Toggle accordion section
  const toggleHostAccordion = (section) => {
    setHostAccordion(prev => ({ ...prev, [section]: !prev[section] }));
  };

  // Schedule Modal state
  const [showScheduleModal, setShowScheduleModal] = useState(false);

  // Config Summary Modal state
  const [showConfigModal, setShowConfigModal] = useState(false);
  const [scheduleConfig, setScheduleConfig] = useState({
    frequency: 'weekly',
    interval: 1,
    days_of_week: [1], // Monday default
    time_of_day: '02:00',
    auto_generate_report: true,
    report_formats: ['pentest'], // Default report types
    max_runs: 12, // 12 runs by default
    has_end: true // Limit enabled by default
  });
  const [isScheduling, setIsScheduling] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  // Existing schedules and running scans for visualization
  const [existingSchedules, setExistingSchedules] = useState([]);
  const [runningScans, setRunningScans] = useState([]);
  const [loadingScheduleData, setLoadingScheduleData] = useState(false);

  // Live Console state - logs des commandes en temps reel
  const [consoleLogs, setConsoleLogs] = useState([]);
  const [consoleAutoScroll, setConsoleAutoScroll] = useState(true);

  // Queue info state for queued scans
  const [queueInfo, setQueueInfo] = useState(null);
  const [loadingQueueInfo, setLoadingQueueInfo] = useState(false);

  // Scan phases for progress tracking
  const [scanPhases, setScanPhases] = useState([]);
  const consoleRef = React.useRef(null);
  const [isCapturing, setIsCapturing] = useState(false);

  // Cleanup state
  const [isCleaning, setIsCleaning] = useState(false);
  const [showCleanupModal, setShowCleanupModal] = useState(false);
  const [cleanupResult, setCleanupResult] = useState(null);
  const [cleanupPreview, setCleanupPreview] = useState(null);

  // VPN live stats state
  const [vpnStats, setVpnStats] = useState({
    uploadSpeed: '0 B/s',
    downloadSpeed: '0 B/s',
    totalUpload: '0 B',
    totalDownload: '0 B',
    publicIp: null
  });
  const vpnStatsRef = useRef({ lastRx: 0, lastTx: 0, lastTime: Date.now() });

  // VPS Info state - dynamic VPS/VPN info from API
  const [vpsInfo, setVpsInfo] = useState(null);

  // Dynamic loading comments state
  const [loadingCommentIndex, setLoadingCommentIndex] = useState(0);

  // Humorous loading comments based on scan progress
  const getLoadingComments = useMemo(() => {
    const vulnCount = vulnerabilities.length;
    const hostCount = hosts.length;
    const criticalCount = vulnerabilities.filter(v => v.severity === 'critical').length;
    const highCount = vulnerabilities.filter(v => v.severity === 'high').length;

    const baseComments = [
      "The AI is analyzing network flows... Don't ask why it takes so long.",
      "Scanning ports as if my life depended on it (actually it's your security).",
      "Searching for vulnerabilities... Is the coffee ready?",
      "Inspecting each packet with the delicacy of a surgeon (or a hacker).",
      "Enumerating services... Hope you have nothing to hide.",
      "Analyzing SSL certificates... Some date back to the Windows XP era!",
      "Digging through cookies... Yum, credentials!",
      "Testing SQL injections... DROP TABLE IF EXISTS stress;",
      "Checking HTTP headers... X-Powered-By: Legacy-PHP-4.3",
      "The AI is thinking hard... or pretending, you never know.",
    ];

    const progressComments = [];

    if (hostCount > 0) {
      progressComments.push(`${hostCount} host(s) discovered! Your network is quite chatty.`);
      if (hostCount > 5) {
        progressComments.push("Wow, lots of machines to analyze... Hope the coffee budget is unlimited.");
      }
    }

    if (vulnCount > 0) {
      progressComments.push(`Oops, ${vulnCount} vulnerability(ies) found so far... Don't panic (yet).`);
      if (vulnCount > 10) {
        progressComments.push(`${vulnCount} vulnerabilities! Looks like Swiss cheese (without the cheese).`);
      }
    }

    if (criticalCount > 0) {
      progressComments.push(`RED ALERT! ${criticalCount} critical vuln(s)! The local hacker probably already knows.`);
      progressComments.push("Found critical vulnerabilities... Did the intern strike again?");
      progressComments.push("Critical CVEs detected! Someone forgot to patch since 2019.");
    }

    if (highCount > 0) {
      progressComments.push(`${highCount} high severity vuln(s)! Not great but could be worse.`);
      progressComments.push("High severity detected... Is the firewall just decoration?");
    }

    if (vulnCount === 0 && hostCount > 0) {
      progressComments.push("All good so far... Too good. Suspicious.");
      progressComments.push("No vulns yet... Either you're brilliant, or I'm not done.");
    }

    const extraComments = [
      "Bruteforcing default credentials... admin/admin? Really?",
      "Checking if someone left a backdoor... 'test123' is not a password.",
      "Scanning APIs... Swagger open on the Internet? Interesting...",
      "Analyzing GraphQL endpoints... Introspection enabled, jackpot!",
      "Detecting CMS... WordPress not updated since 2020, classic.",
      "Enumerating LDAP... Who needs privacy anyway?",
      "Testing CORS... Access-Control-Allow-Origin: * (facepalm)",
      "The AI is compiling its mental report... Like a cat staring at nothing.",
      "Checking exposed backups... Oh, a .sql.bak on the web server!",
      "Scan finishing soon... Or not, I'm not psychic.",
    ];

    return [...baseComments, ...progressComments, ...extraComments];
  }, [vulnerabilities, hosts]);

  // Calculate scan progress and estimated remaining time from phases
  const scanProgress = useMemo(() => {
    if (!scanPhases || scanPhases.length === 0) {
      return { percentage: 0, remainingTime: null, elapsedTime: 0 };
    }

    // Get the latest phase's progress percentage
    const latestPhase = scanPhases[scanPhases.length - 1];
    const percentage = latestPhase?.progress_percentage || 0;

    // Calculate elapsed time
    const startedAt = scan?.started_at ? new Date(scan.started_at) : null;
    const now = new Date();
    const elapsedMs = startedAt ? now - startedAt : 0;
    const elapsedMinutes = Math.floor(elapsedMs / 60000);

    // Estimate remaining time based on progress
    let remainingTime = null;
    if (percentage > 5 && elapsedMs > 0) {
      const totalEstimatedMs = (elapsedMs / percentage) * 100;
      const remainingMs = totalEstimatedMs - elapsedMs;
      const remainingMinutes = Math.max(1, Math.ceil(remainingMs / 60000));

      if (remainingMinutes < 60) {
        remainingTime = `~${remainingMinutes} min`;
      } else {
        const hours = Math.floor(remainingMinutes / 60);
        const mins = remainingMinutes % 60;
        remainingTime = `~${hours}h${mins > 0 ? mins + 'min' : ''}`;
      }
    }

    return { percentage, remainingTime, elapsedTime: elapsedMinutes };
  }, [scanPhases, scan?.started_at]);

  // Severity priority for sorting (higher = more severe)
  const severityPriority = { critical: 4, high: 3, medium: 2, low: 1, info: 0 };

  // Filter and sort vulnerabilities based on viewMode and sortOrder
  const filteredVulnerabilities = useMemo(() => {
    let result = [...vulnerabilities];

    // Sort based on sortBy and sortOrder
    if (vulnSortBy === 'severity') {
      result.sort((a, b) => {
        const priorityA = severityPriority[a.severity?.toLowerCase()] || 0;
        const priorityB = severityPriority[b.severity?.toLowerCase()] || 0;
        return vulnSortOrder === 'desc' ? priorityB - priorityA : priorityA - priorityB;
      });
    } else {
      // Sort by date (created_at or discovered_at)
      result.sort((a, b) => {
        const dateA = new Date(a.created_at || a.discovered_at || 0);
        const dateB = new Date(b.created_at || b.discovered_at || 0);
        return vulnSortOrder === 'desc' ? dateB - dateA : dateA - dateB;
      });
    }

    // Apply view mode filter
    if (vulnViewMode === 'top5') {
      result = result.slice(0, 5);
    }

    return result;
  }, [vulnerabilities, vulnViewMode, vulnSortOrder, vulnSortBy]);

  // Sort hosts based on severity, IP, ports or vulnerabilities count
  const sortedHosts = useMemo(() => {
    if (!hosts || hosts.length === 0) return [];

    return [...hosts].sort((a, b) => {
      // Calculate severity score for each host
      const getHostSeverityScore = (host) => {
        const hostVulns = vulnerabilities.filter(v => v.host_id === host.id || v.ip_address === host.ip_address);
        const criticalCount = hostVulns.filter(v => v.severity === 'critical').length;
        const highCount = hostVulns.filter(v => v.severity === 'high').length;
        const mediumCount = hostVulns.filter(v => v.severity === 'medium').length;
        const lowCount = hostVulns.filter(v => v.severity === 'low').length;
        // Weighted score: critical=1000, high=100, medium=10, low=1
        return criticalCount * 1000 + highCount * 100 + mediumCount * 10 + lowCount;
      };

      const getVulnCount = (host) => {
        return vulnerabilities.filter(v => v.host_id === host.id || v.ip_address === host.ip_address).length;
      };

      const getPortCount = (host) => {
        return host.open_ports?.length || host.open_ports || 0;
      };

      let comparison = 0;

      switch (hostsSortBy) {
        case 'severity':
          comparison = getHostSeverityScore(b) - getHostSeverityScore(a);
          break;
        case 'ip':
          // Sort by IP numerically
          const ipA = a.ip_address?.split('.').map(n => parseInt(n) || 0) || [0, 0, 0, 0];
          const ipB = b.ip_address?.split('.').map(n => parseInt(n) || 0) || [0, 0, 0, 0];
          comparison = ipA[0] - ipB[0] || ipA[1] - ipB[1] || ipA[2] - ipB[2] || ipA[3] - ipB[3];
          break;
        case 'ports':
          comparison = getPortCount(b) - getPortCount(a);
          break;
        case 'vulns':
          comparison = getVulnCount(b) - getVulnCount(a);
          break;
        default:
          comparison = getHostSeverityScore(b) - getHostSeverityScore(a);
      }

      // Apply sort order
      return hostsSortOrder === 'desc' ? comparison : -comparison;
    });
  }, [hosts, vulnerabilities, hostsSortBy, hostsSortOrder]);

  // Initialize CyberScore with default values immediately on mount
  useEffect(() => {
    // Set initial perfect score (no vulnerabilities found yet)
    setCyberScore({
      score: 91,
      grade: 'A',
      components: {
        vulnerabilities: 100,
        exposure: 100,
        configuration: 80,
        ad_security: 70,
        osint: 75
      },
      vulnCounts: { critical: 0, high: 0, medium: 0, low: 0 }
    });
    setHackProbability(5); // Initial low probability
  }, []);

  useEffect(() => {
    fetchScanDetails();
    fetchScreenshots(); // Initial fetch

    // Only poll for running/pending/waiting scans - stop polling when completed to prevent page jumping
    let interval = null;
    if (scan?.status === 'running' || scan?.status === 'pending' || scan?.status === 'waiting' || !scan) {
      interval = setInterval(() => {
        fetchScanDetails();
        fetchScreenshots(); // Also refresh screenshots
      }, 10000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [id, scan?.status]);

  // Fetch VPS info for the scan (re-fetch periodically while running)
  useEffect(() => {
    const fetchVpsInfo = async () => {
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      if (!id || !uuidRegex.test(id)) return;

      try {
        const backendUrl = process.env.REACT_APP_API_URL || '';
        const token = localStorage.getItem('access_token');
        const response = await fetch(`${backendUrl}/api/v1/scan/${id}/vps-info`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          const data = await response.json();
          setVpsInfo(data);
        }
      } catch (error) {
        console.log('VPS info not available');
      }
    };
    if (id) fetchVpsInfo();

    // Re-fetch VPS info every 15s while scan is running (VPN config may update)
    let vpsInterval;
    if (id && scan?.status === 'running') {
      vpsInterval = setInterval(fetchVpsInfo, 15000);
    }
    return () => { if (vpsInterval) clearInterval(vpsInterval); };
  }, [id, scan?.status]);

  // Rotate loading comments every 4 seconds when scan is running
  useEffect(() => {
    if (scan?.status === 'running') {
      const commentInterval = setInterval(() => {
        setLoadingCommentIndex(prev => (prev + 1) % getLoadingComments.length);
      }, 4000);
      return () => clearInterval(commentInterval);
    }
  }, [scan?.status, getLoadingComments.length]);

  // Fetch console logs more frequently when scan is running (every 2 seconds)
  useEffect(() => {
    if (scan?.status === 'running') {
      const fetchLogs = async () => {
        try {
          const backendUrl = process.env.REACT_APP_API_URL || '';
          const token = localStorage.getItem('access_token');
          const logsResponse = await fetch(`${backendUrl}/api/v1/scan/${id}/logs`, {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          if (logsResponse.ok) {
            const logsData = await logsResponse.json();
            setConsoleLogs(logsData.logs || []);
          }
        } catch (e) {
          // Silently fail for logs
        }
      };
      fetchLogs();
      const logsInterval = setInterval(fetchLogs, 2000);
      return () => clearInterval(logsInterval);
    }
  }, [scan?.status, id]);

  // Fetch queue info for queued scans
  useEffect(() => {
    const fetchQueueInfo = async () => {
      if (scan?.status !== 'queued') {
        setQueueInfo(null);
        return;
      }
      setLoadingQueueInfo(true);
      try {
        const backendUrl = process.env.REACT_APP_API_URL || '';
        const token = localStorage.getItem('access_token');
        const response = await fetch(`${backendUrl}/api/v1/scan/${id}/queue-status`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          const data = await response.json();
          setQueueInfo(data);
        }
      } catch (error) {
        console.log('Queue info not available');
      } finally {
        setLoadingQueueInfo(false);
      }
    };

    if (scan?.status === 'queued') {
      fetchQueueInfo();
      // Poll every 5 seconds for queue updates
      const queueInterval = setInterval(fetchQueueInfo, 5000);
      return () => clearInterval(queueInterval);
    }
  }, [scan?.status, id]);

  // VPN stats polling - fetch network info every 2 seconds when VPN is active
  useEffect(() => {
    const workspaceId = scan?.workspace_id || scan?.workspaces?.[0]?.id;
    if (scan?.config?.use_vpn && workspaceId && scan?.status === 'running') {
      const fetchVpnStats = async () => {
        try {
          const backendUrl = process.env.REACT_APP_API_URL || '';
          const token = localStorage.getItem('access_token') || localStorage.getItem('token');
          const response = await fetch(`${backendUrl}/api/v1/vpn/network-info/${workspaceId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          if (response.ok) {
            const data = await response.json();
            const now = Date.now();
            const timeDiff = (now - vpnStatsRef.current.lastTime) / 1000; // seconds

            const rxBytes = data.traffic?.rx_bytes || 0;
            const txBytes = data.traffic?.tx_bytes || 0;

            // Calculate speed (bytes per second)
            let downloadSpeed = '0 B/s';
            let uploadSpeed = '0 B/s';

            if (vpnStatsRef.current.lastRx > 0 && timeDiff > 0) {
              const rxDiff = rxBytes - vpnStatsRef.current.lastRx;
              const txDiff = txBytes - vpnStatsRef.current.lastTx;

              if (rxDiff >= 0 && txDiff >= 0) {
                downloadSpeed = formatSpeed(rxDiff / timeDiff);
                uploadSpeed = formatSpeed(txDiff / timeDiff);
              }
            }

            // Update ref for next calculation
            vpnStatsRef.current = { lastRx: rxBytes, lastTx: txBytes, lastTime: now };

            setVpnStats({
              uploadSpeed,
              downloadSpeed,
              totalUpload: data.traffic?.tx_formatted || '0 B',
              totalDownload: data.traffic?.rx_formatted || '0 B',
              publicIp: data.vpn?.public_ip || data.public_ip || null
            });
          }
        } catch (e) {
          // Silently fail
        }
      };

      // Helper to format speed
      const formatSpeed = (bytesPerSecond) => {
        if (bytesPerSecond < 1024) return `${Math.round(bytesPerSecond)} B/s`;
        if (bytesPerSecond < 1024 * 1024) return `${(bytesPerSecond / 1024).toFixed(1)} KB/s`;
        return `${(bytesPerSecond / (1024 * 1024)).toFixed(1)} MB/s`;
      };

      fetchVpnStats();
      const vpnInterval = setInterval(fetchVpnStats, 2000);
      return () => clearInterval(vpnInterval);
    }
  }, [scan?.config?.use_vpn, scan?.workspace_id, scan?.workspaces, scan?.status]);

  // Auto-scroll console to bottom when new logs arrive
  useEffect(() => {
    if (consoleAutoScroll && consoleRef.current) {
      consoleRef.current.scrollTop = consoleRef.current.scrollHeight;
    }
  }, [consoleLogs, consoleAutoScroll]);

  // Auto-fetch Executive Summary when scan finishes (only once)
  const executiveSummaryFetched = useRef(false);
  useEffect(() => {
    const isFinished = scan?.status === 'completed' || scan?.status === 'failed' || scan?.status === 'finished' || scan?.status === 'done';
    if (isFinished && !executiveSummaryFetched.current && id) {
      executiveSummaryFetched.current = true;
      fetchExecutiveSummary(id);
    }
  }, [scan?.status, id]);

  const fetchScanDetails = async () => {
    // Validate UUID format before making API calls
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (!id || !uuidRegex.test(id)) {
      setLoading(false);
      return;
    }

    try {
      const scanData = await scansApi.get(id);
      setScan(scanData);

      const backendUrl = process.env.REACT_APP_API_URL || '';
      const token = localStorage.getItem('access_token');

      const [hostsData, vulnsData, statsData, phasesData] = await Promise.all([
        scansApi.getHosts(id).catch(() => []),
        scansApi.getVulnerabilities(id).catch(() => []),
        scansApi.getStats(id).catch(() => null),
        fetch(`${backendUrl}/api/v1/scan/${id}/phases`, {
          headers: { 'Authorization': `Bearer ${token}` }
        }).then(r => r.ok ? r.json() : []).catch(() => []),
      ]);

      setHosts(hostsData);
      setVulnerabilities(vulnsData);
      setStats(statsData);
      setScanPhases(phasesData);

      // Initialize GreyNoise results from cached host data
      const cachedGn = {};
      let hasBotnet = 0;
      (Array.isArray(hostsData) ? hostsData : []).forEach(h => {
        if (h.ai_analysis_cache?.greynoise?.checked) {
          cachedGn[h.ip_address] = h.ai_analysis_cache.greynoise;
          if (h.ai_analysis_cache.greynoise.is_botnet) hasBotnet++;
        }
      });
      if (Object.keys(cachedGn).length > 0) {
        setGreynoiseResults(cachedGn);
        setGreynoiseSummary({
          checked: Object.keys(cachedGn).length,
          botnet_count: hasBotnet,
          botnet_ips: Object.entries(cachedGn).filter(([, v]) => v.is_botnet).map(([k]) => k),
        });
      }

      // For completed/failed scans, only calculate/fetch once to prevent page jumping
      const isCompleted = scanData?.status === 'completed';
      const isFailed = scanData?.status === 'failed';
      const isFinished = isCompleted || isFailed;

      // Calculate CyberScore - always calculate once data is loaded
      calculateCyberScore(vulnsData, hostsData, statsData);

      // Fetch Executive Summary - for completed OR failed scans
      // Don't refetch if already loaded to prevent page jumping
      if (isFinished && !executiveSummary?.ready) {
        fetchExecutiveSummary(id);
      }

      // Fetch console logs - always fetch on initial load, then poll for running scans
      try {
        const backendUrl = process.env.REACT_APP_API_URL || '';
        const token = localStorage.getItem('access_token');
        const logsResponse = await fetch(`${backendUrl}/api/v1/scan/${id}/logs`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (logsResponse.ok) {
          const logsData = await logsResponse.json();
          setConsoleLogs(logsData.logs || []);
        }
      } catch (e) {
        console.log('Console logs not available');
      }

    } catch (error) {
      console.error('Failed to fetch scan details:', error);
    } finally {
      setLoading(false);
    }
  };


  // Fetch Executive Summary from new endpoint
  const fetchExecutiveSummary = async (scanId) => {
    setLoadingExecutiveSummary(true);
    try {
      const backendUrl = process.env.REACT_APP_API_URL || '';
      const token = localStorage.getItem('access_token');
      const response = await fetch(`${backendUrl}/api/v1/scan/${scanId}/executive-summary`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        // Map API response to expected format for display
        if (data.ready && data.report) {
          const report = data.report;
          const mappedData = {
            ready: true,
            cached: data.cached,
            // Context section - derived from report data
            context: {
              description: report.executive_summary || `Autonomous security audit performed by SYLink Pentest AI on target ${scan?.target || 'specified'}. This analysis uses automated penetration testing techniques combined with artificial intelligence to identify vulnerabilities and assess security risks.`,
              objectives: [
                "Identify exploitable vulnerabilities on the target perimeter",
                "Assess the overall risk level of the infrastructure",
                "Provide prioritized remediation recommendations",
                "Map potential attack vectors",
                "Assess impact on regulatory compliance"
              ]
            },
            // Perimeter section
            perimeter: {
              hosts_count: report.hosts_summary?.total || report.key_findings?.hosts_discovered || 0,
              ports_count: report.hosts_summary?.total_ports || report.key_findings?.services_found || 0,
              services_count: report.key_findings?.services_found || 0,
              scope: `Analyzed perimeter: ${report.hosts_summary?.total || 0} host(s), ${report.hosts_summary?.total_ports || 0} open port(s). ${report.cves_found?.length || 0} CVE(s) identified.`
            },
            // Risk score section
            risk_score: {
              score: report.risk_score || 0,
              level: report.risk_level?.toUpperCase() === 'CRITICAL' ? 'CRITICAL' :
                     report.risk_level?.toUpperCase() === 'HIGH' ? 'HIGH' :
                     report.risk_level?.toUpperCase() === 'MEDIUM' ? 'MEDIUM' : 'LOW',
              explanation: report.risk_justification || `Assessment based on ${report.key_findings?.critical_count || 0} critical vulnerability(ies) and ${report.key_findings?.high_count || 0} high vulnerability(ies).`
            },
            // Attack scenarios
            attack_scenarios: (report.attack_vectors || []).map((v, idx) => ({
              name: v.vector || `Scenario ${idx + 1}`,
              description: v.description || '',
              severity: v.risk || 'medium',
              mitre_techniques: v.mitre_techniques || []
            })),
            // Top vulnerabilities
            top_vulnerabilities: [], // Will use local vulnerabilities list
            // Identity & Access
            identity_access: {
              weaknesses: report.attack_vectors?.filter(v => v.vector?.toLowerCase().includes('ssh') || v.vector?.toLowerCase().includes('auth'))
                .map(v => v.description) || [],
              recommendations: report.recommendations?.filter(r => r.category === 'authentication' || r.title?.toLowerCase().includes('auth'))
                .map(r => r.description) || [
                  "Implement multi-factor authentication (MFA)",
                  "Strengthen the password policy",
                  "Implement centralized identity management"
                ]
            },
            // Business impact
            business_impact: {
              summary: `The analysis reveals ${report.key_findings?.critical_count || 0} critical vulnerability(ies) and ${report.key_findings?.high_count || 0} high vulnerability(ies) that may impact business continuity, data confidentiality and the organization's reputation.`,
              impacts: [
                { type: "Continuity", level: report.key_findings?.critical_count > 0 ? "high" : "medium", description: "Risk of service disruption if exploited" },
                { type: "Confidentiality", level: report.key_findings?.high_count > 2 ? "high" : "medium", description: "Potential exposure of sensitive data" },
                { type: "Reputation", level: report.key_findings?.critical_count > 0 ? "high" : "low", description: "Impact on image in case of a public incident" }
              ]
            },
            // Action plan
            action_plan: {
              d0_d30: report.top_priorities?.filter(p => p.urgency === 'immediate' || p.priority <= 2)
                .map(p => p.action) || ["Fix identified critical vulnerabilities", "Update vulnerable systems"],
              d30_d90: report.top_priorities?.filter(p => p.urgency === 'short_term')
                .map(p => p.action) || ["Implement security recommendations", "Strengthen network segmentation"],
              d90_12m: report.recommendations?.filter(r => r.effort === 'high')
                .map(r => r.title) || ["Vulnerability management program", "Regular security audits", "Security awareness training"]
            },
            // Positive points
            positive_points: [
              report.key_findings?.critical_count === 0 ? t('scanDetails.noCriticalVulnsDetected') : null,
              report.key_findings?.low_count > report.key_findings?.high_count ? "Majority of low-severity vulnerabilities" : null,
              report.tools_used?.length > 5 ? "Full coverage with multiple analysis tools" : null,
              "Automated scan enabling rapid detection",
              "Report generated with AI assistance for in-depth analysis"
            ].filter(Boolean),
            // Raw report data for reference
            raw: report
          };
          setExecutiveSummary(mappedData);
        } else {
          setExecutiveSummary(data);
        }
      } else {
        console.error('Failed to fetch executive summary:', response.status);
      }
    } catch (error) {
      console.error('Error fetching executive summary:', error);
    } finally {
      setLoadingExecutiveSummary(false);
    }
  };

  // Handle scan validation and redirect to reports
  const handleValidateAndGenerateReport = async () => {
    setIsValidating(true);
    try {
      // Mark scan as validated for report using the correct endpoint
      const backendUrl = process.env.REACT_APP_API_URL || '';
      const response = await fetch(`${backendUrl}/api/v1/scan/validate-for-report`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        },
        body: JSON.stringify({
          scan_ids: [id],
          validated: true
        })
      });

      if (!response.ok) {
        console.error('Validation response error:', response.status);
      } else {
        const data = await response.json();
        console.log('Scan validated for report:', data);
      }

      // Navigate to reports page with scan pre-selected
      navigate(`/reports?scan_id=${id}&auto_generate=true`);
    } catch (error) {
      console.error('Failed to validate scan:', error);
      // Still navigate even if validation fails
      navigate(`/reports?scan_id=${id}&auto_generate=true`);
    } finally {
      setIsValidating(false);
    }
  };

  // CyberScore Calculation based on the provided algorithm
  const calculateCyberScore = useCallback((vulns, hostsData, statsData) => {
    // Vulnerability scoring
    let vulnScore = 100;
    const vulnCounts = {
      critical: vulns.filter(v => v.severity === 'critical').length,
      high: vulns.filter(v => v.severity === 'high').length,
      medium: vulns.filter(v => v.severity === 'medium').length,
      low: vulns.filter(v => v.severity === 'low').length
    };

    // Severity factors based on CVSS
    const severityFactors = { critical: 10.0, high: 7.0, medium: 4.0, low: 2.0 };
    let totalImpact = 0;
    let totalWeight = 0;

    Object.entries(vulnCounts).forEach(([severity, count]) => {
      if (count > 0) {
        const factor = severityFactors[severity];
        const exploitability = severity === 'critical' ? 0.95 : severity === 'high' ? 0.8 : severity === 'medium' ? 0.5 : 0.2;
        totalImpact += factor * exploitability * Math.log10(count + 1) * 1.2;
        totalWeight += 1;
      }
    });

    if (totalWeight > 0) {
      vulnScore = Math.max(0, 100 - (totalImpact / totalWeight) * 25);
    }

    // Exposure scoring
    let exposureScore = 100;
    const openPorts = hostsData.reduce((sum, h) => sum + (h.open_ports?.length || h.open_ports || 0), 0);
    const portPenalty = Math.min(50, openPorts * 2);
    const publicServices = hostsData.filter(h => {
      const ports = h.open_ports || [];
      return Array.isArray(ports) && ports.some(p => [80, 443, 22, 21, 3389].includes(p.port || p));
    }).length;
    const servicePenalty = Math.min(20, publicServices * 4);
    exposureScore = Math.max(0, 100 - portPenalty - servicePenalty);

    // Configuration score (simplified)
    const configScore = hostsData.length > 0 ? 60 : 80;

    // Calculate weighted CyberScore
    const weights = { vulnerabilities: 0.35, exposure: 0.25, configuration: 0.20, ad_security: 0.10, osint: 0.10 };
    const adScore = 70; // Default
    const osintScore = 75; // Default

    const finalScore = Math.round(
      vulnScore * weights.vulnerabilities +
      exposureScore * weights.exposure +
      configScore * weights.configuration +
      adScore * weights.ad_security +
      osintScore * weights.osint
    );

    setCyberScore({
      score: finalScore,
      grade: getGrade(finalScore),
      components: {
        vulnerabilities: Math.round(vulnScore),
        exposure: Math.round(exposureScore),
        configuration: Math.round(configScore),
        ad_security: adScore,
        osint: osintScore
      },
      vulnCounts
    });

    // Calculate Hack Probability
    const baseProbability = 100 - finalScore;
    const attackSurfaceFactor = Math.min(1.5, 1.0 + (openPorts / 100));
    const internetFactor = publicServices > 0 ? 1.4 : 1.0;
    const exploitFactor = vulnCounts.critical > 0 ? 1.6 : vulnCounts.high > 0 ? 1.3 : 1.0;

    const probability = Math.min(100, Math.round(baseProbability * attackSurfaceFactor * internetFactor * exploitFactor / 2));
    setHackProbability(probability);
  }, []);

  const getGrade = (score) => {
    if (score >= 80) return 'A';
    if (score >= 60) return 'B';
    if (score >= 40) return 'C';
    if (score >= 20) return 'D';
    return 'E';
  };

  const getGradeColor = (grade) => {
    const colors = {
      'A': 'from-green-500 to-green-600',
      'B': 'from-blue-500 to-blue-600',
      'C': 'from-yellow-500 to-yellow-600',
      'D': 'from-orange-500 to-orange-600',
      'E': 'from-red-500 to-red-600'
    };
    return colors[grade] || colors['C'];
  };

  const getGradeBgColor = (grade) => {
    const colors = {
      'A': 'bg-green-500/20 border-green-500/50 text-green-400',
      'B': 'bg-blue-500/20 border-blue-500/50 text-blue-400',
      'C': 'bg-yellow-500/20 border-yellow-500/50 text-yellow-400',
      'D': 'bg-orange-500/20 border-orange-500/50 text-orange-400',
      'E': 'bg-red-500/20 border-red-500/50 text-red-400'
    };
    return colors[grade] || colors['C'];
  };

  const getProbabilityColor = (prob) => {
    if (prob >= 80) return 'text-red-500';
    if (prob >= 60) return 'text-orange-500';
    if (prob >= 40) return 'text-yellow-500';
    if (prob >= 20) return 'text-blue-400';
    return 'text-green-400';
  };

  const getProbabilityLevel = (prob) => {
    if (prob >= 80) return { label: 'CRITICAL', color: 'bg-red-500/20 text-red-400 border-red-500/50' };
    if (prob >= 60) return { label: 'HIGH', color: 'bg-orange-500/20 text-orange-400 border-orange-500/50' };
    if (prob >= 40) return { label: 'MEDIUM', color: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/50' };
    if (prob >= 20) return { label: 'LOW', color: 'bg-blue-500/20 text-blue-400 border-blue-500/50' };
    return { label: 'MINIMAL', color: 'bg-green-500/20 text-green-400 border-green-500/50' };
  };

  // Fetch real screenshots from backend API
  const fetchScreenshots = async () => {
    // Validate UUID format before making API call
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (!id || !uuidRegex.test(id)) return;

    try {
      const backendUrl = process.env.REACT_APP_API_URL || '';
      const token = localStorage.getItem('access_token');
      const response = await fetch(`${backendUrl}/api/v1/scan/${id}/screenshots`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        // Transform backend data to frontend format
        const transformedScreenshots = (data.screenshots || []).map((s, index) => ({
          id: index + 1,
          title: s.description || `Capture ${index + 1}`,
          description: s.description || 'Interface screenshot',
          url: s.url || '',
          timestamp: s.captured_at || new Date().toISOString(),
          type: s.type || 'image', // Preserve original type (console or image)
          path: s.path, // Image path for display
          content: s.path ? null : 'Screenshot captured during scan'
        }));
        setScreenshots(transformedScreenshots);
      }
    } catch (error) {
      console.error('Failed to fetch screenshots:', error);
      // Keep existing screenshots if fetch fails
    }
  };

  // Fetch host analysis with AI
  const fetchHostAnalysis = async (host) => {
    setSelectedHost(host);
    setLoadingHostAnalysis(true);
    setHostAnalysis(null);

    // Calculate host vulnerabilities from local data
    const hostVulns = vulnerabilities.filter(v =>
      v.host_id === host.id ||
      v.ip_address === host.ip_address ||
      v.host_ip === host.ip_address
    );

    const criticalCount = hostVulns.filter(v => v.severity === 'critical').length;
    const highCount = hostVulns.filter(v => v.severity === 'high').length;
    const mediumCount = hostVulns.filter(v => v.severity === 'medium').length;
    const lowCount = hostVulns.filter(v => v.severity === 'low').length;
    const totalVulns = hostVulns.length;

    // Determine risk level
    const riskLevel = criticalCount > 0 ? 'CRITICAL' :
                      highCount > 0 ? 'HIGH' :
                      mediumCount > 0 ? 'MEDIUM' : 'LOW';

    // Get unique CVE IDs
    const cveIds = [...new Set(hostVulns.filter(v => v.cve_id).map(v => v.cve_id))];

    // Generate AI analysis based on host data
    const generateAIAnalysis = () => {
      const osInfo = host.os_name || 'unidentified system';
      const portCount = host.open_ports?.length || host.open_ports || 0;

      if (totalVulns === 0) {
        return `Host ${host.ip_address} (${osInfo}) has a satisfactory security posture. With ${portCount} open port(s) and no vulnerabilities detected, this system is not an immediate remediation priority. It is nonetheless recommended to maintain continuous monitoring and apply security updates regularly.`;
      }

      let analysis = `Analysis of host ${host.ip_address} (${osInfo}) reveals **${totalVulns} vulnerability(ies)** broken down as follows: `;

      const parts = [];
      if (criticalCount > 0) parts.push(`${criticalCount} critical`);
      if (highCount > 0) parts.push(`${highCount} high`);
      if (mediumCount > 0) parts.push(`${mediumCount} medium`);
      if (lowCount > 0) parts.push(`${lowCount} low`);
      analysis += parts.join(', ') + '. ';

      if (criticalCount > 0) {
        analysis += `**CRITICAL ALERT**: This system has critical vulnerabilities requiring immediate action. An attacker could exploit these flaws to gain unauthorized access, execute arbitrary code or compromise data integrity. `;
      } else if (highCount > 0) {
        analysis += `This system has high-severity vulnerabilities that could be exploited to compromise network security. A quick fix is recommended. `;
      } else if (mediumCount > 0) {
        analysis += `The medium vulnerabilities identified represent a moderate risk but should not be overlooked in the remediation plan. `;
      }

      if (cveIds.length > 0) {
        analysis += `CVEs identified: ${cveIds.slice(0, 5).join(', ')}${cveIds.length > 5 ? ` and ${cveIds.length - 5} more` : ''}.`;
      }

      return analysis;
    };

    // Generate impact analysis
    const generateImpact = () => {
      if (criticalCount > 0) {
        return "Complete system compromise possible. Risk of data exfiltration, backdoor installation, and use as a pivot for attacks on other systems on the network.";
      } else if (highCount > 0) {
        return "High risk of unauthorized access or privilege escalation. These vulnerabilities could allow an attacker to gain significant control over the system.";
      } else if (mediumCount > 0) {
        return "Moderate impact on data confidentiality or integrity. These flaws could be exploited in combination with other vulnerabilities.";
      }
      return null;
    };

    // Generate recommendations
    const generateRecommendations = () => {
      const recs = [];

      if (criticalCount > 0 || highCount > 0) {
        recs.push({
          title: "Immediate patching",
          description: "Apply security patches for identified critical and high vulnerabilities.",
          priority: "critical"
        });
      }

      if (host.open_ports > 5) {
        recs.push({
          title: "Attack surface reduction",
          description: t('scanDetails.reduceAttackSurfaceDesc'),
          priority: "high"
        });
      }

      if (cveIds.length > 0) {
        recs.push({
          title: "Component update",
          description: "Update vulnerable software to their latest secure versions.",
          priority: "high"
        });
      }

      recs.push({
        title: "Continuous monitoring",
        description: "Set up log and alert monitoring to detect any suspicious activity.",
        priority: "medium"
      });

      return recs;
    };

    try {
      const backendUrl = process.env.REACT_APP_API_URL || '';
      const token = localStorage.getItem('access_token');
      const response = await fetch(`${backendUrl}/api/v1/scan/${id}/hosts/${host.id}/analysis`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        // Merge API data with calculated CVE counts
        setHostAnalysis({
          ...data,
          cve_summary: {
            total: totalVulns,
            critical: criticalCount,
            high: highCount,
            medium: mediumCount,
            low: lowCount
          },
          vulnerability_count: totalVulns,
          critical_count: criticalCount,
          high_count: highCount,
          medium_count: mediumCount,
          low_count: lowCount,
          risk_level: riskLevel,
          cve_ids: cveIds,
          host_vulnerabilities: hostVulns,
          ai_analysis: data.ai_analysis || generateAIAnalysis(),
          impact: data.impact || generateImpact(),
          recommendations: data.recommendations || generateRecommendations()
        });
      } else {
        // Fallback with calculated data and generated analysis
        setHostAnalysis({
          ...host,
          cve_summary: {
            total: totalVulns,
            critical: criticalCount,
            high: highCount,
            medium: mediumCount,
            low: lowCount
          },
          vulnerability_count: totalVulns,
          critical_count: criticalCount,
          high_count: highCount,
          medium_count: mediumCount,
          low_count: lowCount,
          risk_level: riskLevel,
          cve_ids: cveIds,
          host_vulnerabilities: hostVulns,
          ai_analysis: generateAIAnalysis(),
          impact: generateImpact(),
          recommendations: generateRecommendations()
        });
      }
    } catch (error) {
      console.error('Failed to fetch host analysis:', error);
      // Fallback with calculated data
      setHostAnalysis({
        ...host,
        cve_summary: {
          total: totalVulns,
          critical: criticalCount,
          high: highCount,
          medium: mediumCount,
          low: lowCount
        },
        vulnerability_count: totalVulns,
        critical_count: criticalCount,
        high_count: highCount,
        medium_count: mediumCount,
        low_count: lowCount,
        risk_level: riskLevel,
        cve_ids: cveIds,
        host_vulnerabilities: hostVulns,
        ai_analysis: generateAIAnalysis(),
        impact: generateImpact(),
        recommendations: generateRecommendations()
      });
    } finally {
      setLoadingHostAnalysis(false);
    }
  };

  // Close host modal
  const closeHostModal = () => {
    setSelectedHost(null);
    setHostAnalysis(null);
  };

  // GreyNoise botnet check for all hosts in this scan
  const checkGreynoise = async () => {
    if (!id || checkingGreynoise) return;
    setCheckingGreynoise(true);
    try {
      const backendUrl = process.env.REACT_APP_API_URL || '';
      const token = localStorage.getItem('access_token');
      const response = await fetch(`${backendUrl}/api/v1/scan/${id}/greynoise`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        // Update results state with per-IP data
        setGreynoiseResults(data.results || {});
        setGreynoiseSummary({
          checked: data.ips_checked?.length || 0,
          botnet_count: data.botnet_ips?.length || 0,
          botnet_ips: data.botnet_ips || [],
          scan_target_ip: data.scan_target_ip,
          scan_target_is_botnet: data.scan_target_is_botnet,
        });
        // Refresh hosts to pick up stored ai_analysis_cache
        const hostsData = await scansApi.getHosts(id).catch(() => []);
        setHosts(Array.isArray(hostsData) ? hostsData : []);
      }
    } catch (err) {
      console.error('GreyNoise check failed:', err);
    } finally {
      setCheckingGreynoise(false);
    }
  };

  // AI Feedback handlers
  const handleAIFeedback = (actionId, feedbackType, comment = '') => {
    setAiFeedbacks(prev => ({
      ...prev,
      [actionId]: {
        type: feedbackType,
        comment,
        timestamp: new Date().toISOString()
      }
    }));

    // Send feedback to backend (mock)
    console.log('AI Feedback submitted:', { actionId, feedbackType, comment });
    setShowFeedbackModal(null);
    setFeedbackComment('');
  };

  const handleStopScan = async () => {
    if (window.confirm(t('scanDetails.stopScanConfirm'))) {
      try {
        await scansApi.stop(id);
        fetchScanDetails();
      } catch (error) {
        console.error('Failed to stop scan:', error);
        alert(t('scanDetails.stopScanFailed'));
      }
    }
  };

  const handleDelete = async () => {
    if (window.confirm(t('scanDetails.deleteScanConfirm'))) {
      try {
        await scansApi.delete(id);
        navigate('/scans');
      } catch (error) {
        alert(t('scanDetails.deleteScanFailed'));
      }
    }
  };

  // Handle retry scan - recreate a new scan with the same configuration
  const handleRetryScan = async () => {
    if (!scan) return;

    if (window.confirm(t('scanDetails.retryScanConfirm'))) {
      try {
        // Prepare scan data from current scan config
        const scanData = {
          target: scan.target,
          scan_type: scan.scan_type,
          config: scan.config || {},
          network_mode: scan.config?.network_mode || 'direct',
        };

        // Create new scan with the same configuration
        const newScan = await scansApi.create(scanData);

        // Navigate to the new scan
        navigate(`/scans/${newScan.id}`);
      } catch (error) {
        console.error('Failed to retry scan:', error);
        alert(t('scanDetails.restartScanFailed'));
      }
    }
  };

  // Handle refresh with visual feedback
  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await fetchScanDetails();
      await fetchScreenshots();
    } finally {
      setTimeout(() => setIsRefreshing(false), 500);
    }
  };

  // Fetch cleanup preview
  const fetchCleanupPreview = async () => {
    try {
      const backendUrl = process.env.REACT_APP_API_URL || '';
      const token = localStorage.getItem('access_token') || localStorage.getItem('token');

      const response = await fetch(`${backendUrl}/api/v1/exploit/scan/${id}/cleanup/preview`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const preview = await response.json();
        setCleanupPreview(preview);
      }
    } catch (error) {
      console.error('Failed to fetch cleanup preview:', error);
    }
  };

  // Handle cleanup with confirmation
  const handleOpenCleanupModal = async () => {
    await fetchCleanupPreview();
    setShowCleanupModal(true);
  };

  // Handle cleanup execution
  const handleCleanup = async (archiveEvidence = false) => {
    setIsCleaning(true);
    try {
      const backendUrl = process.env.REACT_APP_API_URL || '';
      const token = localStorage.getItem('access_token') || localStorage.getItem('token');

      const response = await fetch(`${backendUrl}/api/v1/exploit/scan/${id}/cleanup`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          cleanup_types: ['all'],
          archive_evidence: archiveEvidence
        })
      });

      if (response.ok) {
        const result = await response.json();
        setCleanupResult(result);
        // Refresh scan details after cleanup
        await fetchScanDetails();
      } else {
        const error = await response.json();
        alert(t('scanDetails.cleanupFailed') + ': ' + (error.detail || t('common.error')));
      }
    } catch (error) {
      console.error('Cleanup failed:', error);
      alert(t('scanDetails.cleanupFailed'));
    } finally {
      setIsCleaning(false);
    }
  };

  // Fetch existing schedules and running scans for visualization
  const fetchScheduleVisualizationData = async () => {
    setLoadingScheduleData(true);
    try {
      const backendUrl = process.env.REACT_APP_API_URL || '';
      const token = localStorage.getItem('access_token') || localStorage.getItem('token');

      // Fetch existing schedules
      const schedulesResponse = await fetch(`${backendUrl}/api/v1/schedules?is_active=true&limit=50`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (schedulesResponse.ok) {
        const schedulesData = await schedulesResponse.json();
        setExistingSchedules(schedulesData || []);
      }

      // Fetch running and pending scans
      const scansResponse = await fetch(`${backendUrl}/api/v1/scans?status=running&status=pending&status=waiting&limit=20`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (scansResponse.ok) {
        const scansData = await scansResponse.json();
        setRunningScans(scansData.scans || scansData || []);
      }
    } catch (error) {
      console.error('Failed to fetch schedule data:', error);
    } finally {
      setLoadingScheduleData(false);
    }
  };

  // Fetch schedule data when modal opens
  useEffect(() => {
    if (showScheduleModal) {
      fetchScheduleVisualizationData();
    }
  }, [showScheduleModal]);

  // Handle schedule creation
  const handleCreateSchedule = async () => {
    if (!scan) return;

    setIsScheduling(true);
    try {
      const backendUrl = process.env.REACT_APP_API_URL || '';
      const token = localStorage.getItem('access_token') || localStorage.getItem('token');

      // Get workspace ID from scan (try all possible fields)
      const workspaceId = scan.workspaces?.[0]?.id
        || scan.workspace_id
        || scan.config?.workspace_id;

      if (!workspaceId) {
        alert(t('scans.noWorkspaceForScan'));
        return;
      }

      // Map scan_type to schedule-compatible types
      const scanTypeMapping = {
        'full_autonomous': 'full',
        'network_discovery': 'quick',
        'vulnerability_scan': 'vulnerability',
        'api_pentest': 'web_scan'
      };
      const scheduleScanType = scanTypeMapping[scan.scan_type] || scan.scan_type || 'full';

      const scheduleData = {
        name: `Recurring scan - ${scan.target}`,
        description: `Automated scheduled scan for ${scan.target}`,
        workspace_id: workspaceId,
        scan_type: scheduleScanType,
        targets: [scan.target],
        scan_options: {
          ...(scan.config || {}),
          report_formats: scheduleConfig.report_formats // Store all selected formats in options
        },
        frequency: scheduleConfig.frequency,
        days_of_week: ['weekly', 'monthly', 'quarterly', 'semestrial', 'yearly'].includes(scheduleConfig.frequency) ? scheduleConfig.days_of_week : null,
        time_of_day: scheduleConfig.time_of_day,
        timezone: 'Europe/Paris',
        auto_generate_report: scheduleConfig.auto_generate_report,
        report_format: scheduleConfig.report_formats[0] || 'pdf', // Primary format for backend
        send_notifications: true,
        notify_on_complete: true,
        notify_on_critical: true,
        max_runs: scheduleConfig.has_end ? scheduleConfig.max_runs : null
      };

      const response = await fetch(`${backendUrl}/api/v1/schedules`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(scheduleData)
      });

      if (response.ok) {
        const result = await response.json();
        alert(`Scan scheduled successfully! Next run: ${new Date(result.next_run).toLocaleString(undefined)}`);
        setShowScheduleModal(false);
      } else {
        const errorData = await response.json();
        const errorMessage = typeof errorData.detail === 'string'
          ? errorData.detail
          : errorData.detail?.msg || errorData.message || JSON.stringify(errorData.detail) || 'Unable to create schedule';
        alert(`${t('errors.generic')}: ${errorMessage}`);
      }
    } catch (error) {
      console.error('Failed to create schedule:', error);
      alert(t('scans.scheduleError'));
    } finally {
      setIsScheduling(false);
    }
  };

  const toggleDayOfWeek = (day) => {
    setScheduleConfig(prev => {
      const days = prev.days_of_week || [];
      if (days.includes(day)) {
        // Don't allow deselecting the last day
        if (days.length <= 1) {
          return prev;
        }
        return { ...prev, days_of_week: days.filter(d => d !== day) };
      } else {
        return { ...prev, days_of_week: [...days, day].sort() };
      }
    });
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  const handleScreenshotClick = async (screenshot) => {
    setScreenshotZoom(1);

    // If it's a console capture (.txt file), load the content
    const isConsole = screenshot.type === 'console' || screenshot.path?.endsWith('.txt');
    if (isConsole && screenshot.path) {
      try {
        const backendUrl = process.env.REACT_APP_API_URL || '';
        const response = await fetch(`${backendUrl}${screenshot.path}`);
        const content = await response.text();
        setSelectedScreenshot({ ...screenshot, content, isConsole: true });
      } catch (error) {
        console.error('Failed to load console content:', error);
        setSelectedScreenshot({ ...screenshot, content: t('scans.screenshotLoadError'), isConsole: true });
      }
    } else {
      setSelectedScreenshot({ ...screenshot, isConsole: false });
    }
  };

  const handleZoomIn = () => setScreenshotZoom(prev => Math.min(prev + 0.25, 3));
  const handleZoomOut = () => setScreenshotZoom(prev => Math.max(prev - 0.25, 0.5));

  // Capture console content as screenshot
  const handleCaptureConsole = async () => {
    if (!consoleRef.current || consoleLogs.length === 0) return;

    setIsCapturing(true);
    try {
      const backendUrl = process.env.REACT_APP_API_URL || '';
      const token = localStorage.getItem('access_token');

      // Get last 50 lines of console logs
      const logsToCapture = consoleLogs.slice(-50).map(log => ({
        timestamp: log.timestamp,
        tool: log.tool || 'system',
        content: log.content || log.message || ''
      }));

      const response = await fetch(`${backendUrl}/api/v1/scan/${id}/capture-console`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          logs: logsToCapture,
          description: `Console capture - ${new Date().toLocaleString('fr-FR')}`
        })
      });

      if (response.ok) {
        // Refresh screenshots to show new capture
        await fetchScreenshots();
        // Brief visual feedback
        alert('Capture added to screenshots!');
      } else {
        console.error('Failed to capture console');
      }
    } catch (error) {
      console.error('Error capturing console:', error);
    } finally {
      setIsCapturing(false);
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      completed: 'bg-brand-green/20 text-brand-green border-brand-green/50',
      running: 'bg-blue-500/20 text-blue-400 border-blue-500/50',
      waiting: 'bg-orange-500/20 text-orange-400 border-orange-500/50',
      pending: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/50',
      failed: 'bg-red-500/20 text-red-400 border-red-500/50',
    };
    return colors[status] || 'bg-gray-500/20 text-gray-400 border-gray-500/50';
  };

  const getSeverityBadgeClass = (severity) => {
    const classes = {
      critical: 'bg-severity-critical/20 text-severity-critical border-severity-critical/50',
      high: 'bg-severity-high/20 text-severity-high border-severity-high/50',
      medium: 'bg-severity-medium/20 text-severity-medium border-severity-medium/50',
      low: 'bg-severity-low/20 text-severity-low border-severity-low/50',
    };
    return classes[severity] || 'bg-gray-500/20 text-gray-400 border-gray-500/50';
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-brand-black flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-brand-green border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-400">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  if (!scan) {
    return (
      <div className="min-h-screen bg-brand-black p-6">
        <div className="w-[95%] sm:w-[92%] lg:w-[88%] laptop:w-[85%] 2xl:w-[80%] max-w-[1600px] laptop:max-w-[1700px] 2xl:max-w-[1800px] mx-auto">
          <div className="text-center py-20">
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-white mb-2">{t('scans.notFound')}</h2>
            <p className="text-gray-400 mb-6">{t('scans.notFoundDesc')}</p>
            <button onClick={() => navigate('/scans')} className="px-6 py-3 bg-brand-green text-black rounded-lg font-medium hover:bg-brand-green/90">
              {t('scans.backToScans')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Full-page queue waiting view when scan is queued
  if (scan.status === 'queued') {
    return (
      <div className="min-h-screen bg-brand-black p-6">
        <div className="w-[80%] max-w-[1200px] mx-auto">
          {/* Header */}
          <div className="flex items-center gap-4 mb-8">
            <button
              onClick={() => navigate('/scans')}
              className="p-2.5 bg-brand-black-light border border-gray-700 hover:border-brand-green/50 rounded-lg transition-colors"
            >
              <ArrowLeft className="w-5 h-5 text-gray-400 hover:text-brand-green" />
            </button>
            <div>
              <h1 className="text-3xl font-bold text-white">{scan.target}</h1>
              <div className="flex items-center gap-3 mt-1">
                <span className="px-3 py-1 bg-amber-500/20 text-amber-400 border border-amber-500/50 rounded-full text-sm">
                  {t('scanDetails.queuedStatus')}
                </span>
                <span className="text-sm text-gray-500">
                  Type: <span className="text-white">{translateScanType(scan.scan_type)}</span>
                </span>
              </div>
            </div>
          </div>

          {/* Main Queue Card */}
          <div className="bg-gradient-to-br from-amber-500/5 to-brand-black border border-amber-500/30 rounded-2xl overflow-hidden">
            {/* Animated Header Bar */}
            <div className="h-1 bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 animate-pulse"></div>

            <div className="p-8">
              {/* Icon and Title */}
              <div className="text-center mb-8">
                <div className="relative inline-flex items-center justify-center mb-4">
                  {/* Animated ring around icon */}
                  <div className="absolute inset-0 w-24 h-24 rounded-full border-4 border-amber-500/30 animate-ping" style={{ animationDuration: '2s' }}></div>
                  <div className="absolute inset-0 w-24 h-24 rounded-full border-2 border-amber-500/50 animate-pulse"></div>
                  {/* Main icon */}
                  <div className="relative w-24 h-24 rounded-full bg-amber-500/20 flex items-center justify-center">
                    <Clock className="w-12 h-12 text-amber-400" />
                  </div>
                  {/* Position badge */}
                  <div className="absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-brand-black border-2 border-amber-500 flex items-center justify-center">
                    <span className="text-amber-400 font-bold text-sm">
                      {loadingQueueInfo ? '...' : (queueInfo?.position || '1')}
                    </span>
                  </div>
                </div>
                <h2 className="text-2xl font-bold text-white mb-2">{t('scans.details.queuedTitle')}</h2>
                <p className="text-gray-400 max-w-xl mx-auto">
                  {t('scans.details.queuedDesc')}
                </p>
              </div>

              {/* Queue Stats */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                <div className="bg-brand-black-light rounded-xl p-5 border border-amber-500/20 text-center">
                  <div className="text-4xl font-bold text-amber-400 mb-1">
                    {loadingQueueInfo ? '...' : (queueInfo?.position || 1)}
                  </div>
                  <div className="text-sm text-gray-400">{t('scans.details.queuePosition')}</div>
                </div>
                <div className="bg-brand-black-light rounded-xl p-5 border border-gray-700 text-center">
                  <div className="text-4xl font-bold text-white mb-1">
                    {loadingQueueInfo ? '...' : (queueInfo?.estimated_wait_minutes
                      ? `~${queueInfo.estimated_wait_minutes}`
                      : '< 5')}
                  </div>
                  <div className="text-sm text-gray-400">{t('scans.details.estimatedWait')}</div>
                </div>
                <div className="bg-brand-black-light rounded-xl p-5 border border-gray-700 text-center">
                  <div className="text-4xl font-bold text-white mb-1">
                    {loadingQueueInfo ? '...' : (queueInfo?.active_scans || 0)}
                  </div>
                  <div className="text-sm text-gray-400">{t('scans.details.runningScans')}</div>
                </div>
              </div>

              {/* Progress Timeline */}
              <div className="mb-8">
                <div className="flex items-center justify-between mb-4">
                  {/* Step 1: En attente */}
                  <div className="flex flex-col items-center">
                    <div className="w-12 h-12 rounded-full bg-amber-500 flex items-center justify-center mb-2 shadow-lg shadow-amber-500/30">
                      <Clock className="w-6 h-6 text-black" />
                    </div>
                    <span className="text-sm font-medium text-amber-400">{t('scans.details.statusQueued')}</span>
                    <span className="text-xs text-gray-500">{t('scans.details.currentStep')}</span>
                  </div>

                  {/* Connector */}
                  <div className="flex-1 h-1 bg-gray-700 mx-4 relative">
                    <div className="absolute left-0 top-0 h-full w-0 bg-amber-500 animate-pulse"></div>
                  </div>

                  {/* Step 2: Start */}
                  <div className="flex flex-col items-center opacity-50">
                    <div className="w-12 h-12 rounded-full bg-gray-700 flex items-center justify-center mb-2">
                      <Play className="w-6 h-6 text-gray-400" />
                    </div>
                    <span className="text-sm font-medium text-gray-400">{t('scans.details.statusStarting')}</span>
                    <span className="text-xs text-gray-600">{t('scans.details.soon')}</span>
                  </div>

                  {/* Connector */}
                  <div className="flex-1 h-1 bg-gray-700 mx-4"></div>

                  {/* Step 3: Scan en cours */}
                  <div className="flex flex-col items-center opacity-50">
                    <div className="w-12 h-12 rounded-full bg-gray-700 flex items-center justify-center mb-2">
                      <Activity className="w-6 h-6 text-gray-400" />
                    </div>
                    <span className="text-sm font-medium text-gray-400">{t('scans.stepInProgress')}</span>
                    <span className="text-xs text-gray-600">{t('scans.stepWaiting')}</span>
                  </div>

                  {/* Connector */}
                  <div className="flex-1 h-1 bg-gray-700 mx-4"></div>

                  {/* Step 4: Completed */}
                  <div className="flex flex-col items-center opacity-50">
                    <div className="w-12 h-12 rounded-full bg-gray-700 flex items-center justify-center mb-2">
                      <CheckCircle className="w-6 h-6 text-gray-400" />
                    </div>
                    <span className="text-sm font-medium text-gray-400">{t('scans.stepCompleted')}</span>
                    <span className="text-xs text-gray-600">{t('scans.stepWaiting')}</span>
                  </div>
                </div>
              </div>

              {/* Info Box */}
              <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-5 mb-8">
                <div className="flex items-start gap-4">
                  <Info className="w-6 h-6 text-blue-400 flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="text-white font-medium mb-2">{t('scanDetails.queueHowItWorks')}</h4>
                    <ul className="text-sm text-gray-400 space-y-2">
                      <li className="flex items-start gap-2">
                        <span className="text-blue-400">•</span>
                        {t('scanDetails.queueOrdered')}
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-blue-400">•</span>
                        {t('scanDetails.queueAutoUpdate')}
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-blue-400">•</span>
                        {t('scanDetails.queueAutoStart')}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Upgrade CTA */}
              <div className="bg-gradient-to-r from-brand-green/10 to-emerald-500/10 border border-brand-green/30 rounded-xl p-6">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-brand-green/20 rounded-lg flex-shrink-0">
                    <Sparkles className="w-6 h-6 text-brand-green" />
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-semibold text-white mb-2">{t('scanDetails.accelerateScans')}</h4>
                    <p className="text-gray-400 text-sm mb-4">
                      {t('scanDetails.accelerateDesc')}
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                      <div className="bg-brand-black-light/50 rounded-lg p-4 border border-gray-700">
                        <div className="flex items-center gap-2 mb-2">
                          <TrendingUp className="w-5 h-5 text-brand-green" />
                          <span className="font-medium text-white">{t('scanDetails.proPlanOption')}</span>
                        </div>
                        <p className="text-xs text-gray-400">
                          {t('scanDetails.proPlanDesc')}
                        </p>
                      </div>
                      <div className="bg-brand-black-light/50 rounded-lg p-4 border border-gray-700">
                        <div className="flex items-center gap-2 mb-2">
                          <Server className="w-5 h-5 text-brand-green" />
                          <span className="font-medium text-white">{t('scanDetails.dedicatedServer')}</span>
                        </div>
                        <p className="text-xs text-gray-400">
                          {t('scanDetails.dedicatedServerDesc')}
                        </p>
                      </div>
                    </div>
                    <div className="flex gap-3">
                      <button
                        onClick={() => navigate('/pricing')}
                        className="px-5 py-2.5 bg-brand-green text-black font-medium rounded-lg hover:bg-brand-green/90 transition-colors flex items-center gap-2"
                      >
                        <TrendingUp className="w-4 h-4" />
                        {t('scanDetails.viewPlans')}
                      </button>
                      <button
                        onClick={() => navigate('/dedicated-server')}
                        className="px-5 py-2.5 bg-brand-black-light text-gray-300 font-medium rounded-lg border border-gray-600 hover:bg-gray-800 transition-colors flex items-center gap-2"
                      >
                        <Server className="w-4 h-4" />
                        {t('scanDetails.dedicatedServer')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Scan Config Summary */}
          <div className="mt-6 bg-brand-black-light border border-gray-700 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
              <Settings className="w-5 h-5 text-gray-400" />
              {t('scanDetails.scanConfiguration')}
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div>
                <div className="text-xs text-gray-500 mb-1">{t('scanDetails.target')}</div>
                <div className="text-white font-medium">{scan.target}</div>
              </div>
              <div>
                <div className="text-xs text-gray-500 mb-1">{t('scanDetails.scanType')}</div>
                <div className="text-white font-medium">{translateScanType(scan.scan_type)}</div>
              </div>
              <div>
                <div className="text-xs text-gray-500 mb-1">{t('scanDetails.createdAt')}</div>
                <div className="text-white font-medium">
                  {new Date(scan.created_at).toLocaleString()}
                </div>
              </div>
              <div>
                <div className="text-xs text-gray-500 mb-1">{t('scanDetails.intensity')}</div>
                <div className="text-white font-medium">{scan.config?.intensity || t('osint.scanTypes.standard')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-brand-black p-6">
      <div className="w-[95%] sm:w-[92%] lg:w-[88%] laptop:w-[85%] 2xl:w-[80%] max-w-[1600px] laptop:max-w-[1700px] 2xl:max-w-[1800px] mx-auto space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/scans')}
              className="p-2.5 bg-brand-black-light border border-gray-700 hover:border-brand-green/50 rounded-lg transition-colors"
            >
              <ArrowLeft className="w-5 h-5 text-gray-400 hover:text-brand-green" />
            </button>
            <div>
              <h1 className="text-4xl font-bold text-gradient-green">{scan.target}</h1>
              <div className="flex items-center gap-3 mt-2">
                <span className={`badge border inline-flex items-center ${getStatusColor(scan.status)}`}>
                  {scan.status === 'running' && (
                    <span className="w-2 h-2 bg-blue-400 rounded-full mr-2 animate-pulse"></span>
                  )}
                  {scan.status}
                </span>
                <span className="text-sm text-gray-500">
                  {t('scans.scanType')}: <span className="text-white">{translateScanType(scan.scan_type)}</span>
                </span>
                {scan.status === 'running' && (
                  <span className="text-sm text-blue-400 flex items-center gap-1">
                    <Activity className="w-4 h-4 animate-pulse" />
                    {t('scans.status.running')}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            {/* Config Summary Button */}
            <button
              onClick={() => setShowConfigModal(true)}
              className="px-4 py-2.5 bg-gradient-to-r from-orange-500/20 to-amber-500/20 border border-orange-500/50 rounded-lg hover:from-orange-500/30 hover:to-amber-500/30 transition-all flex items-center gap-2"
              title={t('scanDetails.viewScanConfig')}
            >
              <Settings className="w-5 h-5 text-orange-400" />
              <span className="text-sm font-medium text-orange-300">Configuration</span>
            </button>
            {/* PDF Report */}
            {scan.status === 'completed' && (
              <button
                onClick={async () => {
                  try {
                    const token = localStorage.getItem('access_token');
                    const res = await fetch(`/api/v1/reports/scan/${scan.id}/generate?format=pdf`, {
                      method: 'POST',
                      headers: { 'Authorization': `Bearer ${token}` }
                    });
                    if (!res.ok) throw new Error(`${t('errors.serverError')} ${res.status}`);
                    const blob = await res.blob();
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `report_${scan.target}_${new Date().toISOString().slice(0,10)}.pdf`;
                    a.click();
                    URL.revokeObjectURL(url);
                  } catch (e) {
                    alert(`${t('scans.pdfGenerationError')}: ${e.message}`);
                  }
                }}
                className="px-4 py-2.5 bg-gradient-to-r from-red-500/20 to-pink-500/20 border border-red-500/50 rounded-lg hover:from-red-500/30 hover:to-pink-500/30 transition-all flex items-center gap-2"
                title={t('scanDetails.downloadPdfReport')}
              >
                <Download className="w-5 h-5 text-red-400" />
                <span className="text-sm font-medium text-red-300">{t('scanDetails.pdfReport')}</span>
              </button>
            )}
            {/* Retry Button - only for failed scans */}
            {scan.status === 'failed' && (
              <LicenseGatedButton
                onClick={handleRetryScan}
                feature="scans"
                className="px-4 py-2.5 bg-gradient-to-r from-green-500/20 to-emerald-500/20 border border-green-500/50 rounded-lg hover:from-green-500/30 hover:to-emerald-500/30 transition-all flex items-center gap-2"
                title={t('scanDetails.relaunchScan')}
              >
                <Repeat className="w-5 h-5 text-green-400" />
                <span className="text-sm font-medium text-green-300">{t('scanDetails.relaunch')}</span>
              </LicenseGatedButton>
            )}
            {/* Schedule Button */}
            <button
              onClick={() => setShowScheduleModal(true)}
              className="px-4 py-2.5 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-500/50 rounded-lg hover:from-cyan-500/30 hover:to-blue-500/30 transition-all flex items-center gap-2"
              title={t('scanDetails.scheduleScan')}
            >
              <Calendar className="w-5 h-5 text-cyan-400" />
              <span className="text-sm font-medium text-cyan-300">{t('scanDetails.schedule')}</span>
            </button>
            <button
              onClick={handleRefresh}
              disabled={isRefreshing}
              className={`p-2.5 bg-brand-black-light border border-brand-green/50 rounded-lg hover:bg-brand-green/10 transition-colors ${isRefreshing ? 'opacity-50' : ''}`}
              title={t('scanDetails.refresh')}
            >
              <RefreshCcw className={`w-5 h-5 text-brand-green ${isRefreshing ? 'animate-spin' : ''}`} />
            </button>
            {(scan.status === 'running' || scan.status === 'pending' || scan.status === 'waiting') && (
              <button
                onClick={handleStopScan}
                className="p-2.5 bg-orange-500/20 text-orange-400 border border-orange-500/50 rounded-lg hover:bg-orange-500/30 transition-colors flex items-center gap-2"
                title={t('scans.stopScan')}
              >
                <Pause className="w-5 h-5" />
                <span className="text-sm font-medium">{t('scans.stopScan')}</span>
              </button>
            )}
            {/* Nettoyage — hidden */}
            <button
              onClick={handleDelete}
              className="p-2.5 bg-red-500/20 text-red-400 border border-red-500/50 rounded-lg hover:bg-red-500/30 transition-colors"
              title={t('common.delete')}
            >
              <Trash2 className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Error Banner for Failed Scans */}
        {scan.status === 'failed' && (
          <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-6">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-red-500/20 rounded-lg flex-shrink-0">
                <XCircle className="w-6 h-6 text-red-400" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-red-400 mb-2">
                  {t('scans.scanFailed') || 'Scan failed'}
                </h3>
                <p className="text-gray-300 mb-3">
                  {toSafeString(scan.error_message) || t('scans.genericError') || 'An error occurred during the scan. Check network connectivity and target settings.'}
                </p>
                {scan.error_details && (
                  <details className="mt-3">
                    <summary className="text-sm text-gray-400 cursor-pointer hover:text-gray-300 flex items-center gap-2">
                      <Info className="w-4 h-4" />
                      {t('scans.technicalDetails') || 'Technical details'}
                    </summary>
                    <pre className="mt-2 p-3 bg-brand-black-light rounded-lg text-xs text-gray-500 overflow-x-auto whitespace-pre-wrap font-mono">
                      {toSafeString(scan.error_details)}
                    </pre>
                  </details>
                )}
                <div className="mt-4 flex gap-3">
                  <LicenseGatedButton
                    onClick={handleRetryScan}
                    feature="scans"
                    className="px-4 py-2 bg-brand-green text-black rounded-lg font-medium hover:bg-brand-green/90 transition-colors flex items-center gap-2"
                  >
                    <Repeat className="w-4 h-4" />
                    {t('scans.retryScan') || 'Retry scan'}
                  </LicenseGatedButton>
                  <LicenseGatedButton
                    onClick={() => navigate('/scans/new')}
                    feature="scans"
                    className="px-4 py-2 bg-brand-black-light text-gray-300 border border-gray-600 rounded-lg font-medium hover:bg-gray-800 transition-colors flex items-center gap-2"
                  >
                    <Play className="w-4 h-4" />
                    {t('dashboard.newScan')}
                  </LicenseGatedButton>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* VPN Connection Warning Banner - Only show on VPN-related errors */}
        {scan.status === 'failed' && scan.error_message && (scan.error_message.toLowerCase().includes('vpn') || scan.error_message.toLowerCase().includes('tunnel')) && (
          <div className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-6 mb-4">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-amber-500/20 rounded-lg flex-shrink-0">
                <Shield className="w-6 h-6 text-amber-400" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-amber-400 mb-2">
                  {t('scanDetails.vpnConnectionRequired')}
                </h3>
                <p className="text-gray-300 mb-3">
                  {t('scanDetails.vpnConnectionRequired2')} <span className="font-mono text-amber-300">{scan.target}</span>.
                  {t('scans.noVpnSession')}
                </p>
                <p className="text-gray-400 text-sm mb-4">
                  {t('scanDetails.vpnConnectInstructions')}
                </p>
                <div className="flex flex-wrap gap-3">
                  <button
                    onClick={() => navigate(`/workspaces/${scan.workspace_id || scan.workspaces?.[0]?.id}?tab=vpn`)}
                    className="px-4 py-2 bg-amber-500 text-black rounded-lg font-medium hover:bg-amber-400 transition-colors flex items-center gap-2"
                  >
                    <Shield className="w-4 h-4" />
                    {t('scanDetails.configureVpn')}
                  </button>
                  <button
                    onClick={() => navigate('/workspaces')}
                    className="px-4 py-2 bg-brand-black-light text-gray-300 border border-gray-600 rounded-lg font-medium hover:bg-gray-800 transition-colors flex items-center gap-2"
                  >
                    <ArrowLeft className="w-4 h-4" />
                    {t('scanDetails.viewWorkspaces')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Stats Grid with Rich Tooltips */}
        <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
          {/* Hosts */}
          <div className="bg-gradient-to-br from-brand-green/20 to-brand-black border border-brand-green/30 rounded-xl p-4 hover:border-brand-green/50 transition-all relative group cursor-help">
            <div className="flex items-center gap-2 mb-2">
              <Server className="w-4 h-4 text-brand-green" />
              <span className="text-sm text-gray-400">{t('scanDetails.hostsLabel')}</span>
            </div>
            <div className="text-3xl font-bold text-white">{stats?.hosts?.total || hosts.length || 0}</div>
            {/* Tooltip */}
            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-72 p-3 bg-brand-black border border-brand-green/30 rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
              <div className="flex items-center gap-2 mb-2">
                <Server className="w-4 h-4 text-brand-green" />
                <span className="font-semibold text-white">{t('scanDetails.hostsDiscovered')}</span>
              </div>
              <p className="text-xs text-gray-300">{t('scanDetails.hostsDiscoveredDesc')}</p>
            </div>
          </div>

          {/* Vulnerabilities Total */}
          <div className="bg-gradient-to-br from-gray-800/50 to-brand-black border border-gray-600/30 rounded-xl p-4 hover:border-gray-500/50 transition-all relative group cursor-help">
            <div className="flex items-center gap-2 mb-2">
              <AlertTriangle className="w-4 h-4 text-gray-400" />
              <span className="text-sm text-gray-400">{t('scanDetails.vulnerabilitiesLabel')}</span>
            </div>
            <div className="text-3xl font-bold text-white">{stats?.vulnerabilities?.total || vulnerabilities.length || 0}</div>
            {/* Tooltip */}
            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-72 p-3 bg-brand-black border border-gray-600/30 rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
              <div className="flex items-center gap-2 mb-2">
                <AlertTriangle className="w-4 h-4 text-gray-400" />
                <span className="font-semibold text-white">{t('scanDetails.totalVulnerabilities')}</span>
              </div>
              <p className="text-xs text-gray-300">{t('scanDetails.totalVulnerabilitiesDesc')}</p>
            </div>
          </div>

          {/* Critical */}
          <div className="bg-gradient-to-br from-red-900/30 to-brand-black border border-red-500/30 rounded-xl p-4 hover:border-red-500/50 transition-all relative group cursor-help">
            <div className="flex items-center gap-2 mb-2">
              <AlertTriangle className="w-4 h-4 text-red-500" />
              <span className="text-sm text-gray-400">{t('scanDetails.criticalLabel')}</span>
            </div>
            <div className="text-3xl font-bold text-red-500">{stats?.vulnerabilities?.critical || cyberScore?.vulnCounts?.critical || 0}</div>
            <div className="text-xs text-red-500/60 mt-1">{t('scans.details.cvssRangeCritical')}</div>
            {/* Tooltip */}
            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-72 p-3 bg-brand-black border border-red-500/30 rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
              <div className="flex items-center gap-2 mb-2">
                <AlertTriangle className="w-4 h-4 text-red-500" />
                <span className="font-semibold text-white">{t('scanDetails.criticalVulnerabilities')}</span>
              </div>
              <p className="text-xs text-gray-300">{t('scanDetails.criticalVulnerabilitiesDesc')} <span className="text-red-400 font-semibold">{t('scanDetails.immediateActionRequired')}</span></p>
            </div>
          </div>

          {/* High */}
          <div className="bg-gradient-to-br from-orange-900/30 to-brand-black border border-orange-500/30 rounded-xl p-4 hover:border-orange-500/50 transition-all relative group cursor-help">
            <div className="flex items-center gap-2 mb-2">
              <Shield className="w-4 h-4 text-orange-500" />
              <span className="text-sm text-gray-400">{t('scanDetails.highLabel')}</span>
            </div>
            <div className="text-3xl font-bold text-orange-500">{stats?.vulnerabilities?.high || cyberScore?.vulnCounts?.high || 0}</div>
            <div className="text-xs text-orange-500/60 mt-1">{t('scans.details.cvssRangeHigh')}</div>
            {/* Tooltip */}
            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-72 p-3 bg-brand-black border border-orange-500/30 rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
              <div className="flex items-center gap-2 mb-2">
                <Shield className="w-4 h-4 text-orange-500" />
                <span className="font-semibold text-white">{t('vulnerabilities.attackChain.stages.initialAccess')}</span>
              </div>
              <p className="text-xs text-gray-300">{t('scanDetails.highVulnsDesc')}</p>
            </div>
          </div>

          {/* Medium */}
          <div className="bg-gradient-to-br from-yellow-900/30 to-brand-black border border-yellow-500/30 rounded-xl p-4 hover:border-yellow-500/50 transition-all relative group cursor-help">
            <div className="flex items-center gap-2 mb-2">
              <Activity className="w-4 h-4 text-yellow-500" />
              <span className="text-sm text-gray-400">{t('scanDetails.mediumLabel')}</span>
            </div>
            <div className="text-3xl font-bold text-yellow-500">{stats?.vulnerabilities?.medium || cyberScore?.vulnCounts?.medium || 0}</div>
            <div className="text-xs text-yellow-500/60 mt-1">{t('scans.details.cvssRangeMedium')}</div>
            {/* Tooltip */}
            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-72 p-3 bg-brand-black border border-yellow-500/30 rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
              <div className="flex items-center gap-2 mb-2">
                <Activity className="w-4 h-4 text-yellow-500" />
                <span className="font-semibold text-white">{t('scanDetails.mediumLabel')}</span>
              </div>
              <p className="text-xs text-gray-300">{t('scanDetails.mediumVulnsDesc')}</p>
            </div>
          </div>

          {/* Low */}
          <div className="bg-gradient-to-br from-blue-900/30 to-brand-black border border-blue-500/30 rounded-xl p-4 hover:border-blue-500/50 transition-all relative group cursor-help">
            <div className="flex items-center gap-2 mb-2">
              <Target className="w-4 h-4 text-blue-400" />
              <span className="text-sm text-gray-400">{t('scanDetails.lowLabel')}</span>
            </div>
            <div className="text-3xl font-bold text-blue-400">{stats?.vulnerabilities?.low || cyberScore?.vulnCounts?.low || 0}</div>
            <div className="text-xs text-blue-500/60 mt-1">{t('scans.details.cvssRangeLow')}</div>
            {/* Tooltip */}
            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-72 p-3 bg-brand-black border border-blue-500/30 rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
              <div className="flex items-center gap-2 mb-2">
                <Target className="w-4 h-4 text-blue-400" />
                <span className="font-semibold text-white">{t('scanDetails.lowLabel')}</span>
              </div>
              <p className="text-xs text-gray-300">{t('scanDetails.lowVulnsDesc')}</p>
            </div>
          </div>
        </div>

        {/* Scan Info with CyberScore */}
        <div className="bg-brand-black-light rounded-xl border border-brand-green/30 overflow-hidden">
          <div
            className="p-4 border-b border-gray-800 flex items-center justify-between cursor-pointer"
            onClick={() => toggleSection('info')}
          >
            <h2 className="text-xl font-bold text-brand-green flex items-center gap-2">
              <Info className="w-5 h-5" />
              Scan Information
            </h2>
            {expandedSections.info ? <ChevronUp className="w-5 h-5 text-gray-400" /> : <ChevronDown className="w-5 h-5 text-gray-400" />}
          </div>

          {expandedSections.info && (
            <div className="p-6">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* Left: VPN & Scan Details */}
                <div className="space-y-3">
                  {/* Connection Status - VPS/VPN Block */}
                  <div className={`bg-brand-black rounded-xl p-4 border ${vpsInfo?.vps?.vpn_enabled ? 'border-green-500/50' : 'border-blue-500/30'} relative overflow-hidden`}>
                    <div className="absolute top-0 right-0 w-32 h-32 opacity-10">
                      <div className={`w-full h-full rounded-bl-full bg-gradient-to-br ${vpsInfo?.vps?.vpn_enabled ? 'from-green-400 to-green-600' : 'from-blue-400 to-blue-600'}`}></div>
                    </div>
                    <div className="flex items-center gap-3 mb-3">
                      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${vpsInfo?.vps?.vpn_enabled ? 'bg-gradient-to-br from-green-500 to-green-600' : 'bg-gradient-to-br from-blue-500 to-blue-600'}`}>
                        {vpsInfo?.vps?.vpn_enabled ? <Shield className="w-5 h-5 text-white" /> : <Server className="w-5 h-5 text-white" />}
                      </div>
                      <div>
                        <div className="text-xs text-gray-500 uppercase">{vpsInfo?.vps?.vpn_enabled ? t('scanDetails.vpnConnection') : t('scanDetails.scanServer')}</div>
                        <div className="flex items-center gap-2">
                          <div className={`w-2 h-2 rounded-full ${vpsInfo?.vps?.vpn_enabled ? 'bg-green-500 animate-pulse' : 'bg-blue-500'}`}></div>
                          <span className={`${vpsInfo?.vps?.vpn_enabled ? 'text-green-400' : 'text-blue-400'} font-bold`}>
                            {vpsInfo?.vps?.vpn_enabled ? t('scanDetails.vpnActive') : t('scanDetails.directConnection')}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="space-y-2">
                      {/* Server Name */}
                      <div className="bg-gray-900/50 rounded-lg p-2">
                        <div className="flex items-center gap-1.5 mb-0.5">
                          <Server className="w-3 h-3 text-gray-400" />
                          <span className="text-[10px] text-gray-500 uppercase">{vpsInfo?.vps?.vpn_enabled ? t('scanDetails.vpnServer') : t('common.status')}</span>
                        </div>
                        <div className="text-white text-xs font-semibold">
                          {vpsInfo?.vps?.name || 'Sylink Infrastructure'}
                        </div>
                        {vpsInfo?.vps?.vpn_provider && (
                          <div className="text-[10px] text-green-400 mt-0.5 flex items-center gap-1">
                            <Shield className="w-2.5 h-2.5" />
                            {vpsInfo.vps.vpn_provider}
                          </div>
                        )}
                      </div>
                      <div className="grid grid-cols-2 gap-2">
                        <div className="bg-gray-900/50 rounded-lg p-2">
                          <div className="flex items-center gap-1.5 mb-0.5">
                            <Globe className="w-3 h-3 text-gray-400" />
                            <span className="text-[10px] text-gray-500 uppercase">{t('scans.details.exitIp')}</span>
                          </div>
                          <div className="text-white font-mono text-xs">
                            {vpsInfo?.vps?.vpn_public_ip || '185.246.84.182'}
                          </div>
                        </div>
                        <div className="bg-gray-900/50 rounded-lg p-2">
                          <div className="flex items-center gap-1.5 mb-0.5">
                            <MapPin className="w-3 h-3 text-gray-400" />
                            <span className="text-[10px] text-gray-500 uppercase">{t('scans.details.location')}</span>
                          </div>
                          <div className="text-white text-xs flex items-center gap-1.5">
                            <span className="text-base">
                              {vpsInfo?.vps?.vpn_country_code === 'INTERNAL' ? '🔒' :
                               vpsInfo?.vps?.vpn_country_code === 'FR' ? '🇫🇷' :
                               vpsInfo?.vps?.vpn_country_code === 'DE' ? '🇩🇪' :
                               vpsInfo?.vps?.vpn_country_code === 'NL' ? '🇳🇱' :
                               vpsInfo?.vps?.vpn_country_code === 'BE' ? '🇧🇪' :
                               vpsInfo?.vps?.vpn_country_code === 'CH' ? '🇨🇭' :
                               vpsInfo?.vps?.vpn_country_code === 'GB' ? '🇬🇧' :
                               vpsInfo?.vps?.vpn_country_code === 'US' ? '🇺🇸' :
                               vpsInfo?.vps?.vpn_country_code === 'CA' ? '🇨🇦' :
                               vpsInfo?.vps?.vpn_country_code === 'ES' ? '🇪🇸' :
                               vpsInfo?.vps?.vpn_country_code === 'IT' ? '🇮🇹' :
                               vpsInfo?.vps?.vpn_country_code === 'PT' ? '🇵🇹' :
                               vpsInfo?.vps?.vpn_country_code === 'PL' ? '🇵🇱' :
                               vpsInfo?.vps?.vpn_country_code === 'AT' ? '🇦🇹' :
                               vpsInfo?.vps?.vpn_country_code === 'SE' ? '🇸🇪' :
                               vpsInfo?.vps?.vpn_country_code === 'NO' ? '🇳🇴' :
                               vpsInfo?.vps?.vpn_country_code === 'DK' ? '🇩🇰' :
                               vpsInfo?.vps?.vpn_country_code === 'FI' ? '🇫🇮' :
                               vpsInfo?.vps?.vpn_country_code === 'IE' ? '🇮🇪' :
                               vpsInfo?.vps?.vpn_country_code === 'JP' ? '🇯🇵' :
                               vpsInfo?.vps?.vpn_country_code === 'SG' ? '🇸🇬' :
                               vpsInfo?.vps?.vpn_country_code === 'AU' ? '🇦🇺' : '🌍'}
                            </span>
                            {vpsInfo?.vps?.vpn_city ? `${vpsInfo.vps.vpn_city}, ${vpsInfo.vps.vpn_country}` : (vpsInfo?.vps?.vpn_country || 'France')}
                          </div>
                        </div>
                      </div>
                      {vpsInfo?.vps?.vpn_enabled && (
                        <>
                          <div className="bg-gray-900/50 rounded-lg p-2">
                            <div className="flex items-center gap-1.5 mb-0.5">
                              <Lock className="w-3 h-3 text-gray-400" />
                              <span className="text-[10px] text-gray-500 uppercase">{t('scans.details.protocol')}</span>
                            </div>
                            <div className="text-white text-xs">
                              {scan.config?.vpn_config_id?.includes('openvpn') ? 'OpenVPN TCP' :
                               scan.config?.vpn_config_id?.includes('WireGuard') || scan.config?.vpn_config_id?.includes('wireguard') ? 'WireGuard' : 'OpenVPN'}
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-2">
                            <div className="bg-gray-900/50 rounded-lg p-2 relative overflow-hidden">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-1.5">
                                  <ArrowUp className="w-3 h-3 text-green-400" />
                                  <span className="text-[10px] text-gray-500 uppercase">{t('scans.details.upload')}</span>
                                </div>
                                <div className="text-green-400 font-mono text-xs font-bold">
                                  {vpnStats.uploadSpeed}
                                </div>
                              </div>
                              <div className="text-[10px] text-gray-600 mt-0.5">
                                Total: {vpnStats.totalUpload}
                              </div>
                              {scan.status === 'running' && (
                                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-green-500/30">
                                  <div className="h-full bg-green-500 animate-pulse" style={{width: '60%'}}></div>
                                </div>
                              )}
                            </div>
                            <div className="bg-gray-900/50 rounded-lg p-2 relative overflow-hidden">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-1.5">
                                  <ArrowDown className="w-3 h-3 text-blue-400" />
                                  <span className="text-[10px] text-gray-500 uppercase">{t('scans.details.download')}</span>
                                </div>
                                <div className="text-blue-400 font-mono text-xs font-bold">
                                  {vpnStats.downloadSpeed}
                                </div>
                              </div>
                              <div className="text-[10px] text-gray-600 mt-0.5">
                                Total: {vpnStats.totalDownload}
                              </div>
                              {scan.status === 'running' && (
                                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-500/30">
                                  <div className="h-full bg-blue-500 animate-pulse" style={{width: '80%'}}></div>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="bg-brand-black rounded-lg p-3 border border-gray-800 flex items-center justify-between">
                    <span className="text-xs text-gray-500 uppercase">ID</span>
                    <div className="text-white font-mono text-sm flex items-center gap-2">
                      {scan.id.substring(0, 8)}...
                      <button
                        onClick={() => navigator.clipboard.writeText(scan.id)}
                        className="text-gray-500 hover:text-brand-green"
                      >
                        <Copy className="w-3 h-3" />
                      </button>
                    </div>
                  </div>
                  {scan.config?.ai_model && (
                    <div className="bg-brand-black rounded-lg p-3 border border-gray-800 flex items-center justify-between">
                      <span className="text-xs text-gray-500 uppercase">{t('scanDetails.aiModel')}</span>
                      <div className="text-white text-sm">{scan.config.ai_model}</div>
                    </div>
                  )}
                  {scan.started_at && (
                    <div className="bg-brand-black rounded-lg p-3 border border-gray-800 flex items-center justify-between">
                      <span className="text-xs text-gray-500 uppercase">{t('scans.timestampStarted')}</span>
                      <div className="text-white text-xs">{new Date(scan.started_at).toLocaleString('fr-FR')}</div>
                    </div>
                  )}
                  {scan.completed_at && (
                    <div className="bg-brand-black rounded-lg p-3 border border-gray-800 flex items-center justify-between">
                      <span className="text-xs text-gray-500 uppercase">{t('scans.timestampCompleted')}</span>
                      <div className="text-white text-xs">{new Date(scan.completed_at).toLocaleString('fr-FR')}</div>
                    </div>
                  )}
                </div>

                {/* Center: Radar Scanner */}
                <div className="flex items-center justify-center">
                  <RadarScanner
                    isActive={scan.status === 'running'}
                    hosts={hosts}
                    ports={stats?.ports?.total || scan.total_ports || 0}
                    vulnerabilities={vulnerabilities}
                    exploits={scan.sessions_established || 0}
                  />
                </div>

                {/* Right: CyberScore Panel */}
                <div className="space-y-4">
                  {/* CyberScore Grade */}
                  {cyberScore && (
                    <div className="bg-brand-black rounded-xl p-5 border border-gray-800 relative overflow-hidden">
                      <div className="absolute top-0 right-0 w-32 h-32 opacity-10">
                        <div className={`w-full h-full rounded-bl-full bg-gradient-to-br ${getGradeColor(cyberScore.grade)}`}></div>
                      </div>
                      <div className="flex items-center justify-between mb-4">
                        <div>
                          <div className="text-xs text-gray-500 uppercase mb-1">
                            CyberScore
                          </div>
                          <div className="flex items-baseline gap-2">
                            <span className="text-4xl font-bold text-white">{cyberScore.score}</span>
                            <span className="text-gray-500">/100</span>
                          </div>
                        </div>
                        <div className={`w-20 h-20 rounded-xl bg-gradient-to-br ${getGradeColor(cyberScore.grade)} flex items-center justify-center shadow-lg`}>
                          <span className="text-4xl font-black text-white drop-shadow-lg">{cyberScore.grade}</span>
                        </div>
                      </div>
                      {/* Score bars */}
                      <div className="space-y-2 mt-4">
                        <div className="flex items-center gap-2">
                          <span className="text-xs text-gray-500 w-24">{t('scans.details.vulnerabilities')}</span>
                          <div className="flex-1 h-2 bg-gray-800 rounded-full overflow-hidden">
                            <div
                              className="h-full bg-gradient-to-r from-red-500 to-orange-500 rounded-full transition-all"
                              style={{ width: `${cyberScore.components.vulnerabilities}%` }}
                            ></div>
                          </div>
                          <span className="text-xs text-white w-8">{cyberScore.components.vulnerabilities}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs text-gray-500 w-24">{t('scans.details.exposure')}</span>
                          <div className="flex-1 h-2 bg-gray-800 rounded-full overflow-hidden">
                            <div
                              className="h-full bg-gradient-to-r from-yellow-500 to-green-500 rounded-full transition-all"
                              style={{ width: `${cyberScore.components.exposure}%` }}
                            ></div>
                          </div>
                          <span className="text-xs text-white w-8">{cyberScore.components.exposure}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs text-gray-500 w-24">{t('scans.details.configuration')}</span>
                          <div className="flex-1 h-2 bg-gray-800 rounded-full overflow-hidden">
                            <div
                              className="h-full bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full transition-all"
                              style={{ width: `${cyberScore.components.configuration}%` }}
                            ></div>
                          </div>
                          <span className="text-xs text-white w-8">{cyberScore.components.configuration}</span>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Hack Probability */}
                  {hackProbability !== null && (
                    <div className="bg-brand-black rounded-xl p-5 border border-gray-800">
                      <div className="flex items-center justify-between mb-3">
                        <div className="text-xs text-gray-500 uppercase">{t('scans.details.hackProbability')}</div>
                        <span className={`px-2 py-1 rounded text-xs font-medium border ${getProbabilityLevel(hackProbability).color}`}>
                          {getProbabilityLevel(hackProbability).label}
                        </span>
                      </div>
                      <div className="flex items-center gap-4">
                        <div className="relative w-24 h-24">
                          <svg className="w-24 h-24 transform -rotate-90">
                            <circle
                              cx="48"
                              cy="48"
                              r="40"
                              fill="none"
                              stroke="#1f2937"
                              strokeWidth="8"
                            />
                            <circle
                              cx="48"
                              cy="48"
                              r="40"
                              fill="none"
                              stroke={hackProbability >= 60 ? '#ef4444' : hackProbability >= 40 ? '#f59e0b' : '#10b981'}
                              strokeWidth="8"
                              strokeLinecap="round"
                              strokeDasharray={`${hackProbability * 2.51} 251`}
                              className="transition-all duration-1000"
                            />
                          </svg>
                          <div className="absolute inset-0 flex items-center justify-center">
                            <span className={`text-2xl font-bold ${getProbabilityColor(hackProbability)}`}>
                              {hackProbability}%
                            </span>
                          </div>
                        </div>
                        <div className="flex-1 text-sm text-gray-400">
                          {hackProbability >= 60 ? (
                            <p className="text-red-400">{t('scans.details.riskCritical')}</p>
                          ) : hackProbability >= 40 ? (
                            <p className="text-yellow-400">{t('scans.details.riskHigh')}</p>
                          ) : (
                            <p className="text-green-400">{t('scans.details.riskMedium')}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Duration/Progress - moved from left column */}
                  <div className="bg-brand-black rounded-xl p-5 border border-gray-800">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-xs text-gray-500 uppercase">{t('scanDetails.duration')}</span>
                      <div className="text-white text-lg font-semibold">
                        {scan.completed_at && scan.started_at
                          ? `${Math.round((new Date(scan.completed_at) - new Date(scan.started_at)) / 60000)} min`
                          : scan.status === 'running'
                            ? `${scanProgress.elapsedTime} min`
                            : 'N/A'
                        }
                      </div>
                    </div>
                    {/* Progress bar and remaining time for running scans */}
                    {scan.status === 'running' && scanProgress.percentage > 0 && (
                      <div className="mt-3">
                        <div className="flex items-center justify-between text-sm mb-2">
                          <span className="text-brand-green font-bold">{scanProgress.percentage}%</span>
                          {scanProgress.remainingTime && (
                            <span className="text-gray-400">{t('scanDetails.remainingTime')}: {scanProgress.remainingTime}</span>
                          )}
                        </div>
                        <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden">
                          <div
                            className="h-full bg-gradient-to-r from-brand-green to-green-400 rounded-full transition-all duration-500"
                            style={{ width: `${scanProgress.percentage}%` }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Screenshots/Captures Section */}
        <div className="bg-brand-black-light rounded-xl border border-brand-green/30 overflow-hidden">
          <div
            className="p-4 border-b border-gray-800 flex items-center justify-between cursor-pointer"
            onClick={() => toggleSection('screenshots')}
          >
            <h2 className="text-xl font-bold text-brand-green flex items-center gap-2">
              <Image className="w-5 h-5" />
              {t('scanDetails.capturesResults')} ({screenshots.length})
            </h2>
            {expandedSections.screenshots ? <ChevronUp className="w-5 h-5 text-gray-400" /> : <ChevronDown className="w-5 h-5 text-gray-400" />}
          </div>

          {expandedSections.screenshots && (
            <div className="p-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Left side - Screenshots */}
                <div>
                  <h3 className="text-sm font-medium text-gray-400 mb-3 flex items-center gap-2">
                    <Image className="w-4 h-4" />
                    Captures ({screenshots.length})
                  </h3>
                  {screenshots.length === 0 ? (
                    <div className="text-center py-8 text-gray-500 bg-brand-black rounded-lg border border-gray-800">
                      <Image className="w-10 h-10 mx-auto mb-2 opacity-50" />
                      <p className="text-sm">{t('scans.noCaptures')}</p>
                      <p className="text-xs mt-1 text-gray-600">{scan?.status === 'running' ? 'En attente...' : 'Pas de captures'}</p>
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-h-96 overflow-y-auto pr-2">
                      {screenshots.map((screenshot) => {
                        const isConsole = screenshot.type === 'console' || screenshot.path?.endsWith('.txt');
                        return (
                        <div
                          key={screenshot.id}
                          className="bg-brand-black rounded-lg border border-gray-800 overflow-hidden cursor-pointer hover:border-brand-green/50 transition-all group"
                          onClick={() => handleScreenshotClick(screenshot)}
                        >
                          <div className="h-28 bg-gray-900 overflow-hidden relative">
                            {isConsole ? (
                              /* Console capture - show terminal icon */
                              <div className="w-full h-full flex flex-col items-center justify-center bg-gray-900">
                                <Terminal className="w-10 h-10 text-brand-green mb-2" />
                                <span className="text-xs text-gray-400">Console Capture</span>
                              </div>
                            ) : screenshot.path ? (
                              <img
                                src={`${process.env.REACT_APP_API_URL || ''}${screenshot.path}`}
                                alt={screenshot.title}
                                className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity"
                                onError={(e) => {
                                  const retries = parseInt(e.target.dataset.retries || '0');
                                  if (retries < 2) {
                                    e.target.dataset.retries = retries + 1;
                                    const base = e.target.src.split('?')[0];
                                    setTimeout(() => { e.target.src = `${base}?r=${retries + 1}&t=${Date.now()}`; }, 1500);
                                  } else {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }
                                }}
                              />
                            ) : null}
                            {!isConsole && (
                              <div className={`w-full h-full items-center justify-center bg-gray-900 ${screenshot.path ? 'hidden' : 'flex'}`}>
                                <Image className="w-8 h-8 text-gray-700" />
                              </div>
                            )}
                            <div className="absolute inset-0 bg-gradient-to-t from-brand-black to-transparent"></div>
                            <div className="absolute bottom-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity">
                              <ZoomIn className="w-4 h-4 text-brand-green" />
                            </div>
                          </div>
                          <div className="p-2">
                            <h4 className="text-xs font-medium text-white truncate">{screenshot.title}</h4>
                            <div className="flex items-center justify-between mt-1">
                              <span className="text-xs text-gray-500">
                                {new Date(screenshot.timestamp).toLocaleTimeString('fr-FR')}
                              </span>
                              <div className="flex items-center gap-1">
                                <button
                                  onClick={(e) => { e.stopPropagation(); handleAIFeedback(`screenshot-${screenshot.id}`, 'positive'); }}
                                  className={`p-1 rounded ${aiFeedbacks[`screenshot-${screenshot.id}`]?.type === 'positive' ? 'bg-green-500/20 text-green-400' : 'bg-gray-800 text-gray-500 hover:text-green-400'}`}
                                >
                                  <ThumbsUp className="w-3 h-3" />
                                </button>
                                <button
                                  onClick={(e) => { e.stopPropagation(); setShowFeedbackModal(`screenshot-${screenshot.id}`); }}
                                  className={`p-1 rounded ${aiFeedbacks[`screenshot-${screenshot.id}`]?.type === 'negative' ? 'bg-red-500/20 text-red-400' : 'bg-gray-800 text-gray-500 hover:text-red-400'}`}
                                >
                                  <ThumbsDown className="w-3 h-3" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      );})}
                    </div>
                  )}
                </div>

                {/* Right side - Live Console */}
                <div>
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-sm font-medium text-gray-400 flex items-center gap-2">
                      <Terminal className="w-4 h-4" />
                      {scan?.status === 'running' ? t('scans.consoleLive') :
                       scan?.status === 'completed' ? t('scans.consoleCompleted') :
                       scan?.status === 'failed' ? t('scans.consoleFailed') : t('scans.consoleTitle')}
                      {scan?.status === 'running' && (
                        <span className="inline-flex h-2 w-2 rounded-full bg-green-400 animate-pulse"></span>
                      )}
                      {scan?.status === 'completed' && (
                        <span className="inline-flex h-2 w-2 rounded-full bg-green-500"></span>
                      )}
                      {scan?.status === 'failed' && (
                        <span className="inline-flex h-2 w-2 rounded-full bg-red-500"></span>
                      )}
                    </h3>
                    <div className="flex items-center gap-2">
                      <button
                        onClick={handleCaptureConsole}
                        disabled={isCapturing || consoleLogs.length === 0}
                        className={`text-xs px-2 py-1 rounded flex items-center gap-1 transition-all ${
                          isCapturing ? 'bg-purple-500/30 text-purple-300' :
                          consoleLogs.length === 0 ? 'bg-gray-800 text-gray-600 cursor-not-allowed' :
                          'bg-purple-500/20 text-purple-400 hover:bg-purple-500/30'
                        }`}
                        title={t('scans.details.captureConsole')}
                      >
                        <Camera className={`w-3 h-3 ${isCapturing ? 'animate-pulse' : ''}`} />
                        {isCapturing ? '...' : 'Capture'}
                      </button>
                      <button
                        onClick={() => setConsoleAutoScroll(!consoleAutoScroll)}
                        className={`text-xs px-2 py-1 rounded ${consoleAutoScroll ? 'bg-brand-green/20 text-brand-green' : 'bg-gray-800 text-gray-500'}`}
                        title={consoleAutoScroll ? 'Auto-scroll actif' : 'Auto-scroll desactive'}
                      >
                        {consoleAutoScroll ? 'Auto' : 'Manuel'}
                      </button>
                    </div>
                  </div>
                  <div
                    ref={consoleRef}
                    className="bg-black rounded-lg border border-gray-800 h-96 overflow-y-auto font-mono text-xs p-3"
                    style={{ scrollbarWidth: 'thin', scrollbarColor: '#22c55e #1a1a1a' }}
                  >
                    {consoleLogs.length === 0 ? (
                      <div className="flex flex-col items-center justify-center h-full text-gray-500">
                        <Terminal className="w-8 h-8 mb-2 opacity-50" />
                        <p>{scan?.status === 'running' ? t('scans.waitingForLogs') : t('scans.noLogsAvailable')}</p>
                      </div>
                    ) : (
                      consoleLogs.map((log, index) => (
                        <div key={log.id || index} className="mb-2">
                          <div className="flex items-start gap-2">
                            <span className="text-gray-600 text-[10px] whitespace-nowrap">
                              [{log.timestamp ? new Date(log.timestamp).toLocaleTimeString('fr-FR') : '--:--:--'}]
                            </span>
                            <span className={`text-[10px] px-1 rounded ${
                              log.tool === 'AI' ? 'bg-purple-500/20 text-purple-400' :
                              'bg-blue-500/20 text-blue-400'
                            }`}>
                              {log.tool || 'system'}
                            </span>
                          </div>
                          <div className={`mt-0.5 pl-4 whitespace-pre-wrap break-all ${
                            log.type === 'error' ? 'text-red-400' :
                            log.type === 'output' && log.status === 'success' ? 'text-green-400' :
                            log.type === 'output' && log.status === 'error' ? 'text-red-400' :
                            log.type === 'command' ? 'text-cyan-400' :
                            log.type === 'ai_action' ? 'text-purple-300' :
                            'text-gray-300'
                          }`}>
                            {log.content || log.message || (typeof log === 'string' ? log : JSON.stringify(log))}
                          </div>
                        </div>
                      ))
                    )}
                    {/* "Completed!" message when scan is done */}
                    {consoleLogs.length > 0 && (scan?.status === 'completed' || scan?.status === 'failed') && (
                      <div className="mt-4 pt-3 border-t border-gray-700">
                        <div className="flex items-center gap-2">
                          <span className="text-gray-600 text-[10px] whitespace-nowrap">
                            [{scan.completed_at ? new Date(scan.completed_at).toLocaleTimeString('fr-FR') : '--:--:--'}]
                          </span>
                          <span className={`text-[10px] px-1 rounded ${
                            scan?.status === 'completed' ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'
                          }`}>
                            SYSTEM
                          </span>
                        </div>
                        <div className={`mt-1 pl-4 text-lg font-bold ${
                          scan?.status === 'completed' ? 'text-green-400' : 'text-red-400'
                        }`}>
                          {scan?.status === 'completed' ? t('scans.scanCompletedMessage') : t('scans.scanFailedMessage')}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Timeline */}
        <ScanTimeline scanId={scan.id} />

        {/* Attack Timeline Replay */}
        {vulnerabilities && vulnerabilities.length > 0 && (
          <AttackTimeline scanId={scan.id} vulnerabilities={vulnerabilities} hosts={hosts} />
        )}

        {/* Network Cartography */}
        {scan && (
          <div className="bg-brand-black-light rounded-xl border border-brand-green/30 overflow-hidden">
            <div className="p-4 border-b border-gray-800">
              <h2 className="text-xl font-bold text-brand-green flex items-center gap-2">
                <Globe className="w-5 h-5" />
                {isIPAddress(scan.target) ? 'Network Cartography' : 'Attack Surface'}
              </h2>
            </div>
            <div className={isIPAddress(scan.target) ? "h-[500px]" : ""}>
              {isIPAddress(scan.target) ? (
                <AssetCartography
                  scans={[scan]}
                  selectedScanId={scan.id}
                />
              ) : (
                <DomainCartography
                  scanId={scan.id}
                  domain={scan.target}
                />
              )}
            </div>
          </div>
        )}

        {/* Hosts */}
        {scan && (
          <div className="bg-brand-black-light rounded-xl border border-brand-green/30 overflow-hidden">
            <div
              className="p-4 border-b border-gray-800 flex items-center justify-between cursor-pointer"
              onClick={() => toggleSection('hosts')}
            >
              <h2 className="text-xl font-bold text-brand-green flex items-center gap-2">
                <Server className="w-5 h-5" />
                {t('scanDetails.discoveredHosts')} ({hosts.length})
              </h2>
              {expandedSections.hosts ? <ChevronUp className="w-5 h-5 text-gray-400" /> : <ChevronDown className="w-5 h-5 text-gray-400" />}
            </div>

            {expandedSections.hosts && (
              hosts.length === 0 ? (
                <div className="p-6 text-center text-gray-400">
                  <Server className="w-12 h-12 mx-auto mb-3 opacity-50" />
                  <p>{scan?.status === 'running' ? t('scans.discoveringHosts') : t('scans.noHostDiscovered')}</p>
                </div>
              ) :
              <div className="p-6">
                {/* Sorting Controls */}
                <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-800">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-xs text-gray-500 mr-1">Sort by:</span>
                    {[
                      { key: 'severity', label: t('common.severity'), icon: AlertTriangle },
                      { key: 'vulns', label: 'Vulns', icon: Bug },
                      { key: 'ports', label: 'Ports', icon: Database },
                      { key: 'ip', label: 'IP', icon: Server }
                    ].map(({ key, label, icon: Icon }) => (
                      <button
                        key={key}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (hostsSortBy === key) {
                            setHostsSortOrder(hostsSortOrder === 'desc' ? 'asc' : 'desc');
                          } else {
                            setHostsSortBy(key);
                            setHostsSortOrder('desc');
                          }
                        }}
                        className={`px-2.5 py-1 text-xs font-medium rounded-lg flex items-center gap-1.5 transition-colors ${
                          hostsSortBy === key
                            ? 'bg-brand-green text-black'
                            : 'bg-gray-800 text-gray-400 hover:bg-gray-700'
                        }`}
                      >
                        <Icon className="w-3 h-3" />
                        {label}
                        {hostsSortBy === key && (
                          <span className="ml-0.5">{hostsSortOrder === 'desc' ? '↓' : '↑'}</span>
                        )}
                      </button>
                    ))}
                  </div>
                  <div className="flex items-center gap-3">
                    {/* GreyNoise Check Button */}
                    <button
                      onClick={(e) => { e.stopPropagation(); checkGreynoise(); }}
                      disabled={checkingGreynoise}
                      className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg transition-all ${
                        checkingGreynoise
                          ? 'bg-gray-800 text-gray-500 cursor-not-allowed'
                          : greynoiseSummary?.botnet_count > 0
                            ? 'bg-red-500/20 text-red-400 border border-red-500/30 hover:bg-red-500/30'
                            : greynoiseSummary
                              ? 'bg-green-500/20 text-green-400 border border-green-500/30 hover:bg-green-500/30'
                              : 'bg-gray-800 text-gray-300 border border-gray-700 hover:bg-gray-700'
                      }`}
                      title="Verify public IPs against GreyNoise (botnet detection)"
                    >
                      <Globe className="w-3 h-3" />
                      {checkingGreynoise
                        ? 'Verifying...'
                        : greynoiseSummary
                          ? greynoiseSummary.botnet_count > 0
                            ? `${greynoiseSummary.botnet_count} Botnet(s) !`
                            : `GreyNoise ✓`
                          : 'Check Botnet'
                      }
                    </button>
                    <div className="flex items-center gap-2 text-xs text-gray-500">
                      <div className="flex items-center gap-1">
                        <div className="w-2 h-2 rounded-full bg-red-500"></div>
                        <span>{t('vulnerabilities.severities.critical')}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <div className="w-2 h-2 rounded-full bg-orange-500"></div>
                        <span>{t('vulnerabilities.severities.high')}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <div className="w-2 h-2 rounded-full bg-yellow-500"></div>
                        <span>{t('vulnerabilities.severities.medium')}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <div className="w-2 h-2 rounded-full bg-green-500"></div>
                        <span>{t('vulnerabilities.severities.low')}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* GreyNoise Botnet Alert Banner */}
                {greynoiseSummary?.botnet_count > 0 && (
                  <div className="mb-4 p-3 bg-red-900/20 border border-red-600/50 rounded-lg flex items-start gap-3">
                    <AlertTriangle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="text-red-300 font-medium text-sm">
                        {greynoiseSummary.botnet_count} IP(s) identified as botnet by GreyNoise
                      </p>
                      <p className="text-red-400/70 text-xs mt-1">
                        {greynoiseSummary.botnet_ips.join(', ')}
                      </p>
                    </div>
                  </div>
                )}
                {greynoiseSummary && greynoiseSummary.botnet_count === 0 && greynoiseSummary.checked > 0 && (
                  <div className="mb-4 p-3 bg-green-900/20 border border-green-600/30 rounded-lg flex items-center gap-3">
                    <Shield className="w-4 h-4 text-green-400 flex-shrink-0" />
                    <p className="text-green-300 text-sm">
                      {greynoiseSummary.checked} IP(s) verified by GreyNoise — no botnet activity detected
                    </p>
                  </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {(showAllHosts ? sortedHosts : sortedHosts.slice(0, 12)).map((host) => {
                    // Calculate host vulnerability counts
                    const hostVulns = vulnerabilities.filter(v => v.host_id === host.id || v.ip_address === host.ip_address);
                    const criticalCount = hostVulns.filter(v => v.severity === 'critical').length;
                    const highCount = hostVulns.filter(v => v.severity === 'high').length;
                    const mediumCount = hostVulns.filter(v => v.severity === 'medium').length;
                    const lowCount = hostVulns.filter(v => v.severity === 'low').length;
                    const totalVulns = hostVulns.length;

                    // Determine risk level
                    const riskLevel = criticalCount > 0 ? 'CRITICAL' : highCount > 0 ? 'HIGH' : mediumCount > 0 ? 'MEDIUM' : 'LOW';

                    // GreyNoise data for this host
                    const gnData = host.ai_analysis_cache?.greynoise || greynoiseResults[host.ip_address];
                    const isBotnet = gnData?.is_botnet;
                    const gnChecked = gnData?.checked;

                    const riskColor = isBotnet ? 'border-red-600/70 bg-red-600/10' :
                                      criticalCount > 0 ? 'border-red-500/50 bg-red-500/5' :
                                      highCount > 0 ? 'border-orange-500/50 bg-orange-500/5' :
                                      mediumCount > 0 ? 'border-yellow-500/50 bg-yellow-500/5' :
                                      'border-gray-800';

                    return (
                      <div
                        key={host.id}
                        onClick={() => fetchHostAnalysis(host)}
                        className={`bg-brand-black rounded-xl p-4 border ${riskColor} hover:border-brand-green/50 hover:bg-brand-black-light transition-all cursor-pointer group`}
                      >
                        {/* Header with IP and Risk Badge */}
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex items-center gap-2 min-w-0">
                            <span className="font-mono text-brand-green font-medium group-hover:text-brand-green-light truncate">{host.ip_address}</span>
                            {/* GreyNoise indicator */}
                            {gnChecked && (
                              <span
                                className={`text-xs px-1.5 py-0.5 rounded font-medium flex-shrink-0 ${
                                  isBotnet
                                    ? 'bg-red-600/30 text-red-300 border border-red-600/50'
                                    : gnData?.noise
                                      ? 'bg-orange-500/20 text-orange-300 border border-orange-500/30'
                                      : gnData?.classification === 'benign'
                                        ? 'bg-green-500/20 text-green-400'
                                        : 'bg-gray-700 text-gray-400'
                                }`}
                                title={`GreyNoise: ${gnData?.classification || 'unknown'} | ${gnData?.name || ''} | Last seen: ${gnData?.last_seen || 'N/A'}`}
                              >
                                {isBotnet ? '⚠ Botnet' : gnData?.noise ? '◉ Noisy' : gnData?.riot ? '✓ RIOT' : '• OK'}
                              </span>
                            )}
                          </div>
                          <div className="flex items-center gap-2">
                            {totalVulns > 0 && (
                              <span className={`text-xs px-2 py-0.5 rounded font-bold ${
                                riskLevel === 'CRITICAL' ? 'bg-red-500/20 text-red-400' :
                                riskLevel === 'HIGH' ? 'bg-orange-500/20 text-orange-400' :
                                riskLevel === 'MEDIUM' ? 'bg-yellow-500/20 text-yellow-400' :
                                'bg-green-500/20 text-green-400'
                              }`}>
                                {riskLevel}
                              </span>
                            )}
                            {/* Severity indicator dot */}
                            <div
                              className={`w-3 h-3 rounded-full shadow-lg ${
                                criticalCount > 0 ? 'bg-red-500 shadow-red-500/50' :
                                highCount > 0 ? 'bg-orange-500 shadow-orange-500/50' :
                                mediumCount > 0 ? 'bg-yellow-500 shadow-yellow-500/50' :
                                lowCount > 0 ? 'bg-blue-500 shadow-blue-500/50' :
                                host.status === 'up' ? 'bg-green-500 shadow-green-500/50' : 'bg-gray-500'
                              }`}
                              title={
                                criticalCount > 0 ? `${criticalCount} ${t('scanDetails.criticalLabel').toLowerCase()}` :
                                highCount > 0 ? `${highCount} ${t('scanDetails.highLabel').toLowerCase()}` :
                                mediumCount > 0 ? `${mediumCount} ${t('scanDetails.mediumLabel').toLowerCase()}` :
                                lowCount > 0 ? `${lowCount} ${t('scanDetails.lowLabel').toLowerCase()}` :
                                t('scanDetails.noVulnDetected')
                              }
                            ></div>
                          </div>
                        </div>

                        {/* Host Info */}
                        <div className="space-y-1 text-sm">
                          {host.hostname && (
                            <div className="flex items-center gap-2 text-gray-400">
                              <Wifi className="w-3 h-3" />
                              <span className="truncate">{toSafeString(host.hostname)}</span>
                            </div>
                          )}
                          {host.discovery_details && (
                            <div className="flex items-center gap-2 text-gray-500 italic">
                              <Info className="w-3 h-3 flex-shrink-0" />
                              <span className="truncate text-xs">{toSafeString(host.discovery_details)}</span>
                            </div>
                          )}
                          {host.os_name && (() => {
                            const osInfo = getOSIcon(host.os_name);
                            const OSIcon = osInfo.icon;
                            return (
                              <div className="flex items-center gap-2 text-gray-400">
                                <OSIcon className={`w-3 h-3 ${osInfo.color}`} />
                                <span className="truncate">{host.os_name}</span>
                              </div>
                            );
                          })()}
                          <div className="flex items-center gap-2 text-gray-400">
                            <Database className="w-3 h-3" />
                            <span>{host.ports?.length || host.open_ports || 0} ports ouverts</span>
                          </div>
                        </div>

                        {/* Services Details for Internet Scans */}
                        {host.ports && host.ports.length > 0 && (
                          <div className="mt-3 pt-3 border-t border-gray-800">
                            <div className="text-xs text-gray-500 mb-2 flex items-center gap-1">
                              <Server className="w-3 h-3" />
                              {t('scanDetails.detectedServices')}:
                            </div>
                            <div className="grid grid-cols-1 gap-1.5">
                              {host.ports.slice(0, 5).map((svc, idx) => (
                                <div key={idx} className="flex items-center justify-between text-xs bg-gray-900/50 rounded px-2 py-1">
                                  <div className="flex items-center gap-2">
                                    <span className="font-mono text-brand-green">{svc.port}/{svc.protocol}</span>
                                    <span className="text-gray-400">{svc.service_name}</span>
                                  </div>
                                  <div className="text-gray-500 truncate max-w-[120px]">
                                    {svc.product && <span>{svc.product}</span>}
                                    {svc.version && <span className="ml-1 text-blue-400">{svc.version}</span>}
                                  </div>
                                </div>
                              ))}
                              {host.ports.length > 5 && (
                                <div className="text-xs text-gray-500 text-center">
                                  +{host.ports.length - 5} more services
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* CVE Summary by Level */}
                        {totalVulns > 0 && (
                          <div className="mt-3 pt-3 border-t border-gray-800">
                            <div className="flex items-center gap-1 text-xs">
                              <Bug className="w-3 h-3 text-gray-500 mr-1" />
                              <span className="text-gray-500">{totalVulns} CVE:</span>
                              {criticalCount > 0 && (
                                <span className="px-1.5 py-0.5 rounded bg-red-500/20 text-red-400 font-bold">{criticalCount}C</span>
                              )}
                              {highCount > 0 && (
                                <span className="px-1.5 py-0.5 rounded bg-orange-500/20 text-orange-400 font-bold">{highCount}H</span>
                              )}
                              {mediumCount > 0 && (
                                <span className="px-1.5 py-0.5 rounded bg-yellow-500/20 text-yellow-400 font-bold">{mediumCount}M</span>
                              )}
                              {lowCount > 0 && (
                                <span className="px-1.5 py-0.5 rounded bg-blue-500/20 text-blue-400 font-bold">{lowCount}L</span>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Click hint */}
                        <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-800">
                          <span className="text-xs text-gray-600 group-hover:text-gray-400 flex items-center gap-1">
                            <Eye className="w-3 h-3" />
                            {t('scanDetails.analyzeWithAI')}
                          </span>
                          <div className="flex items-center gap-2">
                            <button
                              onClick={(e) => { e.stopPropagation(); handleAIFeedback(`host-${host.id}`, 'positive'); }}
                              className={`p-1.5 rounded text-xs ${aiFeedbacks[`host-${host.id}`]?.type === 'positive' ? 'bg-green-500/20 text-green-400' : 'bg-gray-800 text-gray-500 hover:text-green-400'}`}
                            >
                              <ThumbsUp className="w-3 h-3" />
                            </button>
                            <button
                              onClick={(e) => { e.stopPropagation(); setShowFeedbackModal(`host-${host.id}`); }}
                              className={`p-1.5 rounded text-xs ${aiFeedbacks[`host-${host.id}`]?.type === 'negative' ? 'bg-red-500/20 text-red-400' : 'bg-gray-800 text-gray-500 hover:text-red-400'}`}
                            >
                              <ThumbsDown className="w-3 h-3" />
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {hosts.length > 12 && (
                  <div className="text-center mt-4">
                    <button
                      onClick={() => setShowAllHosts(!showAllHosts)}
                      className="text-brand-green hover:text-brand-green-light text-sm"
                    >
                      {showAllHosts
                        ? t('scanDetails.reduceList')
                        : t('scanDetails.showMoreHosts').replace('{count}', hosts.length - 12)}
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* Vulnerabilities */}
        {scan && (
          <div className="bg-brand-black-light rounded-xl border border-brand-green/30 overflow-hidden">
            <div
              className="p-4 border-b border-gray-800 flex items-center justify-between cursor-pointer"
              onClick={() => toggleSection('vulnerabilities')}
            >
              <h2 className="text-xl font-bold text-brand-green flex items-center gap-2">
                <Bug className="w-5 h-5" />
                Vulnerabilities ({vulnerabilities.length})
                {Object.keys(excludedVulns).length > 0 && (
                  <span className="text-xs px-2 py-0.5 rounded bg-gray-700 text-gray-400">
                    {Object.keys(excludedVulns).length} excluded
                  </span>
                )}
              </h2>
              {expandedSections.vulnerabilities ? <ChevronUp className="w-5 h-5 text-gray-400" /> : <ChevronDown className="w-5 h-5 text-gray-400" />}
            </div>

            {expandedSections.vulnerabilities && (
              vulnerabilities.length === 0 ? (
                <div className="p-6 text-center text-gray-400">
                  <Bug className="w-12 h-12 mx-auto mb-3 opacity-50" />
                  <p>{scan?.status === 'running' ? t('scans.analyzingVulns') : t('scans.noVulnDetected')}</p>
                  <p className="text-xs text-gray-500 mt-1"></p>
                </div>
              ) :
              <div className="p-6 space-y-3">
                {/* Filter and Sort Controls */}
                <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-800">
                  <div className="flex items-center gap-2">
                    {/* View Mode Buttons */}
                    <div className="flex rounded-lg overflow-hidden border border-gray-700">
                      <button
                        onClick={(e) => { e.stopPropagation(); setVulnViewMode('top5'); }}
                        className={`px-3 py-1.5 text-xs font-medium transition-colors flex items-center gap-1.5 ${
                          vulnViewMode === 'top5'
                            ? 'bg-brand-green text-black'
                            : 'bg-gray-800 text-gray-400 hover:text-white hover:bg-gray-700'
                        }`}
                        title={t('scanDetails.showTop5')}
                      >
                        <ListFilter className="w-3.5 h-3.5" />
                        Top 5
                      </button>
                      <button
                        onClick={(e) => { e.stopPropagation(); setVulnViewMode('all'); }}
                        className={`px-3 py-1.5 text-xs font-medium transition-colors flex items-center gap-1.5 border-l border-gray-700 ${
                          vulnViewMode === 'all'
                            ? 'bg-brand-green text-black'
                            : 'bg-gray-800 text-gray-400 hover:text-white hover:bg-gray-700'
                        }`}
                        title={t('scanDetails.showAll')}
                      >
                        <List className="w-3.5 h-3.5" />
                        {t('common.all')} ({vulnerabilities.length})
                      </button>
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    {/* Sort By Buttons */}
                    <div className="flex rounded-lg overflow-hidden border border-gray-700">
                      <button
                        onClick={(e) => { e.stopPropagation(); setVulnSortBy('severity'); }}
                        className={`px-3 py-1.5 text-xs font-medium transition-colors flex items-center gap-1.5 ${
                          vulnSortBy === 'severity'
                            ? 'bg-red-500/80 text-white'
                            : 'bg-gray-800 text-gray-400 hover:text-white hover:bg-gray-700'
                        }`}
                        title={t('scans.details.sortBySeverity')}
                      >
                        <AlertTriangle className="w-3.5 h-3.5" />
                        {t('common.severity')}
                      </button>
                      <button
                        onClick={(e) => { e.stopPropagation(); setVulnSortBy('date'); }}
                        className={`px-3 py-1.5 text-xs font-medium transition-colors flex items-center gap-1.5 border-l border-gray-700 ${
                          vulnSortBy === 'date'
                            ? 'bg-blue-500/80 text-white'
                            : 'bg-gray-800 text-gray-400 hover:text-white hover:bg-gray-700'
                        }`}
                        title={t('scans.details.sortByDate')}
                      >
                        <Clock className="w-3.5 h-3.5" />
                        Date
                      </button>
                    </div>

                    {/* Sort Order Button */}
                    <button
                      onClick={(e) => { e.stopPropagation(); setVulnSortOrder(prev => prev === 'desc' ? 'asc' : 'desc'); }}
                      className={`px-3 py-1.5 text-xs font-medium rounded-lg border transition-colors flex items-center gap-1.5 ${
                        vulnSortOrder === 'desc'
                          ? 'border-brand-green/50 bg-brand-green/10 text-brand-green'
                          : 'border-blue-500/50 bg-blue-500/10 text-blue-400'
                      }`}
                      title={vulnSortOrder === 'desc' ? (vulnSortBy === 'severity' ? t('scans.details.mostSevereFirst') : t('scans.details.mostRecentFirst')) : (vulnSortBy === 'severity' ? t('scans.details.mostSevereFirst') : t('scans.details.mostRecentFirst'))}
                    >
                      <ArrowUpDown className="w-3.5 h-3.5" />
                      {vulnSortOrder === 'desc' ? (vulnSortBy === 'severity' ? 'Severe' : 'Recent') : (vulnSortBy === 'severity' ? 'Low' : 'Old')}
                    </button>
                  </div>
                </div>

                {/* Info bar when filtered */}
                {vulnerabilities.length > 5 && vulnViewMode === 'top5' && (
                  <div className="mb-4 px-3 py-2 bg-gray-800/50 rounded-lg border border-gray-700/50 text-xs text-gray-400 flex items-center justify-between">
                    <span>{t('scanDetails.showingTop5').replace('{sortType}', vulnSortBy === 'severity' ? t('scanDetails.bySeverity') : t('scanDetails.byDate')).replace('{total}', vulnerabilities.length)}</span>
                    <button
                      onClick={(e) => { e.stopPropagation(); setVulnViewMode('all'); }}
                      className="text-brand-green hover:underline"
                    >
                      {t('scanDetails.viewAll')}
                    </button>
                  </div>
                )}

                {filteredVulnerabilities.map((vuln) => {
                  // Find the associated host for this vulnerability
                  const associatedHost = hosts.find(h => h.id === vuln.host_id || h.ip_address === vuln.ip_address);
                  const isExcluded = excludedVulns[vuln.id];

                  return (
                    <div
                      key={vuln.id}
                      className={`bg-brand-black rounded-xl p-4 border transition-colors cursor-pointer group ${
                        isExcluded
                          ? 'border-gray-700 opacity-60'
                          : 'border-gray-800 hover:border-brand-green/50'
                      }`}
                      onClick={() => setSelectedVulnerability(vuln)}
                    >
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          {/* Host Info Row - IP and Hostname */}
                          <div className="flex items-center gap-2 mb-2 text-xs">
                            <MapPin className="w-3 h-3 text-gray-500" />
                            <span className="font-mono text-brand-green">
                              {vuln.ip_address || associatedHost?.ip_address || 'N/A'}
                            </span>
                            {(vuln.hostname || associatedHost?.hostname) && (
                              <>
                                <span className="text-gray-600">|</span>
                                <span className="text-gray-400">
                                  {vuln.hostname || associatedHost?.hostname}
                                </span>
                              </>
                            )}
                            {isExcluded && (
                              <span className="px-2 py-0.5 rounded bg-gray-700 text-gray-400 ml-2">
                                {t('scanDetails.excludedFromReport')}
                              </span>
                            )}
                          </div>

                          {/* Severity and CVE badges */}
                          <div className="flex items-center gap-2 mb-2 flex-wrap">
                            <span className={`badge border ${getSeverityBadgeClass(vuln.severity)}`}>
                              {vuln.severity?.toUpperCase()}
                            </span>
                            {vuln.cve_id && (
                              <span className="badge bg-brand-green/20 text-brand-green border border-brand-green/50">
                                {vuln.cve_id}
                              </span>
                            )}
                            {vuln.cvss_score && (
                              <span className={`text-xs px-2 py-1 rounded ${
                                vuln.cvss_score >= 9 ? 'bg-red-500/20 text-red-400' :
                                vuln.cvss_score >= 7 ? 'bg-orange-500/20 text-orange-400' :
                                'bg-yellow-500/20 text-yellow-400'
                              }`}>
                                CVSS: {vuln.cvss_score}
                              </span>
                            )}
                            {vuln.exploitation_successful && (
                              <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-bold rounded bg-purple-600/30 text-purple-300 border border-purple-500/50 animate-pulse whitespace-nowrap">
                                <svg className="w-3 h-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                                </svg>
                                EXPLOITED
                              </span>
                            )}
                          </div>
                          <div className={`font-medium mb-1 transition-colors ${isExcluded ? 'text-gray-500' : 'text-white group-hover:text-brand-green'}`}>
                            {vuln.title}
                          </div>
                          <div className="text-sm text-gray-400 line-clamp-2 break-all">{vuln.description || 'No description'}</div>
                        </div>
                        {/* Action Buttons */}
                        <div className="flex items-center gap-2 ml-4">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAIFeedback(`vuln-${vuln.id}`, 'positive');
                            }}
                            className={`p-2 rounded ${aiFeedbacks[`vuln-${vuln.id}`]?.type === 'positive' ? 'bg-green-500/20 text-green-400' : 'bg-gray-800 text-gray-500 hover:text-green-400'}`}
                            title={t('scans.details.correctDetection')}
                          >
                            <ThumbsUp className="w-4 h-4" />
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowFeedbackModal(`vuln-${vuln.id}`);
                            }}
                            className={`p-2 rounded ${aiFeedbacks[`vuln-${vuln.id}`]?.type === 'negative' ? 'bg-red-500/20 text-red-400' : 'bg-gray-800 text-gray-500 hover:text-red-400'}`}
                            title={t('scans.details.falsePositive')}
                          >
                            <ThumbsDown className="w-4 h-4" />
                          </button>
                          {/* Exclude from report button */}
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setExcludedVulns(prev => {
                                const newExcluded = { ...prev };
                                if (newExcluded[vuln.id]) {
                                  delete newExcluded[vuln.id];
                                } else {
                                  newExcluded[vuln.id] = true;
                                }
                                return newExcluded;
                              });
                            }}
                            className={`p-2 rounded ${isExcluded ? 'bg-gray-600/20 text-gray-400' : 'bg-gray-800 text-gray-500 hover:text-orange-400'}`}
                            title={isExcluded ? t('scans.details.includeInReport') : t('scans.details.excludeFromReport')}
                          >
                            {isExcluded ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedVulnerability(vuln);
                            }}
                            className="p-2 rounded bg-brand-green/20 text-brand-green hover:bg-brand-green/30 opacity-0 group-hover:opacity-100 transition-all"
                            title={t('scanDetails.viewDetails')}
                          >
                            <ExternalLink className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
                {/* Link to full vulnerabilities page when viewing all */}
                {vulnViewMode === 'all' && vulnerabilities.length > 10 && (
                  <div className="text-center pt-4 border-t border-gray-800">
                    <button
                      onClick={() => navigate('/vulnerabilities')}
                      className="text-brand-green hover:text-brand-green-light text-sm"
                    >
                      {t('scanDetails.manageAllVulnerabilities')}
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* Advanced CyberScore Panel - New Component */}
        {scan && (
          <div className="bg-brand-black-light rounded-xl border border-gray-800 overflow-hidden">
            <div
              className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-800/50 transition-colors"
              onClick={() => toggleSection('advancedScore')}
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyan-500/20 to-blue-500/20 flex items-center justify-center">
                  <Shield className="w-5 h-5 text-cyan-400" />
                </div>
                <div>
                  <h2 className="text-lg font-bold text-white">{t('scans.details.advancedAnalysis')}</h2>
                  <p className="text-xs text-gray-400">{t('scans.details.advancedAnalysisDesc')}</p>
                </div>
              </div>
              {expandedSections.advancedScore ? <ChevronUp className="w-5 h-5 text-gray-400" /> : <ChevronDown className="w-5 h-5 text-gray-400" />}
            </div>

            {expandedSections.advancedScore && (
              <div className="p-6 border-t border-gray-800">
                <CyberScorePanel
                  scanId={scan.id}
                  authToken={localStorage.getItem('access_token') || localStorage.getItem('token')}
                  onScoreLoaded={(data) => setAdvancedCyberScore(data)}
                />
              </div>
            )}
          </div>
        )}

        {/* SwaggerSpy OSINT Results - API Security */}
        {scan && scan.scan_type === 'api_pentest' && scan.results?.swaggerspy && (
          <SwaggerSpyResults
            scanId={scan.id}
            domain={scan.target}
            results={scan.results.swaggerspy}
          />
        )}

        {/* ☁️ Cloud Audit Results — AWS / Azure / GCP */}
        {scan && ['cloud_scan','cloud_aws','cloud_azure','cloud_gcp'].includes(scan.scan_type) && (() => {
          const cs = scan.config?.cloud_audit_summary || {};
          const provider = cs.cloud_provider || scan.config?.cloud_provider || 'aws';
          const compliance = cs.cloud_compliance || scan.config?.cloud_compliance || '';
          const summary = cs.prowler_summary || {};
          const totalFail = cs.total_fail ?? summary.FAIL ?? 0;
          const totalPass = cs.total_pass ?? summary.PASS ?? 0;
          const totalFindings = cs.total_findings ?? (totalFail + totalPass);
          const passRate = totalFindings > 0 ? Math.round((totalPass / totalFindings) * 100) : 0;
          const providerLabels = { aws: 'Amazon Web Services', azure: 'Microsoft Azure', gcp: 'Google Cloud Platform' };
          const providerIcons = { aws: '☁️', azure: '🔵', gcp: '🟡' };
          const providerColors = {
            aws: 'from-orange-900/30 to-brand-black border-orange-500/30',
            azure: 'from-blue-900/30 to-brand-black border-blue-500/30',
            gcp: 'from-yellow-900/30 to-brand-black border-yellow-500/30',
          };
          // Parse cloud-specific vuln fields from description
          const parseCloudMeta = (desc) => {
            if (!desc) return {};
            const meta = {};
            const lines = desc.split('\n');
            lines.forEach(l => {
              if (l.startsWith('Resource: ')) meta.resource = l.replace('Resource: ', '');
              if (l.startsWith('Region: ')) meta.region = l.replace('Region: ', '');
              if (l.startsWith('Service: ')) meta.service = l.replace('Service: ', '');
              if (l.startsWith('Remediation: ')) meta.remediation = l.replace('Remediation: ', '');
            });
            return meta;
          };
          // Group vulns by service
          const vulnsByService = {};
          vulnerabilities.forEach(v => {
            const m = parseCloudMeta(v.description);
            const svc = m.service || 'unknown';
            if (!vulnsByService[svc]) vulnsByService[svc] = 0;
            vulnsByService[svc]++;
          });
          const topServices = Object.entries(vulnsByService).sort((a,b) => b[1]-a[1]).slice(0, 8);
          return (
            <div className={`bg-gradient-to-br ${providerColors[provider] || providerColors.aws} rounded-xl border overflow-hidden`}>
              {/* Header */}
              <div className="flex items-center justify-between p-5 border-b border-gray-800/50">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-blue-500/20 rounded-xl flex items-center justify-center text-xl">
                    {providerIcons[provider] || '☁️'}
                  </div>
                  <div>
                    <h2 className="text-lg font-bold text-white flex items-center gap-2">
                      <Cloud className="w-5 h-5 text-blue-400" />
                      Audit Cloud — {providerLabels[provider] || provider.toUpperCase()}
                    </h2>
                    {compliance && <p className="text-xs text-gray-400 mt-0.5">Framework : {compliance}</p>}
                  </div>
                </div>
                {/* Pass rate badge */}
                <div className={`px-4 py-2 rounded-xl font-bold text-sm border ${
                  passRate >= 80 ? 'bg-brand-green/20 border-brand-green/50 text-brand-green' :
                  passRate >= 60 ? 'bg-yellow-500/20 border-yellow-500/50 text-yellow-400' :
                  'bg-red-500/20 border-red-500/50 text-red-400'
                }`}>
                  {passRate}% compliance
                </div>
              </div>
              <div className="p-5 space-y-5">
                {/* Stats row */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: 'Total findings', value: totalFindings, color: 'text-gray-300' },
                    { label: 'Failures (FAIL)', value: totalFail, color: 'text-red-400' },
                    { label: 'Successes (PASS)', value: totalPass, color: 'text-brand-green' },
                    { label: t('scans.details.vulnerabilities'), value: vulnerabilities.length, color: 'text-orange-400' },
                  ].map((s, i) => (
                    <div key={i} className="bg-brand-black/60 rounded-xl p-3 text-center border border-gray-800/50">
                      <div className={`text-2xl font-bold ${s.color}`}>{s.value}</div>
                      <div className="text-xs text-gray-500 mt-0.5">{s.label}</div>
                    </div>
                  ))}
                </div>
                {/* Severity breakdown */}
                {(summary.CRITICAL > 0 || summary.HIGH > 0 || summary.MEDIUM > 0 || summary.LOW > 0) && (
                  <div>
                    <h3 className="text-sm font-semibold text-gray-400 mb-2">{t('scans.details.severityBreakdown')}</h3>
                    <div className="grid grid-cols-4 gap-2">
                      {[
                        { label: 'Critical', key: 'CRITICAL', color: 'bg-red-900/30 border-red-500/40 text-red-400' },
                        { label: 'High', key: 'HIGH', color: 'bg-orange-900/30 border-orange-500/40 text-orange-400' },
                        { label: 'Medium', key: 'MEDIUM', color: 'bg-yellow-900/30 border-yellow-500/40 text-yellow-400' },
                        { label: 'Low', key: 'LOW', color: 'bg-blue-900/30 border-blue-500/40 text-blue-400' },
                      ].map(s => (
                        <div key={s.key} className={`${s.color} rounded-lg p-2 border text-center`}>
                          <div className="text-xl font-bold">{summary[s.key] || 0}</div>
                          <div className="text-xs opacity-70">{s.label}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {/* Services breakdown */}
                {topServices.length > 0 && (
                  <div>
                    <h3 className="text-sm font-semibold text-gray-400 mb-2">{t('scans.details.mostImpacted')}</h3>
                    <div className="space-y-1.5">
                      {topServices.map(([svc, count]) => {
                        const pct = Math.round((count / vulnerabilities.length) * 100);
                        return (
                          <div key={svc} className="flex items-center gap-3">
                            <span className="text-xs text-gray-300 w-20 flex-shrink-0 uppercase font-mono">{svc}</span>
                            <div className="flex-1 bg-gray-800 rounded-full h-1.5">
                              <div className="h-1.5 rounded-full bg-red-500/70" style={{ width: `${pct}%` }} />
                            </div>
                            <span className="text-xs text-gray-400 w-8 text-right">{count}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {/* Cloud Vulnerabilities Table */}
                {vulnerabilities.length > 0 && (
                  <div>
                    <h3 className="text-sm font-semibold text-gray-400 mb-2">
                      Findings ({vulnerabilities.length})
                    </h3>
                    <div className="rounded-xl border border-gray-800 overflow-hidden">
                      <div className="overflow-x-auto">
                        <table className="w-full text-sm">
                          <thead>
                            <tr className="border-b border-gray-800 bg-gray-900/50">
                              <th className="text-left px-3 py-2 text-gray-500 font-medium">{t('common.severity')}</th>
                              <th className="text-left px-3 py-2 text-gray-500 font-medium">{t('scans.details.check')}</th>
                              <th className="text-left px-3 py-2 text-gray-500 font-medium">{t('common.service')}</th>
                              <th className="text-left px-3 py-2 text-gray-500 font-medium">{t('common.resource')}</th>
                              <th className="text-left px-3 py-2 text-gray-500 font-medium">{t('common.region')}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {vulnerabilities.slice(0, 50).map((v, i) => {
                              const meta = parseCloudMeta(v.description);
                              const sevColors = {
                                critical: 'bg-red-500/20 text-red-400 border-red-500/40',
                                high: 'bg-orange-500/20 text-orange-400 border-orange-500/40',
                                medium: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/40',
                                low: 'bg-blue-500/20 text-blue-400 border-blue-500/40',
                                info: 'bg-gray-500/20 text-gray-400 border-gray-500/40',
                              };
                              return (
                                <tr key={i} className="border-b border-gray-800/50 hover:bg-gray-800/30 transition-colors">
                                  <td className="px-3 py-2">
                                    <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium border ${sevColors[v.severity] || sevColors.info}`}>
                                      {v.severity}
                                    </span>
                                  </td>
                                  <td className="px-3 py-2 text-white text-xs max-w-xs">
                                    <div className="font-medium truncate" title={v.title}>{v.title}</div>
                                    {meta.remediation && (
                                      <div className="text-gray-500 text-xs mt-0.5 truncate" title={meta.remediation}>
                                        💡 {meta.remediation}
                                      </div>
                                    )}
                                  </td>
                                  <td className="px-3 py-2 text-gray-300 text-xs font-mono uppercase">{meta.service || v.cve_id?.replace('CLOUD-','').split('-')[0] || '—'}</td>
                                  <td className="px-3 py-2 text-gray-400 text-xs font-mono max-w-xs truncate" title={meta.resource}>{meta.resource || '—'}</td>
                                  <td className="px-3 py-2 text-gray-400 text-xs">{meta.region || '—'}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                        {vulnerabilities.length > 50 && (
                          <div className="px-3 py-2 text-center text-gray-500 text-xs border-t border-gray-800">
                            +{vulnerabilities.length - 50} additional findings in PDF export
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })()}

        {/* IA Tools Panel — Command Generator + Threat Intel */}
        {scan && (
          <div className="bg-brand-black-light rounded-xl border border-gray-800 overflow-hidden">
            <div
              className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-800/50 transition-colors"
              onClick={() => toggleSection('aiTools')}
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-brand-green/20 to-teal-500/20 flex items-center justify-center">
                  <Brain className="w-5 h-5 text-brand-green" />
                </div>
                <div>
                  <h2 className="text-lg font-bold text-white">{t('scans.details.aiToolsTitle')}</h2>
                  <p className="text-xs text-gray-400">{t('scans.details.aiToolsDesc')}</p>
                </div>
              </div>
              {expandedSections.aiTools ? <ChevronUp className="w-5 h-5 text-gray-400" /> : <ChevronDown className="w-5 h-5 text-gray-400" />}
            </div>
            {expandedSections.aiTools && (
              <div className="p-6 border-t border-gray-800">
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                  <AICommandGenerator
                    defaultTarget={scan.target || ''}
                    scanId={scan.id}
                    workspaceId={scan.workspace_id || scan.workspaces?.[0]?.id || null}
                  />
                  <OSINTIntelPanel defaultTarget={scan.target || ''} />
                </div>
              </div>
            )}
          </div>
        )}

        {/* Tool Outputs Panel - New Component */}
        {scan && (
          <div className="bg-brand-black-light rounded-xl border border-gray-800 overflow-hidden">
            <div
              className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-800/50 transition-colors"
              onClick={() => toggleSection('toolOutputs')}
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-purple-500/20 to-pink-500/20 flex items-center justify-center">
                  <Terminal className="w-5 h-5 text-purple-400" />
                </div>
                <div>
                  <h2 className="text-lg font-bold text-white">{t('scans.details.toolResults')}</h2>
                  <p className="text-xs text-gray-400">{t('scans.details.toolResultsDesc')}</p>
                </div>
              </div>
              {expandedSections.toolOutputs ? <ChevronUp className="w-5 h-5 text-gray-400" /> : <ChevronDown className="w-5 h-5 text-gray-400" />}
            </div>

            {expandedSections.toolOutputs && (
              <div className="p-6 border-t border-gray-800">
                <ToolOutputsPanel
                  scanId={scan.id}
                  authToken={localStorage.getItem('access_token') || localStorage.getItem('token')}
                />
              </div>
            )}
          </div>
        )}

        {/* AI Executive Summary - Complete Refactored Section */}
        {scan && (
          <div className="bg-brand-black-light rounded-xl p-6 border border-brand-green/30">
            <div className="flex items-center gap-2 mb-6">
              <Brain className="w-6 h-6 text-brand-green" />
              <h2 className="text-xl font-bold text-brand-green">{t('scans.details.aiReport')}</h2>
              <span className="ml-auto px-3 py-1 bg-purple-500/20 text-purple-400 text-xs rounded-full flex items-center gap-1">
                <Sparkles className="w-3 h-3" />
                {scan.status === 'running' ? 'Analysis in progress' : 'Executive Report'}
              </span>
            </div>

            {/* Loading state when scan is running */}
            {scan.status === 'running' ? (
              <div className="space-y-6">
                {/* Animated brain loader */}
                <div className="flex flex-col items-center justify-center py-8">
                  <div className="relative w-24 h-24">
                    <div className="absolute inset-0 rounded-full bg-gradient-to-br from-brand-green/20 to-purple-500/20 animate-pulse"></div>
                    <Brain className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 text-brand-green z-10" />
                    <div className="absolute -inset-2 rounded-full border-2 border-brand-green/30 animate-spin" style={{ animationDuration: '3s' }}></div>
                    <div className="absolute -inset-4 rounded-full border border-purple-500/20 animate-spin" style={{ animationDuration: '5s', animationDirection: 'reverse' }}></div>
                  </div>
                  <div className="mt-6 text-center">
                    <p className="text-brand-green font-semibold text-lg mb-2">{t('scans.details.aiAnalyzing')}</p>
                    <p className="text-gray-400 text-sm">The executive report will be available when the scan completes</p>
                  </div>
                </div>

                {/* Dynamic humorous comment */}
                <div className="bg-brand-black rounded-xl p-5 border border-gray-800 relative overflow-hidden">
                  <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-brand-green via-purple-500 to-blue-500 animate-pulse"></div>
                  <div className="flex items-start gap-3 pl-4">
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-brand-green/20 flex items-center justify-center">
                      <Sparkles className="w-4 h-4 text-brand-green" />
                    </div>
                    <div className="flex-1">
                      <p className="text-white font-medium mb-1">AI comment</p>
                      <p className="text-gray-400 text-sm italic transition-all duration-500">
                        "{getLoadingComments[loadingCommentIndex]}"
                      </p>
                    </div>
                  </div>
                </div>

                {/* Real-time progress stats */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  <div className="bg-brand-black rounded-lg p-3 border border-gray-800 text-center relative overflow-hidden group">
                    <div className="absolute inset-0 bg-gradient-to-r from-brand-green/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                    <div className="text-2xl font-bold text-brand-green">{hosts.length}</div>
                    <div className="text-xs text-gray-500">Hosts found</div>
                  </div>
                  <div className="bg-brand-black rounded-lg p-3 border border-gray-800 text-center">
                    <div className="text-2xl font-bold text-blue-400">{hosts.reduce((sum, h) => sum + (typeof h.open_ports === 'number' ? h.open_ports : (Array.isArray(h.open_ports) ? h.open_ports.length : 0)), 0)}</div>
                    <div className="text-xs text-gray-500">Open ports</div>
                  </div>
                  <div className="bg-brand-black rounded-lg p-3 border border-gray-800 text-center">
                    <div className="text-2xl font-bold text-orange-400">{vulnerabilities.length}</div>
                    <div className="text-xs text-gray-500">{t('scanDetails.vulnerabilitiesLabel')}</div>
                  </div>
                  <div className="bg-brand-black rounded-lg p-3 border border-gray-800 text-center">
                    <div className="text-2xl font-bold text-red-500">{vulnerabilities.filter(v => v.severity === 'critical').length}</div>
                    <div className="text-xs text-gray-500">{t('scanDetails.criticalLabel')}</div>
                  </div>
                </div>

                {/* Scan activity indicator */}
                <div className="flex items-center justify-center gap-2 text-sm text-gray-400">
                  <Activity className="w-4 h-4 text-blue-400 animate-pulse" />
                  <span>{t('scans.activeScanRealtime')}</span>
                  <div className="flex gap-1">
                    <span className="w-2 h-2 rounded-full bg-brand-green animate-bounce" style={{ animationDelay: '0ms' }}></span>
                    <span className="w-2 h-2 rounded-full bg-brand-green animate-bounce" style={{ animationDelay: '150ms' }}></span>
                    <span className="w-2 h-2 rounded-full bg-brand-green animate-bounce" style={{ animationDelay: '300ms' }}></span>
                  </div>
                </div>
              </div>
            ) : loadingExecutiveSummary ? (
              <div className="flex flex-col items-center justify-center py-12">
                <div className="w-12 h-12 border-4 border-brand-green/30 border-t-brand-green rounded-full animate-spin mb-4"></div>
                <p className="text-gray-400">{t('scans.loadingExecutiveReport')}</p>
              </div>
            ) : executiveSummary?.ready ? (
              <div className="space-y-6">
                {/* Introduction - What is this AI Report */}
                <div className="bg-gradient-to-br from-brand-green/10 via-purple-500/5 to-blue-500/10 rounded-xl p-6 border border-brand-green/30 relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-brand-green/5 rounded-full blur-3xl"></div>
                  <div className="absolute bottom-0 left-0 w-24 h-24 bg-purple-500/5 rounded-full blur-2xl"></div>
                  <div className="relative">
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-brand-green/20 flex items-center justify-center">
                        <Brain className="w-6 h-6 text-brand-green" />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-lg font-bold text-white mb-2">{t('scans.details.aiIntelAnalysis')}</h3>
                        <p className="text-gray-400 text-sm leading-relaxed mb-4">
                          {(() => {
                            const tpl = t('scanDetails.executiveReportDesc');
                            const idx = tpl.indexOf('{brand}');
                            const before = idx >= 0 ? tpl.substring(0, idx) : tpl;
                            const after = idx >= 0 ? tpl.substring(idx + '{brand}'.length) : '';
                            return (
                              <>
                                {before}<span className="text-brand-green font-semibold">SYLink AI</span>{after}
                              </>
                            );
                          })()}
                        </p>
                        <div className="flex flex-wrap gap-2">
                          <span className="px-3 py-1 rounded-full bg-brand-green/20 text-brand-green text-xs font-medium flex items-center gap-1">
                            <Sparkles className="w-3 h-3" />
                            {t('scanDetails.modelLabel')}: {executiveSummary.raw?.model_used || 'SYLink AI'}
                          </span>
                          <span className="px-3 py-1 rounded-full bg-purple-500/20 text-purple-400 text-xs font-medium">
                            Generation: {executiveSummary.raw?.generation_time_seconds || '?'}s
                          </span>
                          <span className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-400 text-xs font-medium">
                            {executiveSummary.cached ? 'Cached report' : 'Freshly generated'}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* AI Risk Analysis Details */}
                <div className="bg-gradient-to-br from-red-500/10 via-orange-500/5 to-yellow-500/5 rounded-xl p-6 border border-red-500/30">
                  <div className="flex items-center gap-3 mb-5">
                    <div className="w-10 h-10 rounded-xl bg-red-500/20 flex items-center justify-center">
                      <AlertTriangle className="w-5 h-5 text-red-400" />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-white">{t('scans.details.aiRiskAnalysis')}</h3>
                      <p className="text-xs text-gray-400">Detailed evaluation of identified threats</p>
                    </div>
                  </div>

                  {/* Exploitation Alert - If any exploited vulnerabilities */}
                  {vulnerabilities.filter(v => v.exploitation_successful).length > 0 && (
                    <div className="bg-purple-600/20 border border-purple-500/50 rounded-lg p-4 mb-5">
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 rounded-full bg-purple-500/30 flex items-center justify-center flex-shrink-0 animate-pulse">
                          <svg className="w-4 h-4 text-purple-300" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                          </svg>
                        </div>
                        <div className="flex-1">
                          <h4 className="text-purple-300 font-bold flex items-center gap-2">
                            {t('scanDetails.alertExploitedVulns')}
                          </h4>
                          <p className="text-sm text-purple-200/80 mt-1 mb-3">
                            {t('scanDetails.aiConfirmedExploitation', { count: vulnerabilities.filter(v => v.exploitation_successful).length })}{' '}
                            {t('scanDetails.immediateRiskFlaws')}
                          </p>
                          <div className="space-y-2">
                            {vulnerabilities.filter(v => v.exploitation_successful).map((vuln, idx) => (
                              <div key={idx} className="flex items-center gap-2 text-sm bg-purple-900/30 rounded px-3 py-2">
                                <span className="px-2 py-0.5 rounded text-xs font-bold bg-red-500/30 text-red-300">{vuln.severity?.toUpperCase()}</span>
                                <span className="text-purple-200 font-medium">{vuln.cve_id || vuln.name}</span>
                                <span className="text-purple-300/60">- {vuln.host_ip}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Risk Breakdown Grid */}
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
                    <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-3 text-center">
                      <div className="text-2xl font-bold text-red-400">{vulnerabilities.filter(v => v.severity === 'critical').length}</div>
                      <div className="text-xs text-red-300">{t('common.severities.critical')}</div>
                      <div className="text-[10px] text-gray-500 mt-1">CVSS ≥ 9.0</div>
                    </div>
                    <div className="bg-orange-500/10 border border-orange-500/30 rounded-lg p-3 text-center">
                      <div className="text-2xl font-bold text-orange-400">{vulnerabilities.filter(v => v.severity === 'high').length}</div>
                      <div className="text-xs text-orange-300">{t('common.severities.high')}</div>
                      <div className="text-[10px] text-gray-500 mt-1">{t('scans.details.cvssRangeHigh')}</div>
                    </div>
                    <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-3 text-center">
                      <div className="text-2xl font-bold text-yellow-400">{vulnerabilities.filter(v => v.severity === 'medium').length}</div>
                      <div className="text-xs text-yellow-300">{t('common.severities.medium')}</div>
                      <div className="text-[10px] text-gray-500 mt-1">{t('scans.details.cvssRangeMedium')}</div>
                    </div>
                    <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-3 text-center">
                      <div className="text-2xl font-bold text-blue-400">{vulnerabilities.filter(v => v.severity === 'low' || v.severity === 'info').length}</div>
                      <div className="text-xs text-blue-300">{t('common.severities.low')}</div>
                      <div className="text-[10px] text-gray-500 mt-1">CVSS &lt; 4.0</div>
                    </div>
                  </div>

                  {/* AI Risk Summary */}
                  <div className="bg-brand-black/50 rounded-lg p-4 mb-5">
                    <h4 className="text-white font-semibold mb-3 flex items-center gap-2">
                      <Brain className="w-4 h-4 text-brand-green" />
                      Risk Summary
                    </h4>
                    <p className="text-gray-300 text-sm leading-relaxed">
                      {executiveSummary.risk_score?.explanation || `Automated analysis by SYLink AI identified ${vulnerabilities.length} vulnerability(ies) on the tested perimeter. ${
                        vulnerabilities.filter(v => v.severity === 'critical').length > 0
                          ? `⚠️ ${vulnerabilities.filter(v => v.severity === 'critical').length} critical vulnerability(ies) detected requiring immediate attention.`
                          : t('scans.noCriticalVulns')
                      } ${
                        vulnerabilities.filter(v => v.exploitation_successful).length > 0
                          ? `🔴 ${vulnerabilities.filter(v => v.exploitation_successful).length} confirmed exploitation(s) demonstrating a real and immediate risk.`
                          : ''
                      }`}
                    </p>
                  </div>

                  {/* Top 3 Critical Risks with Solutions */}
                  {vulnerabilities.filter(v => v.severity === 'critical' || v.severity === 'high').slice(0, 3).length > 0 && (
                    <div className="space-y-3">
                      <h4 className="text-white font-semibold flex items-center gap-2">
                        <Bug className="w-4 h-4 text-red-400" />
                        Priority Risks and Solutions
                      </h4>
                      {vulnerabilities.filter(v => v.severity === 'critical' || v.severity === 'high').slice(0, 3).map((vuln, idx) => (
                        <div key={idx} className="bg-brand-black/40 rounded-lg p-4 border border-gray-700 hover:border-brand-green/50 transition-all cursor-pointer"
                             onClick={() => setSelectedVulnerability(vuln)}>
                          <div className="flex items-start justify-between mb-3">
                            <div className="flex items-center gap-2">
                              <span className={`px-2 py-0.5 rounded text-xs font-bold ${vuln.severity === 'critical' ? 'bg-red-500/30 text-red-400' : 'bg-orange-500/30 text-orange-400'}`}>
                                {vuln.severity?.toUpperCase()}
                              </span>
                              <span className="text-white font-medium">{vuln.cve_id || vuln.name}</span>
                              {vuln.exploitation_successful && (
                                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-purple-600/30 text-purple-300 border border-purple-500/50 whitespace-nowrap flex-shrink-0">
                                  <svg className="w-2.5 h-2.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                                  </svg>
                                  EXPLOITED
                                </span>
                              )}
                            </div>
                            <span className="text-xs text-gray-500 flex-shrink-0">{vuln.host_ip}</span>
                          </div>

                          {/* Risk Description */}
                          <div className="mb-3">
                            <div className="text-xs text-red-400 font-semibold mb-1">🔴 RISK</div>
                            <p className="text-sm text-gray-400">
                              {vuln.cve_id?.includes('2019-0708') ?
                                "Remote code execution without authentication. An attacker can gain full control of the system via RDP (BlueKeep)." :
                               vuln.cve_id?.includes('17-010') || vuln.title?.toLowerCase().includes('eternalblue') ?
                                "Remote code execution via SMB. Ransomware-type propagation (WannaCry, NotPetya) possible." :
                               vuln.description?.substring(0, 150) || "This vulnerability allows an attacker to execute arbitrary code or access sensitive data."
                              }...
                            </p>
                          </div>

                          {/* Solution */}
                          <div className="bg-brand-green/10 rounded-lg p-3 border border-brand-green/20">
                            <div className="text-xs text-brand-green font-semibold mb-1">✅ RECOMMENDED SOLUTION</div>
                            <p className="text-sm text-gray-300">
                              {vuln.cve_id?.includes('2019-0708') ?
                                "Apply patch KB4499175. Disable RDP if unused. Enable NLA (Network Level Authentication). Upgrade to Windows 10/11." :
                               vuln.cve_id?.includes('17-010') || vuln.title?.toLowerCase().includes('eternalblue') ?
                                "Apply patch MS17-010. Disable SMBv1. Segment the network. Deploy an EDR to detect lateral movement." :
                               vuln.ai_recommendations?.remediation ||
                               "Apply security patches. Update the system to the latest version. Check security configuration."
                              }
                            </p>
                            <div className="flex items-center gap-2 mt-2">
                              <span className={`text-[10px] px-2 py-0.5 rounded ${vuln.severity === 'critical' ? 'bg-red-500/20 text-red-400' : 'bg-orange-500/20 text-orange-400'}`}>
                                Urgency: {vuln.severity === 'critical' ? 'Immediate (D0-D7)' : 'Short term (D7-D30)'}
                              </span>
                              {vuln.cvss_score && (
                                <span className="text-[10px] px-2 py-0.5 rounded bg-gray-700 text-gray-300">
                                  CVSS: {vuln.cvss_score}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* AI Recommendations Summary */}
                {executiveSummary.raw?.recommendations?.length > 0 && (
                  <div className="bg-gradient-to-br from-brand-green/10 via-cyan-500/5 to-blue-500/5 rounded-xl p-6 border border-brand-green/30">
                    <div className="flex items-center gap-3 mb-5">
                      <div className="w-10 h-10 rounded-xl bg-brand-green/20 flex items-center justify-center">
                        <CheckCircle className="w-5 h-5 text-brand-green" />
                      </div>
                      <div>
                        <h3 className="text-lg font-bold text-white">{t('scans.details.aiRecommendations')}</h3>
                        <p className="text-xs text-gray-400">Priority actions generated by AI analysis</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {executiveSummary.raw.recommendations.slice(0, 6).map((rec, idx) => (
                        <div key={idx} className="bg-brand-black/40 rounded-lg p-3 border border-gray-700 hover:border-brand-green/50 transition-all">
                          <div className="flex items-start gap-3">
                            <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 text-xs font-bold ${
                              rec.priority === 1 ? 'bg-red-500/30 text-red-400' :
                              rec.priority === 2 ? 'bg-orange-500/30 text-orange-400' :
                              rec.priority === 3 ? 'bg-yellow-500/30 text-yellow-400' :
                              'bg-brand-green/30 text-brand-green'
                            }`}>
                              {idx + 1}
                            </div>
                            <div className="flex-1">
                              <div className="text-white font-medium text-sm mb-1">{rec.title}</div>
                              <p className="text-xs text-gray-400 line-clamp-2">{rec.description}</p>
                              <div className="flex items-center gap-2 mt-2">
                                <span className={`text-[10px] px-2 py-0.5 rounded ${
                                  rec.category === 'system' ? 'bg-blue-500/20 text-blue-400' :
                                  rec.category === 'authentication' ? 'bg-purple-500/20 text-purple-400' :
                                  rec.category === 'protocol' ? 'bg-cyan-500/20 text-cyan-400' :
                                  'bg-gray-700 text-gray-400'
                                }`}>
                                  {rec.category || 'General'}
                                </span>
                                <span className={`text-[10px] px-2 py-0.5 rounded ${
                                  rec.effort === 'low' ? 'bg-green-500/20 text-green-400' :
                                  rec.effort === 'medium' ? 'bg-yellow-500/20 text-yellow-400' :
                                  'bg-red-500/20 text-red-400'
                                }`}>
                                  Effort: {rec.effort === 'low' ? 'Low' : rec.effort === 'medium' ? 'Medium' : 'High'}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* 1. Context & Objectives */}
                <div className="bg-brand-black rounded-xl p-5 border border-gray-800">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-8 h-8 rounded-full bg-blue-500/20 flex items-center justify-center">
                      <Target className="w-4 h-4 text-blue-400" />
                    </div>
                    <h3 className="text-lg font-bold text-white">1. Context and Objectives</h3>
                  </div>
                  <p className="text-gray-300 leading-relaxed whitespace-pre-line">{executiveSummary.context?.description || 'Autonomous security audit performed by SYLink AI.'}</p>
                  {executiveSummary.context?.objectives && (
                    <ul className="mt-3 space-y-1">
                      {executiveSummary.context.objectives.map((obj, idx) => (
                        <li key={idx} className="flex items-start gap-2 text-sm text-gray-400">
                          <CheckCircle className="w-4 h-4 text-brand-green flex-shrink-0 mt-0.5" />
                          <span>{safeRenderValue(obj)}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                {/* 2. Test Perimeter */}
                <div className="bg-brand-black rounded-xl p-5 border border-gray-800">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-8 h-8 rounded-full bg-purple-500/20 flex items-center justify-center">
                      <Server className="w-4 h-4 text-purple-400" />
                    </div>
                    <h3 className="text-lg font-bold text-white">2. Perimetre de Test</h3>
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="text-center">
                      <div className="text-2xl font-bold text-brand-green">{executiveSummary.perimeter?.hosts_count || hosts.length}</div>
                      <div className="text-xs text-gray-500">{t('scans.details.hosts')}</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-bold text-blue-400">{executiveSummary.perimeter?.ports_count || 0}</div>
                      <div className="text-xs text-gray-500">Ports</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-bold text-purple-400">{executiveSummary.perimeter?.services_count || 0}</div>
                      <div className="text-xs text-gray-500">Services</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-bold text-orange-400">{vulnerabilities.length}</div>
                      <div className="text-xs text-gray-500">CVE</div>
                    </div>
                  </div>
                  {executiveSummary.perimeter?.scope && (
                    <p className="mt-4 text-sm text-gray-400">{executiveSummary.perimeter.scope}</p>
                  )}
                </div>

                {/* 3. Global Risk Score */}
                <div className="bg-brand-black rounded-xl p-5 border border-gray-800">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center">
                      <AlertTriangle className="w-4 h-4 text-red-400" />
                    </div>
                    <h3 className="text-lg font-bold text-white">3. Score de Risque Global</h3>
                  </div>
                  <div className="flex items-center gap-6">
                    <div className="relative w-32 h-32">
                      <svg className="w-full h-full transform -rotate-90" viewBox="0 0 100 100">
                        <circle cx="50" cy="50" r="45" fill="none" stroke="#1f2937" strokeWidth="8" />
                        <circle
                          cx="50" cy="50" r="45" fill="none"
                          stroke={executiveSummary.risk_score?.score >= 70 ? '#ef4444' : executiveSummary.risk_score?.score >= 40 ? '#f97316' : '#22c55e'}
                          strokeWidth="8"
                          strokeDasharray={`${(executiveSummary.risk_score?.score || 0) * 2.83} 283`}
                          strokeLinecap="round"
                        />
                      </svg>
                      <div className="absolute inset-0 flex flex-col items-center justify-center">
                        <span className={`text-3xl font-bold ${executiveSummary.risk_score?.score >= 70 ? 'text-red-500' : executiveSummary.risk_score?.score >= 40 ? 'text-orange-500' : 'text-green-500'}`}>
                          {executiveSummary.risk_score?.score || 0}
                        </span>
                        <span className="text-xs text-gray-500">/100</span>
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className={`text-xl font-bold mb-2 ${executiveSummary.risk_score?.level === 'CRITIQUE' ? 'text-red-500' : executiveSummary.risk_score?.level === 'ELEVE' ? 'text-orange-500' : executiveSummary.risk_score?.level === 'MODERE' ? 'text-yellow-500' : 'text-green-500'}`}>
                        Niveau: {executiveSummary.risk_score?.level || 'INCONNU'}
                      </div>
                      <p className="text-gray-400 text-sm">{executiveSummary.risk_score?.explanation || 'Evaluation du niveau de risque base sur les vulnerabilites detectees.'}</p>
                      <div className="mt-3 flex gap-2">
                        <span className="px-2 py-1 rounded text-xs bg-red-500/20 text-red-400">{vulnerabilities.filter(v => v.severity === 'critical').length} {t('common.severities.critical')}</span>
                        <span className="px-2 py-1 rounded text-xs bg-orange-500/20 text-orange-400">{vulnerabilities.filter(v => v.severity === 'high').length} {t('common.severities.high')}</span>
                        <span className="px-2 py-1 rounded text-xs bg-yellow-500/20 text-yellow-400">{vulnerabilities.filter(v => v.severity === 'medium').length} {t('common.severities.medium')}</span>
                        <span className="px-2 py-1 rounded text-xs bg-blue-500/20 text-blue-400">{vulnerabilities.filter(v => v.severity === 'low').length} Basses</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 4. Attack Scenarios */}
                <div className="bg-brand-black rounded-xl p-5 border border-gray-800">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-8 h-8 rounded-full bg-orange-500/20 flex items-center justify-center">
                      <Activity className="w-4 h-4 text-orange-400" />
                    </div>
                    <h3 className="text-lg font-bold text-white">4. Scenarios d'Attaque Identifies</h3>
                  </div>
                  {executiveSummary.attack_scenarios?.length > 0 ? (
                    <div className="space-y-3">
                      {executiveSummary.attack_scenarios.map((scenario, idx) => (
                        <div key={idx} className="bg-brand-black-light rounded-lg p-4 border border-gray-700">
                          <div className="flex items-start gap-3">
                            <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${scenario.severity === 'critical' ? 'bg-red-500/20 text-red-400' : scenario.severity === 'high' ? 'bg-orange-500/20 text-orange-400' : 'bg-yellow-500/20 text-yellow-400'}`}>
                              {idx + 1}
                            </div>
                            <div className="flex-1">
                              <h4 className="font-semibold text-white mb-1">{safeRenderValue(scenario.name) || `Scenario ${idx + 1}`}</h4>
                              <p className="text-sm text-gray-400 mb-2">{safeRenderValue(scenario.description)}</p>
                              {scenario.mitre_techniques && (
                                <div className="flex flex-wrap gap-1">
                                  {scenario.mitre_techniques.map((tech, tidx) => (
                                    <span key={tidx} className="px-2 py-0.5 rounded text-xs bg-purple-500/20 text-purple-400">{safeRenderValue(tech)}</span>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-gray-400 text-sm">{t('scans.noAttackScenario')}</p>
                  )}
                </div>

                {/* 5. Top 5 Vulnerabilities */}
                <div className="bg-brand-black rounded-xl p-5 border border-gray-800">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center">
                      <Bug className="w-4 h-4 text-red-400" />
                    </div>
                    <h3 className="text-lg font-bold text-white">5. Top 5 Vulnerabilites Critiques</h3>
                  </div>
                  <div className="space-y-2">
                    {(() => {
                      const topVulns = executiveSummary.top_vulnerabilities?.length > 0
                        ? executiveSummary.top_vulnerabilities
                        : vulnerabilities.filter(v => v.severity === 'critical' || v.severity === 'high').slice(0, 5);

                      if (topVulns.length === 0) {
                        return (
                          <div className="text-center py-6 text-gray-400">
                            <Bug className="w-8 h-8 mx-auto mb-2 opacity-50" />
                            <p>{t('scans.noVulnDetected')}</p>
                          </div>
                        );
                      }

                      return topVulns.map((vuln, idx) => (
                        <div
                          key={idx}
                          className="flex items-center gap-3 bg-brand-black-light rounded-lg p-3 border border-gray-700 cursor-pointer hover:border-brand-green/50 hover:bg-brand-black transition-all"
                          onClick={() => setSelectedVulnerability(vuln)}
                        >
                          <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold flex-shrink-0 ${vuln.severity === 'critical' ? 'bg-red-500/20 text-red-400' : vuln.severity === 'high' ? 'bg-orange-500/20 text-orange-400' : vuln.severity === 'medium' ? 'bg-yellow-500/20 text-yellow-400' : 'bg-blue-500/20 text-blue-400'}`}>
                            {idx + 1}
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 flex-wrap">
                              <span className="font-medium text-white truncate max-w-[180px]">{vuln.cve_id || vuln.name || vuln.title}</span>
                              {vuln.exploitation_successful && (
                                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-purple-600/30 text-purple-300 border border-purple-500/50 animate-pulse whitespace-nowrap flex-shrink-0">
                                  <svg className="w-2.5 h-2.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                                  </svg>
                                  EXPLOITED
                                </span>
                              )}
                            </div>
                            <div className="text-xs text-gray-500 truncate">{vuln.host_ip || vuln.ip} - {vuln.description?.substring(0, 60)}...</div>
                          </div>
                          <div className={`px-2 py-1 rounded text-xs font-bold flex-shrink-0 ${vuln.severity === 'critical' ? 'bg-red-500/20 text-red-400' : vuln.severity === 'high' ? 'bg-orange-500/20 text-orange-400' : vuln.severity === 'medium' ? 'bg-yellow-500/20 text-yellow-400' : 'bg-blue-500/20 text-blue-400'}`}>
                            {vuln.cvss_score || (vuln.severity === 'critical' ? '9.0+' : vuln.severity === 'high' ? '7.0-8.9' : vuln.severity === 'medium' ? '4.0-6.9' : '0-3.9')}
                          </div>
                        </div>
                      ));
                    })()}
                  </div>
                </div>

                {/* 6. Identity & Access Focus */}
                <div className="bg-brand-black rounded-xl p-5 border border-gray-800">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-8 h-8 rounded-full bg-cyan-500/20 flex items-center justify-center">
                      <Lock className="w-4 h-4 text-cyan-400" />
                    </div>
                    <h3 className="text-lg font-bold text-white">6. Identities and Access</h3>
                  </div>
                  {executiveSummary.identity_access ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <h4 className="text-sm font-semibold text-gray-400 mb-2">{t('scans.details.weakPoints')}</h4>
                        <ul className="space-y-1">
                          {(executiveSummary.identity_access.weaknesses || []).map((weakness, idx) => (
                            <li key={idx} className="flex items-start gap-2 text-sm text-gray-300">
                              <XCircle className="w-4 h-4 text-red-400 flex-shrink-0 mt-0.5" />
                              <span>{safeRenderValue(weakness)}</span>
                            </li>
                          ))}
                          {(!executiveSummary.identity_access.weaknesses || executiveSummary.identity_access.weaknesses.length === 0) && (
                            <li className="text-sm text-gray-500">{t('scans.noWeakness')}</li>
                          )}
                        </ul>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-gray-400 mb-2">{t('common.recommendations')}</h4>
                        <ul className="space-y-1">
                          {(executiveSummary.identity_access.recommendations || []).map((rec, idx) => (
                            <li key={idx} className="flex items-start gap-2 text-sm text-gray-300">
                              <CheckCircle className="w-4 h-4 text-brand-green flex-shrink-0 mt-0.5" />
                              <span>{safeRenderValue(rec)}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ) : (
                    <p className="text-gray-400 text-sm">{t('scans.details.analyzingIdentities')}</p>
                  )}
                </div>

                {/* 7. Business Impact */}
                <div className="bg-brand-black rounded-xl p-5 border border-gray-800">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-8 h-8 rounded-full bg-yellow-500/20 flex items-center justify-center">
                      <TrendingDown className="w-4 h-4 text-yellow-400" />
                    </div>
                    <h3 className="text-lg font-bold text-white">7. Impact Business</h3>
                  </div>
                  {executiveSummary.business_impact ? (
                    <div className="space-y-4">
                      <MarkdownRenderer content={executiveSummary.business_impact.summary} variant="compact" />
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                        {(executiveSummary.business_impact.impacts || []).map((impact, idx) => (
                          <div key={idx} className={`rounded-lg p-3 border ${impact.level === 'high' ? 'bg-red-500/10 border-red-500/30' : impact.level === 'medium' ? 'bg-orange-500/10 border-orange-500/30' : 'bg-yellow-500/10 border-yellow-500/30'}`}>
                            <div className={`text-sm font-bold mb-1 ${impact.level === 'high' ? 'text-red-400' : impact.level === 'medium' ? 'text-orange-400' : 'text-yellow-400'}`}>
                              {impact.type}
                            </div>
                            <div className="text-xs text-gray-400">{impact.description}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <p className="text-gray-400 text-sm">{t('scans.details.businessImpactPending')}</p>
                  )}
                </div>

                {/* 8. Prioritized Action Plan */}
                <div className="bg-brand-black rounded-xl p-5 border border-gray-800">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-8 h-8 rounded-full bg-brand-green/20 flex items-center justify-center">
                      <Calendar className="w-4 h-4 text-brand-green" />
                    </div>
                    <h3 className="text-lg font-bold text-white">8. Plan d'Action Prioritaire</h3>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {/* D0-30 */}
                    <div className="bg-red-500/10 rounded-lg p-4 border border-red-500/30">
                      <div className="flex items-center gap-2 mb-3">
                        <div className="w-6 h-6 rounded-full bg-red-500/30 flex items-center justify-center">
                          <AlertTriangle className="w-3 h-3 text-red-400" />
                        </div>
                        <span className="font-bold text-red-400">D0 - D30</span>
                      </div>
                      <ul className="space-y-2">
                        {(executiveSummary.action_plan?.d0_d30 || []).map((action, idx) => (
                          <li key={idx} className="text-sm text-gray-300 flex items-start gap-2">
                            <span className="text-red-400 font-bold">•</span>
                            <span>{safeRenderValue(action)}</span>
                          </li>
                        ))}
                        {(!executiveSummary.action_plan?.d0_d30 || executiveSummary.action_plan.d0_d30.length === 0) && (
                          <li className="text-sm text-gray-500">{t('scans.details.fixCritical')}</li>
                        )}
                      </ul>
                    </div>
                    {/* D30-90 */}
                    <div className="bg-orange-500/10 rounded-lg p-4 border border-orange-500/30">
                      <div className="flex items-center gap-2 mb-3">
                        <div className="w-6 h-6 rounded-full bg-orange-500/30 flex items-center justify-center">
                          <Clock className="w-3 h-3 text-orange-400" />
                        </div>
                        <span className="font-bold text-orange-400">D30 - D90</span>
                      </div>
                      <ul className="space-y-2">
                        {(executiveSummary.action_plan?.d30_d90 || []).map((action, idx) => (
                          <li key={idx} className="text-sm text-gray-300 flex items-start gap-2">
                            <span className="text-orange-400 font-bold">•</span>
                            <span>{safeRenderValue(action)}</span>
                          </li>
                        ))}
                        {(!executiveSummary.action_plan?.d30_d90 || executiveSummary.action_plan.d30_d90.length === 0) && (
                          <li className="text-sm text-gray-500">{t('scans.details.fixHigh')}</li>
                        )}
                      </ul>
                    </div>
                    {/* D90-12M */}
                    <div className="bg-brand-green/10 rounded-lg p-4 border border-brand-green/30">
                      <div className="flex items-center gap-2 mb-3">
                        <div className="w-6 h-6 rounded-full bg-brand-green/30 flex items-center justify-center">
                          <TrendingUp className="w-3 h-3 text-brand-green" />
                        </div>
                        <span className="font-bold text-brand-green">D90 - 12M</span>
                      </div>
                      <ul className="space-y-2">
                        {(executiveSummary.action_plan?.d90_12m || []).map((action, idx) => (
                          <li key={idx} className="text-sm text-gray-300 flex items-start gap-2">
                            <span className="text-brand-green font-bold">•</span>
                            <span>{safeRenderValue(action)}</span>
                          </li>
                        ))}
                        {(!executiveSummary.action_plan?.d90_12m || executiveSummary.action_plan.d90_12m.length === 0) && (
                          <li className="text-sm text-gray-500">{t('scans.details.continuousImprovements')}</li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>

                {/* 9. Positive Points */}
                <div className="bg-brand-black rounded-xl p-5 border border-brand-green/30">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-8 h-8 rounded-full bg-brand-green/20 flex items-center justify-center">
                      <CheckCircle className="w-4 h-4 text-brand-green" />
                    </div>
                    <h3 className="text-lg font-bold text-white">9. Points Positifs</h3>
                  </div>
                  {executiveSummary.positive_points?.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {executiveSummary.positive_points.map((point, idx) => (
                        <div key={idx} className="flex items-start gap-3 bg-brand-green/10 rounded-lg p-3 border border-brand-green/20">
                          <CheckCircle className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" />
                          <span className="text-gray-300 text-sm">{safeRenderValue(point)}</span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-gray-400 text-sm">{t('scans.details.positivePointsPending')}</p>
                  )}
                </div>

                {/* Validate and Generate Report Button */}
                <button
                  onClick={handleValidateAndGenerateReport}
                  disabled={isValidating}
                  className={`w-full py-4 rounded-xl font-bold text-lg flex items-center justify-center gap-3 transition-all ${
                    isValidating
                      ? 'bg-gray-700 text-gray-400 cursor-not-allowed'
                      : 'bg-gradient-to-r from-brand-green to-green-500 text-black hover:from-green-500 hover:to-brand-green shadow-lg hover:shadow-brand-green/30'
                  }`}
                >
                  {isValidating ? (
                    <>
                      <div className="w-5 h-5 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
                      <span>{t('scans.details.validating')}</span>
                    </>
                  ) : (
                    <>
                      <FileCheck className="w-5 h-5" />
                      <span>{t('common.validateForReport')}</span>
                      <Send className="w-5 h-5" />
                    </>
                  )}
                </button>
              </div>
            ) : (
              <div className="text-center py-8 text-gray-400">
                <Brain className="w-12 h-12 mx-auto mb-3 opacity-50" />
                <p>{scan?.status === 'running' ? 'Le rapport sera genere une fois le scan termine.' : 'Cliquez pour generer le rapport IA.'}</p>
                {scan?.status !== 'running' && (
                  <button
                    onClick={() => fetchExecutiveSummary(scan?.id)}
                    className="mt-4 px-6 py-2 bg-brand-green text-black rounded-lg font-semibold hover:bg-green-500 transition-colors"
                  >
                    {t('reports.generateReport')}
                  </button>
                )}
              </div>
            )}
          </div>
        )}

        {/* Screenshot Zoom Modal */}
        {selectedScreenshot && (
          <div
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedScreenshot(null)}
          >
            <div
              className="bg-brand-black-light rounded-2xl border border-brand-green/30 max-w-5xl w-full max-h-[90vh] overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div className="p-4 border-b border-gray-800 flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-bold text-white">{selectedScreenshot.title}</h3>
                  <p className="text-sm text-gray-500">{selectedScreenshot.description}</p>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={handleZoomOut}
                    className="p-2 bg-gray-800 rounded-lg hover:bg-gray-700"
                    disabled={screenshotZoom <= 0.5}
                  >
                    <ZoomOut className="w-5 h-5 text-gray-400" />
                  </button>
                  <span className="text-sm text-gray-400 w-16 text-center">{Math.round(screenshotZoom * 100)}%</span>
                  <button
                    onClick={handleZoomIn}
                    className="p-2 bg-gray-800 rounded-lg hover:bg-gray-700"
                    disabled={screenshotZoom >= 3}
                  >
                    <ZoomIn className="w-5 h-5 text-gray-400" />
                  </button>
                  <button
                    onClick={() => setSelectedScreenshot(null)}
                    className="p-2 bg-gray-800 rounded-lg hover:bg-gray-700 ml-2"
                  >
                    <X className="w-5 h-5 text-gray-400" />
                  </button>
                </div>
              </div>
              {/* Modal Content */}
              <div className="p-6 overflow-auto max-h-[70vh]">
                <div
                  className="bg-gray-900 rounded-xl overflow-auto transition-transform"
                  style={{ transform: `scale(${screenshotZoom})`, transformOrigin: 'top left' }}
                >
                  {selectedScreenshot.isConsole ? (
                    /* Console capture - show text content */
                    <div className="p-6 font-mono text-sm text-green-400">
                      <div className="flex items-center gap-2 mb-4 pb-2 border-b border-gray-700">
                        <Terminal className="w-5 h-5 text-brand-green" />
                        <span className="text-brand-green font-medium">Console Output</span>
                      </div>
                      <pre className="whitespace-pre-wrap overflow-auto max-h-[55vh]">{selectedScreenshot.content || t('scans.noContent')}</pre>
                    </div>
                  ) : selectedScreenshot.path ? (
                    <img
                      src={`${process.env.REACT_APP_API_URL || ''}${selectedScreenshot.path}`}
                      alt={selectedScreenshot.title}
                      className="w-full h-auto rounded-xl"
                      onError={(e) => {
                        const retries = parseInt(e.target.dataset.retries || '0');
                        if (retries < 2) {
                          e.target.dataset.retries = retries + 1;
                          const base = e.target.src.split('?')[0];
                          setTimeout(() => { e.target.src = `${base}?r=${retries + 1}&t=${Date.now()}`; }, 1500);
                        } else {
                          e.target.style.display = 'none';
                        }
                      }}
                    />
                  ) : (
                    <div className="p-6 font-mono text-sm text-green-400">
                      <pre className="whitespace-pre-wrap">{selectedScreenshot.content || t('scans.noContent')}</pre>
                    </div>
                  )}
                </div>
              </div>
              {/* Modal Footer with Feedback */}
              <div className="p-4 border-t border-gray-800 flex items-center justify-between">
                <span className="text-sm text-gray-500">
                  {t('scanDetails.capturedOn')} {new Date(selectedScreenshot.timestamp).toLocaleString()}
                </span>
                <div className="flex items-center gap-3">
                  <button
                    onClick={() => handleAIFeedback(`screenshot-${selectedScreenshot.id}`, 'positive')}
                    className={`px-4 py-2 rounded-lg flex items-center gap-2 ${
                      aiFeedbacks[`screenshot-${selectedScreenshot.id}`]?.type === 'positive'
                        ? 'bg-green-500/20 text-green-400 border border-green-500/50'
                        : 'bg-gray-800 text-gray-400 hover:text-green-400'
                    }`}
                  >
                    <ThumbsUp className="w-4 h-4" />
                    {t('common.yes')}
                  </button>
                  <button
                    onClick={() => setShowFeedbackModal(`screenshot-${selectedScreenshot.id}`)}
                    className={`px-4 py-2 rounded-lg flex items-center gap-2 ${
                      aiFeedbacks[`screenshot-${selectedScreenshot.id}`]?.type === 'negative'
                        ? 'bg-red-500/20 text-red-400 border border-red-500/50'
                        : 'bg-gray-800 text-gray-400 hover:text-red-400'
                    }`}
                  >
                    <ThumbsDown className="w-4 h-4" />
                    {t('common.no')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Feedback Modal */}
        {showFeedbackModal && (
          <div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={() => setShowFeedbackModal(null)}
          >
            <div
              className="bg-brand-black-light rounded-2xl border border-brand-green/30 w-full max-w-md p-6"
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
                <MessageSquare className="w-5 h-5 text-brand-green" />
                {t('scanDetails.aiFeedback')}
              </h3>
              <p className="text-gray-400 text-sm mb-4">
                {t('scanDetails.aiFeedbackDesc')}
              </p>
              <textarea
                value={feedbackComment}
                onChange={(e) => setFeedbackComment(e.target.value)}
                placeholder="Describe the issue (false positive, incorrect information, etc.)..."
                className="w-full h-32 px-4 py-3 bg-brand-black border border-gray-700 rounded-lg text-white resize-none focus:border-brand-green focus:outline-none"
              />
              <div className="flex items-center justify-end gap-3 mt-4">
                <button
                  onClick={() => setShowFeedbackModal(null)}
                  className="px-4 py-2 text-gray-400 hover:text-white"
                >
                  {t('common.cancel')}
                </button>
                <button
                  onClick={() => handleAIFeedback(showFeedbackModal, 'negative', feedbackComment)}
                  className="px-6 py-2 bg-red-500/20 text-red-400 border border-red-500/50 rounded-lg hover:bg-red-500/30"
                >
                  {t('common.submit')}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Vulnerability Slider */}
        <VulnerabilitySlider
          vulnerability={selectedVulnerability ? {
            ...selectedVulnerability,
            // Enrich with host data
            host_ip: selectedVulnerability.ip_address ||
                     hosts.find(h => h.id === selectedVulnerability.host_id)?.ip_address || 'N/A',
            hostname: selectedVulnerability.hostname ||
                      hosts.find(h => h.id === selectedVulnerability.host_id)?.hostname,
            port: selectedVulnerability.port ||
                  hosts.find(h => h.id === selectedVulnerability.host_id)?.ports?.[0]?.port,
            service: selectedVulnerability.service ||
                     hosts.find(h => h.id === selectedVulnerability.host_id)?.services?.[0]?.name,
            tool: selectedVulnerability.discovered_by
          } : null}
          isOpen={!!selectedVulnerability}
          onClose={() => setSelectedVulnerability(null)}
        />

        {/* AI Storytelling Window — disabled */}
        <AIStorytellingWindow
          scanId={id}
          isOpen={false}
          onClose={() => setShowStorytellingWindow(false)}
          scanTarget={scan?.target}
        />

        {/* Schedule Modal */}
        {showScheduleModal && (
          <div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={() => setShowScheduleModal(false)}
          >
            <div
              className="bg-brand-black-light rounded-2xl border border-cyan-500/30 w-full max-w-5xl p-6 flex gap-6"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Left side - Configuration Form */}
              <div className="flex-1 min-w-0">
                <h3 className="text-xl font-bold text-white mb-2 flex items-center gap-2">
                  <Calendar className="w-6 h-6 text-cyan-400" />
                  {t('scanDetails.scheduleThisScan')}
                </h3>
                <p className="text-gray-400 text-sm mb-6">
                  {(() => {
                    const tpl = t('scanDetails.configureRecurrence');
                    const idx = tpl.indexOf('{target}');
                    const before = idx >= 0 ? tpl.substring(0, idx) : tpl;
                    const after = idx >= 0 ? tpl.substring(idx + '{target}'.length) : '';
                    return (
                      <>
                        {before}<span className="text-cyan-400 font-medium">{scan?.target}</span>{after}
                      </>
                    );
                  })()}
                </p>

              {/* Frequency Selection */}
              <div className="mb-6">
                <label className="text-sm text-gray-400 mb-2 block">{t('scanDetails.frequencyLabel')}</label>
                <div className="grid grid-cols-5 gap-2">
                  {[
                    { value: 'weekly', label: t('scanDetails.freqLabel.weekly') },
                    { value: 'monthly', label: t('scanDetails.freqLabel.monthly') },
                    { value: 'quarterly', label: t('scanDetails.freqLabel.quarterly') },
                    { value: 'semestrial', label: t('scanDetails.freqLabel.semestrial') },
                    { value: 'yearly', label: t('scanDetails.freqLabel.yearly') }
                  ].map(freq => (
                    <button
                      key={freq.value}
                      onClick={() => setScheduleConfig(prev => ({ ...prev, frequency: freq.value }))}
                      className={`px-3 py-2 rounded-lg text-sm font-medium transition-all ${
                        scheduleConfig.frequency === freq.value
                          ? 'bg-cyan-500/20 text-cyan-400 border border-cyan-500/50'
                          : 'bg-brand-black text-gray-400 border border-gray-700 hover:border-gray-600'
                      }`}
                    >
                      {freq.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Days of Week - For weekly, monthly, quarterly, semestrial, yearly */}
              {['weekly', 'monthly', 'quarterly', 'semestrial', 'yearly'].includes(scheduleConfig.frequency) && (
                <div className="mb-6">
                  <label className="text-sm text-gray-400 mb-2 block">
                    {scheduleConfig.frequency === 'weekly'
                      ? t('scanDetails.daysOfTheWeekLabel')
                      : t('scanDetails.dayOfTheWeekLabel')}
                  </label>
                  <div className="flex gap-2">
                    {[
                      { value: 0, label: t('scanDetails.daysOfWeekMini.sun') },
                      { value: 1, label: t('scanDetails.daysOfWeekMini.mon') },
                      { value: 2, label: t('scanDetails.daysOfWeekMini.tue') },
                      { value: 3, label: t('scanDetails.daysOfWeekMini.wed') },
                      { value: 4, label: t('scanDetails.daysOfWeekMini.thu') },
                      { value: 5, label: t('scanDetails.daysOfWeekMini.fri') },
                      { value: 6, label: t('scanDetails.daysOfWeekMini.sat') }
                    ].map(day => (
                      <button
                        key={day.value}
                        onClick={() => {
                          if (scheduleConfig.frequency === 'weekly') {
                            // Multi-select for weekly
                            toggleDayOfWeek(day.value);
                          } else {
                            // Single select for monthly/quarterly
                            setScheduleConfig(prev => ({
                              ...prev,
                              days_of_week: [day.value]
                            }));
                          }
                        }}
                        className={`w-10 h-10 rounded-lg text-sm font-medium transition-all ${
                          (scheduleConfig.days_of_week || []).includes(day.value)
                            ? 'bg-cyan-500/20 text-cyan-400 border border-cyan-500/50'
                            : 'bg-brand-black text-gray-400 border border-gray-700 hover:border-gray-600'
                        }`}
                      >
                        {day.label}
                      </button>
                    ))}
                  </div>
                  {scheduleConfig.frequency !== 'weekly' && (
                    <p className="text-xs text-gray-500 mt-2">
                      {(() => {
                        const dayKeys = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                        const dayName = t(`scanDetails.daysOfWeek.${dayKeys[(scheduleConfig.days_of_week || [1])[0]]}`);
                        const periodKeyMap = { monthly: 'freqEveryMonth', quarterly: 'freqEveryQuarter', semestrial: 'freqEvery6Months', yearly: 'freqEveryYear' };
                        const period = periodKeyMap[scheduleConfig.frequency] ? t(`scanDetails.${periodKeyMap[scheduleConfig.frequency]}`) : '';
                        return t('scanDetails.scheduleRunRule', { day: dayName, period });
                      })()}
                    </p>
                  )}
                </div>
              )}

              {/* Time Selection */}
              <div className="mb-6">
                <label className="text-sm text-gray-400 mb-2 block">{t('scanDetails.executionTime')}</label>
                <input
                  type="time"
                  value={scheduleConfig.time_of_day}
                  onChange={(e) => setScheduleConfig(prev => ({ ...prev, time_of_day: e.target.value }))}
                  className="w-full px-4 py-3 bg-brand-black border border-gray-700 rounded-lg text-white focus:border-cyan-500 focus:outline-none"
                />
                <p className="text-xs text-gray-500 mt-1">{t('scanDetails.timezoneEuropeParis')}</p>
              </div>

              {/* Auto Report */}
              <div className="mb-6">
                <label className="flex items-center gap-2 cursor-pointer mb-3">
                  <input
                    type="checkbox"
                    checked={scheduleConfig.auto_generate_report}
                    onChange={(e) => setScheduleConfig(prev => ({ ...prev, auto_generate_report: e.target.checked }))}
                    className="w-5 h-5 rounded border-gray-600 bg-brand-black text-cyan-500 focus:ring-cyan-500 flex-shrink-0"
                  />
                  <div>
                    <span className="text-white font-medium">{t('scanDetails.autoGenerateReport')}</span>
                    <p className="text-xs text-gray-500">{t('scanDetails.selectReportFormats')}</p>
                  </div>
                </label>
                {scheduleConfig.auto_generate_report && (
                  <div className="ml-8">
                    <label className="text-sm text-gray-400 mb-2 block">{t('scanDetails.reportFormats')}</label>
                    <div className="flex flex-wrap gap-2">
                      {[
                        { value: 'pentest', label: t('scanDetails.reportFormatLabels.pentest'), icon: '🔐' },
                        { value: 'remediation', label: t('scanDetails.reportFormatLabels.remediation'), icon: '🛠️' },
                        { value: 'comex', label: t('scanDetails.reportFormatLabels.comex'), icon: '📊' },
                        { value: 'cve_json', label: t('scanDetails.reportFormatLabels.cveJson'), icon: '🗂️' }
                      ].map(format => (
                        <button
                          key={format.value}
                          type="button"
                          onClick={() => {
                            setScheduleConfig(prev => {
                              const formats = prev.report_formats || [];
                              if (formats.includes(format.value)) {
                                // Don't allow removing the last format
                                if (formats.length > 1) {
                                  return { ...prev, report_formats: formats.filter(f => f !== format.value) };
                                }
                                return prev;
                              } else {
                                return { ...prev, report_formats: [...formats, format.value] };
                              }
                            });
                          }}
                          className={`px-3 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-1.5 ${
                            (scheduleConfig.report_formats || []).includes(format.value)
                              ? 'bg-cyan-500/20 text-cyan-400 border border-cyan-500/50'
                              : 'bg-brand-black text-gray-400 border border-gray-700 hover:border-gray-600'
                          }`}
                        >
                          <span>{format.icon}</span>
                          <span>{format.label}</span>
                        </button>
                      ))}
                    </div>
                    <p className="text-xs text-gray-500 mt-2">
                      {(scheduleConfig.report_formats || []).length} {(scheduleConfig.report_formats || []).length > 1 ? t('reports.formats') : t('reports.format')} {t('common.enabled').toLowerCase()}
                    </p>
                  </div>
                )}
              </div>

              {/* End after X runs */}
              <div className="mb-6">
                <label className="flex items-center gap-2 cursor-pointer mb-3">
                  <input
                    type="checkbox"
                    checked={scheduleConfig.has_end}
                    onChange={(e) => setScheduleConfig(prev => ({
                      ...prev,
                      has_end: e.target.checked,
                      max_runs: e.target.checked ? (prev.max_runs || 12) : null
                    }))}
                    className="w-5 h-5 rounded border-gray-600 bg-brand-black text-cyan-500 focus:ring-cyan-500 flex-shrink-0"
                  />
                  <div>
                    <span className="text-white font-medium">{t('scanDetails.limitExecutions')}</span>
                    <p className="text-xs text-gray-500">{t('scanDetails.autoStopAfterDesc')}</p>
                  </div>
                </label>
                {scheduleConfig.has_end && (
                  <div className="ml-8 flex items-center gap-3">
                    <span className="text-sm text-gray-400">{t('scanDetails.endAfter')}</span>
                    <input
                      type="number"
                      min="1"
                      max="100"
                      value={scheduleConfig.max_runs || 12}
                      onChange={(e) => setScheduleConfig(prev => ({
                        ...prev,
                        max_runs: Math.max(1, Math.min(100, parseInt(e.target.value) || 1))
                      }))}
                      className="w-20 px-3 py-2 bg-brand-black border border-gray-700 rounded-lg text-white text-center focus:border-cyan-500 focus:outline-none"
                    />
                    <span className="text-sm text-gray-400">{t('scanDetails.executionsUnit')}</span>
                  </div>
                )}
              </div>

              {/* Summary */}
              <div className="bg-brand-black rounded-lg p-4 border border-gray-800 mb-6">
                <div className="flex items-center gap-2 mb-2">
                  <Repeat className="w-4 h-4 text-cyan-400" />
                  <span className="text-sm font-medium text-white">{t('scanDetails.summaryLabel')}</span>
                </div>
                <p className="text-sm text-gray-400">
                  {t('scanDetails.schedulePrefix')}{' '}
                  <span className="text-cyan-400 font-medium">
                    {(() => {
                      const dayKeys = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                      const shortKeys = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
                      const firstDay = (scheduleConfig.days_of_week || [1])[0];
                      const dayName = t(`scanDetails.daysOfWeek.${dayKeys[firstDay]}`);
                      if (scheduleConfig.frequency === 'weekly') {
                        const days = (scheduleConfig.days_of_week || [])
                          .map(d => t(`scanDetails.daysOfWeekShort.${shortKeys[d]}`))
                          .join(', ') || t('scanDetails.noDaySelected');
                        return t('scanDetails.scheduleSummaryWeekly', { days });
                      }
                      if (scheduleConfig.frequency === 'monthly') return t('scanDetails.scheduleSummaryMonthly', { day: dayName });
                      if (scheduleConfig.frequency === 'quarterly') return t('scanDetails.scheduleSummaryQuarterly', { day: dayName });
                      if (scheduleConfig.frequency === 'semestrial') return t('scanDetails.scheduleSummarySemestrial', { day: dayName });
                      if (scheduleConfig.frequency === 'yearly') return t('scanDetails.scheduleSummaryYearly', { day: dayName });
                      return '';
                    })()}
                  </span>
                  {' '}{t('scanDetails.scheduleAt')} <span className="text-cyan-400 font-medium">{scheduleConfig.time_of_day}</span>
                  {scheduleConfig.has_end && scheduleConfig.max_runs && (
                    <>, <span className="text-orange-400 font-medium">{t('scanDetails.forNExecutions', { count: scheduleConfig.max_runs })}</span></>
                  )}
                  {scheduleConfig.auto_generate_report && (
                    <>. {t('scanDetails.reportsLabel')}: <span className="text-green-400 font-medium">
                      {(scheduleConfig.report_formats || ['pentest']).map(f => {
                        const map = { pentest: 'pentestShort', remediation: 'remediationShort', comex: 'comexShort', cve_json: 'cveJsonShort' };
                        return map[f] ? t(`scanDetails.reportFormatLabels.${map[f]}`) : f.toUpperCase();
                      }).join(', ')}
                    </span></>
                  )}
                </p>
              </div>

              {/* Actions */}
              <div className="flex items-center justify-end gap-3">
                <button
                  onClick={() => setShowScheduleModal(false)}
                  className="px-4 py-2 text-gray-400 hover:text-white"
                >
                  {t('common.cancel')}
                </button>
                <button
                  onClick={handleCreateSchedule}
                  disabled={isScheduling || (['weekly', 'monthly', 'quarterly', 'semestrial', 'yearly'].includes(scheduleConfig.frequency) && (!scheduleConfig.days_of_week || scheduleConfig.days_of_week.length === 0))}
                  className={`px-6 py-2.5 rounded-lg font-medium flex items-center gap-2 transition-all ${
                    isScheduling || (['weekly', 'monthly', 'quarterly', 'semestrial', 'yearly'].includes(scheduleConfig.frequency) && (!scheduleConfig.days_of_week || scheduleConfig.days_of_week.length === 0))
                      ? 'bg-gray-700 text-gray-400 cursor-not-allowed'
                      : 'bg-gradient-to-r from-cyan-500 to-blue-500 text-white hover:from-cyan-600 hover:to-blue-600'
                  }`}
                >
                  {isScheduling ? (
                    <>
                      <div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
                      <span>{t('common.creating')}</span>
                    </>
                  ) : (
                    <>
                      <Save className="w-4 h-4" />
                      <span>{t('scans.saveSchedule')}</span>
                    </>
                  )}
                </button>
              </div>
              </div>

              {/* Right side - Schedule Visualization */}
              <div className="w-80 bg-brand-black rounded-xl border border-gray-800 p-4 flex flex-col">
                <h4 className="text-sm font-medium text-white mb-3 flex items-center gap-2">
                  <Clock className="w-4 h-4 text-orange-400" />
                  {t('scanDetails.runningScheduledScans')}
                </h4>

                {loadingScheduleData ? (
                  <div className="flex-1 flex items-center justify-center">
                    <div className="w-6 h-6 border-2 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                ) : (
                  <div className="flex-1 overflow-y-auto space-y-3">
                    {/* Running Scans Section */}
                    {runningScans.length > 0 && (
                      <div className="space-y-2">
                        <span className="text-xs text-orange-400 font-medium uppercase">{t('scanDetails.runningScansSection')}</span>
                        {runningScans.map((s, idx) => (
                          <div key={s.id || idx} className="p-2 bg-orange-500/10 border border-orange-500/30 rounded-lg">
                            <div className="flex items-center gap-2">
                              <span className="text-xs text-white font-medium truncate">{s.target}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Scheduled Scans Section */}
                    {existingSchedules.length > 0 && (
                      <div className="space-y-2">
                        <span className="text-xs text-cyan-400 font-medium uppercase">{t('scanDetails.scheduledScansSection')}</span>
                        {existingSchedules.map((s, idx) => (
                          <div
                            key={s.id || idx}
                            className={`p-2 rounded-lg border ${
                              s.is_paused
                                ? 'bg-gray-500/10 border-gray-500/30'
                                : 'bg-cyan-500/10 border-cyan-500/30'
                            }`}
                          >
                            <div className="flex items-center justify-between">
                              <span className="text-xs text-white font-medium truncate flex-1">{s.name}</span>
                              {s.is_paused && (
                                <span className="text-xs text-gray-400 ml-1">⏸</span>
                              )}
                            </div>
                            <div className="text-xs text-gray-400 mt-1">
                              {s.frequency === 'daily' && `📅 ${t('scanDetails.freqLabel.daily')}`}
                              {s.frequency === 'weekly' && `📅 ${t('scanDetails.freqLabel.weekly')}`}
                              {s.frequency === 'monthly' && `📅 ${t('scanDetails.freqLabel.monthly')}`}
                              {s.frequency === 'quarterly' && `📅 ${t('scanDetails.freqLabel.quarterly')}`}
                              {s.frequency === 'semestrial' && `📅 ${t('scanDetails.freqLabel.semestrial')}`}
                              {s.frequency === 'yearly' && `📅 ${t('scanDetails.freqLabel.yearly')}`}
                              {' '}{t('scanDetails.scheduleAt')} {s.time_of_day || '02:00'}
                            </div>
                            {s.next_run && !s.is_paused && (
                              <div className="text-xs text-cyan-400 mt-1">
                                {t('scanDetails.scheduleNext')}: {new Date(s.next_run).toLocaleDateString('fr-FR', {
                                  weekday: 'short',
                                  day: 'numeric',
                                  month: 'short',
                                  hour: '2-digit',
                                  minute: '2-digit'
                                })}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Empty State */}
                    {runningScans.length === 0 && existingSchedules.length === 0 && (
                      <div className="flex-1 flex flex-col items-center justify-center text-center py-8">
                        <CalendarOff className="w-12 h-12 text-gray-600 mb-3" />
                        <p className="text-sm text-gray-500">{t('scans.noActiveScan')}</p>
                        <p className="text-xs text-gray-600">{t('scanDetails.freeToSchedule')}</p>
                      </div>
                    )}
                  </div>
                )}

                {/* Warning if conflicts detected */}
                {existingSchedules.some(s =>
                  !s.is_paused &&
                  s.time_of_day === scheduleConfig.time_of_day &&
                  (s.frequency === scheduleConfig.frequency ||
                   (s.frequency === 'weekly' && scheduleConfig.frequency === 'weekly' &&
                    s.days_of_week?.some(d => (scheduleConfig.days_of_week || []).includes(d))))
                ) && (
                  <div className="mt-3 p-2 bg-yellow-500/10 border border-yellow-500/30 rounded-lg">
                    <div className="flex items-center gap-2">
                      <AlertTriangle className="w-4 h-4 text-yellow-500 flex-shrink-0" />
                      <span className="text-xs text-yellow-400">
                        A scan is already scheduled at this time
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Config Summary Modal */}
        {showConfigModal && scan && (
          <div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={() => setShowConfigModal(false)}
          >
            <div
              className="bg-brand-black-light rounded-2xl border border-orange-500/30 w-full max-w-2xl max-h-[90vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="p-6 border-b border-gray-800 flex items-center justify-between sticky top-0 bg-brand-black-light z-10">
                <h3 className="text-xl font-bold text-white flex items-center gap-2">
                  <Settings className="w-6 h-6 text-orange-400" />
                  {t('scanDetails.scanConfiguration')}
                </h3>
                <button
                  onClick={() => setShowConfigModal(false)}
                  className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                >
                  <X className="w-5 h-5 text-gray-400" />
                </button>
              </div>

              <div className="p-6 space-y-6">
                {/* Basic Info */}
                <div className="bg-brand-black rounded-xl p-4 border border-gray-800">
                  <h4 className="text-sm font-medium text-gray-400 mb-3 flex items-center gap-2">
                    <Target className="w-4 h-4" />
                    {t('scanDetails.generalInformation')}
                  </h4>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <span className="text-xs text-gray-500 block">{t('scanDetails.nameLabel')}</span>
                      <span className="text-white font-medium">{scan.config?.name || t('scanDetails.unnamed')}</span>
                    </div>
                    <div>
                      <span className="text-xs text-gray-500 block">{t('scanDetails.targetLabel')}</span>
                      <span className="text-orange-400 font-mono">{scan.target}</span>
                    </div>
                    <div>
                      <span className="text-xs text-gray-500 block">{t('scanDetails.scanTypeLabel')}</span>
                      <span className="text-white">{translateScanType(scan.scan_type)}</span>
                    </div>
                    <div>
                      <span className="text-xs text-gray-500 block">{t('scanDetails.networkMode')}</span>
                      <span className="text-white capitalize">{scan.config?.network_mode || 'direct'}</span>
                    </div>
                  </div>
                </div>

                {/* VPN Config */}
                {scan.config?.use_vpn && (
                  <div className="bg-brand-black rounded-xl p-4 border border-cyan-500/30">
                    <h4 className="text-sm font-medium text-cyan-400 mb-3 flex items-center gap-2">
                      <Lock className="w-4 h-4" />
                      {t('scanDetails.vpnConfiguration')}
                    </h4>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <span className="text-xs text-gray-500 block">{t('scanDetails.userLabel')}</span>
                        <span className="text-white">{scan.config?.vpn_username || 'N/A'}</span>
                      </div>
                      <div>
                        <span className="text-xs text-gray-500 block">{t('scanDetails.configurationLabel')}</span>
                        <span className="text-white text-sm">{scan.config?.vpn_config_id?.replace('int_', '').split('_').slice(1).join(' ') || 'N/A'}</span>
                      </div>
                    </div>
                  </div>
                )}

                {/* AI Settings */}
                <div className="bg-brand-black rounded-xl p-4 border border-purple-500/30">
                  <h4 className="text-sm font-medium text-purple-400 mb-3 flex items-center gap-2">
                    <Brain className="w-4 h-4" />
                    {t('scanDetails.artificialIntelligence')}
                  </h4>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <span className="text-xs text-gray-500 block">{t('scanDetails.aiModelLabel')}</span>
                      <span className="text-white">{scan.config?.ai_model || 'sylink'}</span>
                    </div>
                    <div>
                      <span className="text-xs text-gray-500 block">{t('scanDetails.analysisDepth')}</span>
                      <span className="text-white capitalize">{scan.config?.ai_depth || scan.config?.analysis_depth || 'standard'}</span>
                    </div>
                    <div>
                      <span className="text-xs text-gray-500 block">{t('scanDetails.assistanceMode')}</span>
                      <span className="text-white capitalize">{scan.config?.ai_assistance_mode || 'auto'}</span>
                    </div>
                    <div>
                      <span className="text-xs text-gray-500 block">{t('scanDetails.activeAiAnalysis')}</span>
                      <span className={scan.config?.ai_analysis ? 'text-green-400' : 'text-gray-500'}>
                        {scan.config?.ai_analysis ? t('common.yes') : t('common.no')}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Tools Enabled */}
                <div className="bg-brand-black rounded-xl p-4 border border-gray-800">
                  <h4 className="text-sm font-medium text-gray-400 mb-3 flex items-center gap-2">
                    <Terminal className="w-4 h-4" />
                    {t('scanDetails.enabledTools')}
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {scan.config?.nmap_enabled && (
                      <span className="px-2 py-1 bg-green-500/20 text-green-400 text-xs rounded border border-green-500/30">Nmap</span>
                    )}
                    {scan.config?.zap_enabled && (
                      <span className="px-2 py-1 bg-green-500/20 text-green-400 text-xs rounded border border-green-500/30">ZAP</span>
                    )}
                    {scan.config?.nikto_enabled && (
                      <span className="px-2 py-1 bg-green-500/20 text-green-400 text-xs rounded border border-green-500/30">Nikto</span>
                    )}
                    {scan.config?.nuclei_enabled && (
                      <span className="px-2 py-1 bg-green-500/20 text-green-400 text-xs rounded border border-green-500/30">Nuclei</span>
                    )}
                    {scan.config?.sqlmap_enabled && (
                      <span className="px-2 py-1 bg-green-500/20 text-green-400 text-xs rounded border border-green-500/30">SQLmap</span>
                    )}
                    {scan.config?.gobuster_enabled && (
                      <span className="px-2 py-1 bg-green-500/20 text-green-400 text-xs rounded border border-green-500/30">Gobuster</span>
                    )}
                    {scan.config?.openvas_enabled && (
                      <span className="px-2 py-1 bg-green-500/20 text-green-400 text-xs rounded border border-green-500/30">OpenVAS</span>
                    )}
                    {scan.config?.metasploit_enabled && (
                      <span className="px-2 py-1 bg-red-500/20 text-red-400 text-xs rounded border border-red-500/30">Metasploit</span>
                    )}
                    {scan.config?.exploitation_enabled && (
                      <span className="px-2 py-1 bg-red-500/20 text-red-400 text-xs rounded border border-red-500/30">Exploitation</span>
                    )}
                    {/* SploitScan - toujours actif pour l'enrichissement CVE */}
                    <span className="px-2 py-1 bg-purple-500/20 text-purple-400 text-xs rounded border border-purple-500/30 flex items-center gap-1">
                      <Bug className="w-3 h-3" />
                      SploitScan
                    </span>
                  </div>
                </div>

                {/* Security Options */}
                <div className="bg-brand-black rounded-xl p-4 border border-gray-800">
                  <h4 className="text-sm font-medium text-gray-400 mb-3 flex items-center gap-2">
                    <Shield className="w-4 h-4" />
                    {t('scanDetails.securityOptions')}
                  </h4>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="flex items-center gap-2">
                      <div className={`w-2 h-2 rounded-full ${scan.config?.safe_mode ? 'bg-green-400' : 'bg-gray-600'}`}></div>
                      <span className="text-sm text-gray-300">{t('scanDetails.safeMode')}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className={`w-2 h-2 rounded-full ${scan.config?.evasion_enabled ? 'bg-yellow-400' : 'bg-gray-600'}`}></div>
                      <span className="text-sm text-gray-300">{t('scanDetails.evasion')}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className={`w-2 h-2 rounded-full ${scan.config?.simulation_mode ? 'bg-blue-400' : 'bg-gray-600'}`}></div>
                      <span className="text-sm text-gray-300">{t('scanDetails.simulationMode')}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className={`w-2 h-2 rounded-full ${scan.config?.darkweb_search ? 'bg-purple-400' : 'bg-gray-600'}`}></div>
                      <span className="text-sm text-gray-300">{t('scanDetails.darkWebSearch')}</span>
                    </div>
                  </div>
                </div>

                {/* Severity Filter */}
                {scan.config?.severity_filter && scan.config.severity_filter.length > 0 && (
                  <div className="bg-brand-black rounded-xl p-4 border border-gray-800">
                    <h4 className="text-sm font-medium text-gray-400 mb-3 flex items-center gap-2">
                      <AlertTriangle className="w-4 h-4" />
                      {t('scanDetails.severityFilters')}
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {scan.config.severity_filter.map(severity => (
                        <span key={severity} className={`px-2 py-1 text-xs rounded border ${
                          severity === 'critical' ? 'bg-red-500/20 text-red-400 border-red-500/30' :
                          severity === 'high' ? 'bg-orange-500/20 text-orange-400 border-orange-500/30' :
                          severity === 'medium' ? 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30' :
                          'bg-blue-500/20 text-blue-400 border-blue-500/30'
                        }`}>
                          {severity.charAt(0).toUpperCase() + severity.slice(1)}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Public IP Attacks */}
                {scan.config?.public_ip_attacks?.enabled && (
                  <div className="bg-brand-black rounded-xl p-4 border border-red-500/30">
                    <h4 className="text-sm font-medium text-red-400 mb-3 flex items-center gap-2">
                      <Wifi className="w-4 h-4" />
                      Attaques IP publique
                    </h4>
                    <div className="grid grid-cols-2 gap-3">
                      <div className="flex items-center gap-2">
                        <div className={`w-2 h-2 rounded-full ${scan.config.public_ip_attacks.box_firewall ? 'bg-red-400' : 'bg-gray-600'}`}></div>
                        <span className="text-sm text-gray-300">Box/Firewall</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <div className={`w-2 h-2 rounded-full ${scan.config.public_ip_attacks.default_creds ? 'bg-red-400' : 'bg-gray-600'}`}></div>
                        <span className="text-sm text-gray-300">Default credentials</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <div className={`w-2 h-2 rounded-full ${scan.config.public_ip_attacks.firmware_vuln ? 'bg-red-400' : 'bg-gray-600'}`}></div>
                        <span className="text-sm text-gray-300">Firmware vulnerabilities</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <div className={`w-2 h-2 rounded-full ${scan.config.public_ip_attacks.management_interface ? 'bg-red-400' : 'bg-gray-600'}`}></div>
                        <span className="text-sm text-gray-300">Interface de gestion</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="p-4 border-t border-gray-800 flex justify-end">
                <button
                  onClick={() => setShowConfigModal(false)}
                  className="px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors"
                >
                  {t('common.close')}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Host Detail Modal - Accordion Design */}
        {selectedHost && (
          <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="bg-brand-black-light rounded-2xl border border-brand-green/30 w-full max-w-5xl max-h-[90vh] flex flex-col">
              {/* Header Compact */}
              <div className="p-4 border-b border-gray-800 flex items-center justify-between flex-shrink-0">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-brand-green/20 rounded-lg">
                    <Server className="w-5 h-5 text-brand-green" />
                  </div>
                  <div>
                    <h2 className="text-lg font-bold text-white font-mono">{selectedHost.ip_address}</h2>
                    {selectedHost.hostname && (
                      <p className="text-xs text-gray-400">{selectedHost.hostname}</p>
                    )}
                  </div>
                </div>
                {/* Risk Level Badge */}
                {hostAnalysis?.risk_level && (
                  <div className={`px-3 py-1.5 rounded-lg font-bold text-sm ${
                    hostAnalysis.risk_level === 'CRITICAL' ? 'bg-red-500/20 text-red-400 border border-red-500/50' :
                    hostAnalysis.risk_level === 'HIGH' ? 'bg-orange-500/20 text-orange-400 border border-orange-500/50' :
                    hostAnalysis.risk_level === 'MEDIUM' ? 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/50' :
                    'bg-green-500/20 text-green-400 border border-green-500/50'
                  }`}>
                    {safeRenderValue(hostAnalysis.risk_level)}
                  </div>
                )}
                <button
                  onClick={closeHostModal}
                  className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                >
                  <X className="w-5 h-5 text-gray-400" />
                </button>
              </div>

              {/* Stats Bar Compact */}
              {hostAnalysis && (
                <div className="px-4 py-3 border-b border-gray-800 bg-brand-black/50 flex-shrink-0">
                  <div className="flex items-center gap-4 flex-wrap">
                    {/* CVE Counts Inline */}
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-gray-500">CVE:</span>
                      <span className="px-2 py-0.5 rounded text-xs font-bold bg-gray-800 text-white">
                        {hostAnalysis.cve_summary?.total || hostAnalysis.vulnerability_count || 0}
                      </span>
                      <span className="px-2 py-0.5 rounded text-xs font-bold bg-red-500/20 text-red-400">
                        {hostAnalysis.cve_summary?.critical || hostAnalysis.critical_count || 0} C
                      </span>
                      <span className="px-2 py-0.5 rounded text-xs font-bold bg-orange-500/20 text-orange-400">
                        {hostAnalysis.cve_summary?.high || hostAnalysis.high_count || 0} H
                      </span>
                      <span className="px-2 py-0.5 rounded text-xs font-bold bg-yellow-500/20 text-yellow-400">
                        {hostAnalysis.cve_summary?.medium || hostAnalysis.medium_count || 0} M
                      </span>
                      <span className="px-2 py-0.5 rounded text-xs font-bold bg-blue-500/20 text-blue-400">
                        {hostAnalysis.cve_summary?.low || hostAnalysis.low_count || 0} L
                      </span>
                    </div>
                    <div className="w-px h-4 bg-gray-700" />
                    {/* OS */}
                    <div className="flex items-center gap-1.5">
                      {(() => {
                        const osData = getOSIcon(hostAnalysis.os_name);
                        const OSIconComponent = osData.icon;
                        return <OSIconComponent className={`w-4 h-4 ${osData.color}`} />;
                      })()}
                      <span className="text-xs text-gray-300">{hostAnalysis.os_name || 'N/A'}</span>
                    </div>
                    <div className="w-px h-4 bg-gray-700" />
                    {/* Ports */}
                    <div className="flex items-center gap-1.5">
                      <span className="text-xs text-gray-500">Ports:</span>
                      <span className="text-xs text-white font-medium">{hostAnalysis.open_ports || 0}</span>
                    </div>
                    <div className="w-px h-4 bg-gray-700" />
                    {/* Status */}
                    <div className="flex items-center gap-1.5">
                      <div className={`w-2 h-2 rounded-full ${hostAnalysis.status === 'up' ? 'bg-green-500' : 'bg-gray-500'}`}></div>
                      <span className="text-xs text-gray-300">{hostAnalysis.status === 'up' ? 'En ligne' : 'Hors ligne'}</span>
                    </div>
                    {/* Services Tags */}
                    {hostAnalysis.services && hostAnalysis.services.length > 0 && (
                      <>
                        <div className="w-px h-4 bg-gray-700" />
                        <div className="flex items-center gap-1 flex-wrap">
                          {hostAnalysis.services.slice(0, 5).map((service, idx) => (
                            <span key={idx} className="px-1.5 py-0.5 bg-brand-green/10 rounded text-xs text-brand-green border border-brand-green/20">
                              {service.port}
                            </span>
                          ))}
                          {hostAnalysis.services.length > 5 && (
                            <span className="text-xs text-gray-500">+{hostAnalysis.services.length - 5}</span>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}

              {/* Content - Accordion Sections */}
              <div className="flex-1 overflow-y-auto">
                {loadingHostAnalysis ? (
                  <div className="flex flex-col items-center justify-center py-12">
                    <div className="w-12 h-12 border-4 border-brand-green/30 border-t-brand-green rounded-full animate-spin mb-4"></div>
                    <p className="text-gray-400">Analyse IA en cours...</p>
                  </div>
                ) : hostAnalysis ? (
                  <div className="divide-y divide-gray-800">
                    {/* Accordion: Analyse IA */}
                    <div>
                      <button
                        onClick={() => toggleHostAccordion('aiAnalysis')}
                        className="w-full px-4 py-3 flex items-center justify-between hover:bg-brand-black/30 transition-colors"
                      >
                        <div className="flex items-center gap-2">
                          <Brain className="w-5 h-5 text-brand-green" />
                          <span className="font-semibold text-brand-green">{t('scans.details.aiRiskAnalysis')}</span>
                          {hostAnalysis.impact && (
                            <span className="px-2 py-0.5 rounded text-xs bg-red-500/20 text-red-400 border border-red-500/30">
                              Impact identified
                            </span>
                          )}
                        </div>
                        <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform ${hostAccordion.aiAnalysis ? 'rotate-180' : ''}`} />
                      </button>
                      {hostAccordion.aiAnalysis && (
                        <div className="px-4 pb-4">
                          <div className="bg-gradient-to-br from-brand-green/5 to-cyan-500/5 rounded-lg p-4 border border-brand-green/20">
                            <MarkdownRenderer content={hostAnalysis.ai_analysis} variant="compact" />
                            {hostAnalysis.impact && (
                              <div className="mt-3 p-3 bg-red-500/10 rounded-lg border border-red-500/30">
                                <div className="flex items-center gap-2 mb-1">
                                  <AlertTriangle className="w-4 h-4 text-red-400" />
                                  <span className="text-sm font-semibold text-red-400">Potential impact</span>
                                </div>
                                <p className="text-sm text-gray-300">{safeRenderValue(hostAnalysis.impact)}</p>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Accordion: Attack scenario */}
                    {hostAnalysis.attack_path && hostAnalysis.attack_path.length > 0 && (
                      <div>
                        <button
                          onClick={() => toggleHostAccordion('attackPath')}
                          className="w-full px-4 py-3 flex items-center justify-between hover:bg-brand-black/30 transition-colors"
                        >
                          <div className="flex items-center gap-2">
                            <Target className="w-5 h-5 text-purple-400" />
                            <span className="font-semibold text-purple-400">Attack scenario</span>
                            <span className="px-2 py-0.5 rounded text-xs bg-purple-500/20 text-purple-300">
                              {hostAnalysis.attack_path.length} steps
                            </span>
                          </div>
                          <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform ${hostAccordion.attackPath ? 'rotate-180' : ''}`} />
                        </button>
                        {hostAccordion.attackPath && (
                          <div className="px-4 pb-4">
                            <div className="relative pl-4">
                              <div className="absolute left-6 top-4 bottom-4 w-0.5 bg-gradient-to-b from-purple-500 via-orange-500 to-red-500"></div>
                              <div className="space-y-3">
                                {hostAnalysis.attack_path.map((step, idx) => (
                                  <div key={idx} className="flex items-start gap-3 relative">
                                    <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold z-10 flex-shrink-0 ${
                                      idx === 0 ? 'bg-purple-500 text-white' :
                                      idx === hostAnalysis.attack_path.length - 1 ? 'bg-red-500 text-white' :
                                      'bg-orange-500 text-white'
                                    }`}>
                                      {safeRenderValue(step.step)}
                                    </div>
                                    <div className="flex-1 bg-brand-black rounded-lg p-2.5 border border-gray-700">
                                      <p className="text-white text-sm">{safeRenderValue(step.action)}</p>
                                      <span className="text-xs px-2 py-0.5 rounded bg-purple-500/20 text-purple-300 border border-purple-500/30 inline-block mt-1.5">
                                        {safeRenderValue(step.technique)}
                                      </span>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Accordion: Actions prioritaires */}
                    {hostAnalysis.priority_actions && hostAnalysis.priority_actions.length > 0 && (
                      <div>
                        <button
                          onClick={() => toggleHostAccordion('priorityActions')}
                          className="w-full px-4 py-3 flex items-center justify-between hover:bg-brand-black/30 transition-colors"
                        >
                          <div className="flex items-center gap-2">
                            <Shield className="w-5 h-5 text-brand-green" />
                            <span className="font-semibold text-brand-green">Priority actions</span>
                            <span className="px-2 py-0.5 rounded text-xs bg-brand-green/20 text-brand-green">
                              {hostAnalysis.priority_actions.length}
                            </span>
                          </div>
                          <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform ${hostAccordion.priorityActions ? 'rotate-180' : ''}`} />
                        </button>
                        {hostAccordion.priorityActions && (
                          <div className="px-4 pb-4">
                            <div className="space-y-2">
                              {hostAnalysis.priority_actions.map((action, idx) => (
                                <div key={idx} className="flex items-center gap-3 p-2.5 bg-brand-black rounded-lg border border-gray-700">
                                  <div className="w-5 h-5 rounded-full bg-brand-green/20 flex items-center justify-center text-brand-green text-xs font-bold flex-shrink-0">
                                    {idx + 1}
                                  </div>
                                  <span className="text-white text-sm">{safeRenderValue(action)}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Accordion: Vulnerabilities */}
                    {(hostAnalysis.vulnerabilities?.length > 0 || hostAnalysis.host_vulnerabilities?.length > 0 || (hostAnalysis.cve_ids && hostAnalysis.cve_ids.length > 0)) && (
                      <div>
                        <button
                          onClick={() => toggleHostAccordion('vulnerabilities')}
                          className="w-full px-4 py-3 flex items-center justify-between hover:bg-brand-black/30 transition-colors"
                        >
                          <div className="flex items-center gap-2">
                            <AlertTriangle className="w-5 h-5 text-orange-400" />
                            <span className="font-semibold text-orange-400">{t('scanDetails.detailedVulnerabilities')}</span>
                            <span className="px-2 py-0.5 rounded text-xs bg-orange-500/20 text-orange-400">
                              {(hostAnalysis.vulnerabilities || hostAnalysis.host_vulnerabilities || hostAnalysis.cve_ids || []).length}
                            </span>
                          </div>
                          <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform ${hostAccordion.vulnerabilities ? 'rotate-180' : ''}`} />
                        </button>
                        {hostAccordion.vulnerabilities && (
                          <div className="px-4 pb-4">
                            {/* CVE IDs */}
                            {hostAnalysis.cve_ids && hostAnalysis.cve_ids.length > 0 && (
                              <div className="mb-3">
                                <h5 className="text-xs text-gray-500 uppercase mb-2">{t('scanDetails.identifiedCves')}</h5>
                                <div className="flex flex-wrap gap-1.5">
                                  {hostAnalysis.cve_ids.map((cveId, idx) => (
                                    <a
                                      key={idx}
                                      href={`https://nvd.nist.gov/vuln/detail/${safeRenderValue(cveId)}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="px-2 py-1 bg-brand-black rounded text-xs text-brand-green border border-brand-green/30 hover:bg-brand-green/20 transition-colors"
                                    >
                                      {safeRenderValue(cveId)}
                                    </a>
                                  ))}
                                </div>
                              </div>
                            )}
                            {/* Vulnerabilities List */}
                            {(hostAnalysis.vulnerabilities?.length > 0 || hostAnalysis.host_vulnerabilities?.length > 0) && (
                              <div className="space-y-1.5">
                                {(hostAnalysis.vulnerabilities || hostAnalysis.host_vulnerabilities).map((vuln, idx) => (
                                  <div key={idx} className="flex items-center justify-between p-2.5 bg-brand-black rounded border border-gray-700">
                                    <div className="flex-1 min-w-0">
                                      <span className="text-sm text-white block truncate">{safeRenderValue(vuln.title || vuln.name)}</span>
                                      {vuln.cve_id && (
                                        <span className="text-xs text-brand-green">{safeRenderValue(vuln.cve_id)}</span>
                                      )}
                                    </div>
                                    <div className="flex items-center gap-2 ml-3 flex-shrink-0">
                                      {vuln.cvss_score && (
                                        <span className="text-xs text-gray-400">CVSS: {vuln.cvss_score}</span>
                                      )}
                                      <span className={`text-xs px-2 py-0.5 rounded font-medium ${
                                        vuln.severity === 'critical' ? 'bg-red-500/20 text-red-400' :
                                        vuln.severity === 'high' ? 'bg-orange-500/20 text-orange-400' :
                                        vuln.severity === 'medium' ? 'bg-yellow-500/20 text-yellow-400' :
                                        'bg-blue-500/20 text-blue-400'
                                      }`}>
                                        {vuln.severity?.toUpperCase()}
                                      </span>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Accordion: Recommandations */}
                    {hostAnalysis.recommendations && hostAnalysis.recommendations.length > 0 && (
                      <div>
                        <button
                          onClick={() => toggleHostAccordion('recommendations')}
                          className="w-full px-4 py-3 flex items-center justify-between hover:bg-brand-black/30 transition-colors"
                        >
                          <div className="flex items-center gap-2">
                            <Shield className="w-5 h-5 text-cyan-400" />
                            <span className="font-semibold text-cyan-400">{t('scanDetails.remediationRecommendations')}</span>
                            <span className="px-2 py-0.5 rounded text-xs bg-cyan-500/20 text-cyan-400">
                              {hostAnalysis.recommendations.length}
                            </span>
                          </div>
                          <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform ${hostAccordion.recommendations ? 'rotate-180' : ''}`} />
                        </button>
                        {hostAccordion.recommendations && (
                          <div className="px-4 pb-4">
                            <div className="space-y-2">
                              {hostAnalysis.recommendations.map((rec, idx) => (
                                <div key={idx} className={`flex items-start gap-3 p-3 rounded-lg border ${
                                  rec.priority === 'critical' ? 'bg-red-500/10 border-red-500/30' :
                                  rec.priority === 'high' ? 'bg-orange-500/10 border-orange-500/30' :
                                  'bg-gray-800/50 border-gray-700'
                                }`}>
                                  <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${
                                    rec.priority === 'critical' ? 'bg-red-500/20 text-red-400' :
                                    rec.priority === 'high' ? 'bg-orange-500/20 text-orange-400' :
                                    'bg-brand-green/20 text-brand-green'
                                  }`}>
                                    {idx + 1}
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <h4 className="text-white font-semibold text-sm">{rec.title}</h4>
                                    <p className="text-gray-400 text-xs mt-0.5">{rec.description}</p>
                                  </div>
                                  <span className={`px-2 py-0.5 rounded text-xs font-bold flex-shrink-0 ${
                                    rec.priority === 'critical' ? 'bg-red-500/20 text-red-400' :
                                    rec.priority === 'high' ? 'bg-orange-500/20 text-orange-400' :
                                    'bg-yellow-500/20 text-yellow-400'
                                  }`}>
                                    {rec.priority === 'critical' ? t('scanDetails.recPriorityUrgent') : rec.priority === 'high' ? t('scanDetails.recPriorityPriority') : t('scanDetails.recPriorityRecommended')}
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Additional Info - Always visible at bottom */}
                    {(hostAnalysis.vendor || hostAnalysis.device_type || hostAnalysis.mac_address) && (
                      <div className="px-4 py-3 bg-brand-black/30">
                        <div className="flex items-center gap-6 text-xs">
                          {hostAnalysis.vendor && (
                            <div>
                              <span className="text-gray-500">Vendor:</span>
                              <span className="text-white ml-1">{safeRenderValue(hostAnalysis.vendor)}</span>
                            </div>
                          )}
                          {hostAnalysis.device_type && (
                            <div>
                              <span className="text-gray-500">Type:</span>
                              <span className="text-white ml-1">{safeRenderValue(hostAnalysis.device_type)}</span>
                            </div>
                          )}
                          {hostAnalysis.mac_address && (
                            <div>
                              <span className="text-gray-500">MAC:</span>
                              <span className="text-white font-mono ml-1">{safeRenderValue(hostAnalysis.mac_address)}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="text-center py-12 text-gray-400">
                    {t('scans.noData')}
                  </div>
                )}
              </div>

              {/* Footer Compact */}
              <div className="p-3 border-t border-gray-800 flex justify-end flex-shrink-0">
                <button
                  onClick={closeHostModal}
                  className="px-4 py-2 bg-brand-green/20 text-brand-green rounded-lg hover:bg-brand-green/30 transition-colors text-sm"
                >
                  {t('common.close')}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Cleanup Modal */}
        {showCleanupModal && (
          <div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={() => setShowCleanupModal(false)}
          >
            <div
              className="bg-brand-black-light rounded-2xl border border-purple-500/30 w-full max-w-lg"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="p-6 border-b border-gray-800 flex items-center justify-between">
                <h3 className="text-xl font-bold text-white flex items-center gap-2">
                  <svg className="w-6 h-6 text-purple-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 3h6l1 7H8L9 3z" />
                    <path d="M8 10h8l-1 11H9L8 10z" />
                    <path d="M12 3v4" />
                    <path d="M10 14l1 5" />
                    <path d="M14 14l-1 5" />
                  </svg>
                  {t('scans.cleanupTitle') || 'Nettoyage post-pentest'}
                </h3>
                <button
                  onClick={() => setShowCleanupModal(false)}
                  className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                >
                  <X className="w-5 h-5 text-gray-400" />
                </button>
              </div>

              <div className="p-6 space-y-4">
                {cleanupResult ? (
                  // Show cleanup results
                  <div className="space-y-4">
                    <div className={`p-4 rounded-xl ${cleanupResult.success ? 'bg-green-500/10 border border-green-500/30' : 'bg-red-500/10 border border-red-500/30'}`}>
                      <div className="flex items-center gap-3 mb-3">
                        {cleanupResult.success ? (
                          <CheckCircle className="w-6 h-6 text-green-400" />
                        ) : (
                          <XCircle className="w-6 h-6 text-red-400" />
                        )}
                        <span className={`font-semibold ${cleanupResult.success ? 'text-green-400' : 'text-red-400'}`}>
                          {cleanupResult.success ? (t('scans.cleanupSuccess') || 'Cleanup completed successfully') : (t('scans.cleanupPartial') || 'Partial cleanup')}
                        </span>
                      </div>

                      <div className="grid grid-cols-2 gap-3 text-sm">
                        <div className="bg-brand-black/50 rounded-lg p-3">
                          <span className="text-gray-400 block text-xs">{t('scans.sessionsClosed') || 'Sessions closed'}</span>
                          <span className="text-white font-medium text-lg">{cleanupResult.sessions_closed || 0}</span>
                        </div>
                        <div className="bg-brand-black/50 rounded-lg p-3">
                          <span className="text-gray-400 block text-xs">{t('scans.persistenceRemoved') || 'Persistence removed'}</span>
                          <span className="text-white font-medium text-lg">{cleanupResult.persistence_removed || 0}</span>
                        </div>
                        <div className="bg-brand-black/50 rounded-lg p-3">
                          <span className="text-gray-400 block text-xs">{t('scans.filesCleaned') || 'Files cleaned'}</span>
                          <span className="text-white font-medium text-lg">{cleanupResult.files_cleaned || 0}</span>
                        </div>
                        <div className="bg-brand-black/50 rounded-lg p-3">
                          <span className="text-gray-400 block text-xs">{t('scans.aptLogsCleaned') || 'APT logs cleaned'}</span>
                          <span className="text-white font-medium text-lg">{cleanupResult.apt_executions_cleaned || 0}</span>
                        </div>
                      </div>

                      {cleanupResult.archive_path && (
                        <div className="mt-3 p-2 bg-brand-black/50 rounded-lg flex items-center gap-2">
                          <FileText className="w-4 h-4 text-cyan-400" />
                          <span className="text-sm text-gray-300">{t('scans.evidenceArchived') || 'Evidence archived'}: {cleanupResult.archive_path}</span>
                        </div>
                      )}
                    </div>

                    <button
                      onClick={() => {
                        setCleanupResult(null);
                        setShowCleanupModal(false);
                      }}
                      className="w-full px-4 py-3 bg-brand-green text-black rounded-lg font-medium hover:bg-brand-green/90 transition-colors"
                    >
                      {t('common.close')}
                    </button>
                  </div>
                ) : (
                  // Show preview and confirmation
                  <>
                    <div className="bg-purple-500/10 border border-purple-500/30 rounded-xl p-4">
                      <p className="text-gray-300 text-sm mb-3">
                        {t('scans.cleanupDescription') || 'This action will remove all traces left by the pentest, including:'}
                      </p>
                      <ul className="space-y-2 text-sm text-gray-400">
                        <li className="flex items-center gap-2">
                          <Terminal className="w-4 h-4 text-purple-400" />
                          {t('scans.cleanupSessions') || 'Active exploitation sessions'}
                        </li>
                        <li className="flex items-center gap-2">
                          <Lock className="w-4 h-4 text-purple-400" />
                          {t('scans.cleanupPersistence') || 'Installed persistence mechanisms'}
                        </li>
                        <li className="flex items-center gap-2">
                          <FileText className="w-4 h-4 text-purple-400" />
                          {t('scans.cleanupFiles') || 'Temporary files and evidence'}
                        </li>
                        <li className="flex items-center gap-2">
                          <Activity className="w-4 h-4 text-purple-400" />
                          {t('scans.cleanupLogs') || 'APT execution logs'}
                        </li>
                      </ul>
                    </div>

                    {cleanupPreview && (
                      <div className="bg-brand-black rounded-xl p-4 border border-gray-700">
                        <h4 className="text-sm font-medium text-white mb-3">{t('scans.cleanupPreview') || 'Cleanup preview'}</h4>
                        <div className="grid grid-cols-2 gap-2 text-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-400">{t('scans.sessionsCount') || 'Sessions'}:</span>
                            <span className="text-white">{cleanupPreview.sessions?.total || 0}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-400">{t('scans.withPersistence') || 'With persistence'}:</span>
                            <span className="text-orange-400">{cleanupPreview.sessions?.with_persistence || 0}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-400">{t('scans.aptExecutions') || 'APT executions'}:</span>
                            <span className="text-white">{cleanupPreview.apt_executions || 0}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-400">{t('scans.evidenceFiles') || 'Evidence files'}:</span>
                            <span className="text-white">{cleanupPreview.evidence_files || 0}</span>
                          </div>
                          {cleanupPreview.evidence_size_mb > 0 && (
                            <div className="flex justify-between col-span-2">
                              <span className="text-gray-400">{t('scans.evidenceSize') || 'Evidence size'}:</span>
                              <span className="text-white">{cleanupPreview.evidence_size_mb} MB</span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    <div className="flex gap-3">
                      <button
                        onClick={() => handleCleanup(false)}
                        disabled={isCleaning}
                        className="flex-1 px-4 py-3 bg-purple-500 text-white rounded-lg font-medium hover:bg-purple-600 transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
                      >
                        {isCleaning ? (
                          <>
                            <RefreshCcw className="w-4 h-4 animate-spin" />
                            {t('scans.cleaning') || 'Nettoyage...'}
                          </>
                        ) : (
                          <>
                            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M9 3h6l1 7H8L9 3z" />
                              <path d="M8 10h8l-1 11H9L8 10z" />
                            </svg>
                            {t('scans.cleanNow') || 'Nettoyer maintenant'}
                          </>
                        )}
                      </button>
                      <button
                        onClick={() => handleCleanup(true)}
                        disabled={isCleaning}
                        className="px-4 py-3 bg-cyan-500/20 text-cyan-400 border border-cyan-500/50 rounded-lg font-medium hover:bg-cyan-500/30 transition-colors disabled:opacity-50"
                        title={t('scans.archiveAndClean') || 'Archiver puis nettoyer'}
                      >
                        <Download className="w-4 h-4" />
                      </button>
                    </div>

                    <p className="text-xs text-gray-500 text-center">
                      {t('scans.cleanupWarning') || '⚠️ This action is irreversible. Make sure you have saved important data.'}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScanDetails;
